export default {
  translation: {
    Automation_flow_templates: "قالب‌های فلو",
    Automation_ai_templates: "قالب‌های هوش مصنوعی",
    Automation_sample: "نمونه",
    Automation_sample_notice: "می‌توانید از قالب‌های از پیش ساخته‌شده استفاده کنید و آن‌ها را تغییر دهید",
    Automation_template_number: "قالب شماره {{number}}",
    Automation_beginner: "مبتدی",
    Automation_intermediate: "متوسط",
    Automation_advanced: "پیشرفته",
    Automation_trending: "پرطرفدار",
    Automation_sample_cart: "بازیابی سبد خرید فروشگاه",
    Automation_sample_cart_description:
      "ایده نمونه: به خریداران کمک کنید به سبد خرید برگردند و پاسخ پرسش‌هایشان را بگیرند.",
    Automation_sample_language: "گفت‌وگوی چندزبانه",
    Automation_sample_language_description: "ایده نمونه: مخاطب را به گفت‌وگو با زبان دلخواهش راهنمایی کنید.",
    Automation_sample_support: "دستیار پشتیبانی مشتری",
    Automation_sample_support_description:
      "ایده نمونه: به پرسش‌های پرتکرار پاسخ دهید و مشتری را به مرحله بعد راهنمایی کنید.",
    Automation_sample_welcome: "خوشامدگویی به مشتریان جدید",
    Automation_sample_welcome_description:
      "ایده نمونه: به مخاطب جدید خوشامد بگویید و محصولات و خدماتتان را معرفی کنید.",
    Automation_flow_history: "فلوهای من",
    Automation_ai_history: "دستورهای هوش مصنوعی من",
    Automation_loaded_count: "تعداد موارد بارگذاری‌شده؛ علامت + یعنی موارد بیشتری وجود دارد.",
    Automation_sort_newest: " جدیدترین",
    Automation_sort_oldest: " قدیمی‌ترین",
    Automation_sort_title: " بر اساس نام",
    Automation_connected_posts: "پست‌های متصل",
    Automation_not_connected: "به هیچ پستی متصل نشده است.",
    Automation_connections_access: "برای دیدن اتصال‌ها، دسترسی کامنت و مجوز بخش‌های خودکارسازی و کامنت لازم است.",
    Automation_checking_connections: "در حال بررسی اتصال به پست‌ها…",
    Automation_connections_retry: "بررسی همه اتصال‌ها انجام نشد؛ دوباره تلاش کنید.",
    aiSuggestedPrompts_title: "پرامپت‌های پیشنهادی",
    aiSuggestedPrompts_openImage: "باز کردن تصویر به‌صورت تمام‌صفحه",
    aiSuggestedPrompts_explain: "یک پرامپت را برای شروع انتخاب کنید.",
    aiSuggestedPrompts_category: "دسته‌بندی پرامپت",
    aiSuggestedPrompts_subCategory: "زیردسته‌بندی",
    aiSuggestedPrompts_allCategories: "همه دسته‌بندی‌ها",
    aiSuggestedPrompts_loading: "در حال بارگذاری...",
    aiSuggestedPrompts_empty: "پرامپت پیشنهادی یافت نشد.",
    aiSuggestedPrompts_loadMore: "نمایش بیشتر",
    aiSuggestedPrompts_prompt: "پرامپت",
    aiSuggestedPrompts_copy: "کپی پرامپت",
    aiSuggestedPrompts_showMore: "نمایش ادامه",
    aiSuggestedPrompts_showLess: "نمایش کمتر",
    // #region landing page
    toggleShowAll: "نمایش همه",
    toggleShowmonthly: "نمایش ماهانه",
    usethisPrompt: "استفاده در پرامپت",
    AudienceTooltip:
      "برای سنجش دقیق‌تر تعامل فعلی، آمار بر اساس عملکرد ۳۰ روز اخیر نمایش داده می‌شود؛ آمار اینستاگرام بر مبنای کل دوره فعالیت پیج است و ممکن است با این داده‌ها متفاوت باشد",
    unpin: "لغو پین",
    pin: "پین کردن",
    Nodetutorial: "توضیح بلوک",
    Dublicate: "تکثیر",
    zoomout: "کوچک‌نمایی",
    fitscreen: "تناسب صفحه",
    zoomin: "بزرگ‌نمایی",
    shortcuts: "میانبرها",
    Workflow_Statistics: "آمار جریان کاری",
    Nodes: "نودها",
    Connections: "اتصالات",
    Last_Auto_saved: "آخرین ذخیره خودکار",
    Canvas_Behavior: "رفتار بوم (Canvas)",
    Canvas_Behavior_explain: "تنظیم گرید و محدوده حرکت برای کنترل بهتر",
    Data_Management: "مدیریت داده",
    exportJSON: "خروجی JSON",
    importJSON: "ورودی JSON",
    importJSON_success: "فایل با موفقیت وارد شد",
    importJSON_error: "خطا در بارگذاری فایل",
    History_saved: "سوابق ذخیره‌شده",
    Data_Management_explain:
      "می‌توانید جریان کاری خود را ذخیره کنید و در صورت نیاز، جریان‌های کاری را از سایر پلتفرم‌ها وارد نمایید.",
    flow_shortcuts_explain: "میانبرهای صفحه‌کلید برای افزایش سرعت و تسلط در مدیریت جریان‌های کاری.",

    quantity: "عدد",
    allquantity: "تعداد کل",
    remainingquantity: "عدد باقیمانده",
    Connecting: "در حال اتصال",
    Connected: "متصل",
    EmailNotification: "اعلان‌های ایمیل",
    EmailNotificationExplain: "اعلان‌های سیستم به این آدرس ایمیل ارسال می‌شوند.",
    MobileNotification: "اعلان‌های موبایل",
    MobileNotificationExplain: "اعلان‌های سیستم به این شماره موبایل ارسال می‌شوند.",
    Responded: "پاسخ داده شده",
    notimelimit: "بدون محدودیت زمانی ",
    loading: "...در حال بارگذاری",
    Beginner: "مبتدی",
    Basic: "پایه",
    Growing: "در حال رشد",
    Advanced: "پیشرفته",
    Professional: "حرفه‌ای",
    Special: "ویژه",
    Unavailable: "غیرفعال",
    menu: "منو",
    level: "سطح",
    bestposts: "بهترین پست‌ها",
    upgradeyouraccount: "حساب خود را ارتقاء دهید",
    featureNotAvailable: "این ویژگی در دسترس نیست",
    featureNotAvailableDesc: "برای استفاده از این امکان، حساب خود را ارتقا دهید.",
    likeaprouser: "یک کسب‌وکار واقعی راه‌اندازی کنید",
    followerrate: "نرخ رشد فالور",
    usersettingexplain: "اطلاعات حساب اینستاگرام فقط در خود اینستاگرام تغییر می‌کند و اینجا خودکار به‌روزرسانی می‌شود.",

    shoppertitle: "همه‌چیز آماده فروش است👌",
    advertisertitle: "همه‌چیز آماده تبلیغات است👌",
    shopperdescription: "عملکرد فروش را به‌صورت دقیق دنبال کنید.",
    advertiserdescription: "عملکرد تبلیغات را به‌صورت دقیق دنبال کنید.",
    syncingAccountTitle: "در حال دریافت اطلاعات",
    syncingAccountDescription: "اطلاعات اینستاگرام شما در برنسی در حال به‌روزرسانی است",
    syncingAccountDescriptiontooltip: "برخی از اطلاعات شما تا ۲۴ ساعت آینده به‌روزرسانی خواهند شد.",
    subscriptionExpiringTitle: "اشتراک شما رو به پایان است",
    subscriptionExpiringDescription: "برای ادامه استفاده از امکانات، اشتراک خود را تمدید کنید.",
    subscriptionDaysRemaining: "{{days}} روز باقی‌مانده",

    daysAgo: "روز پیش",
    hoursAgo: "ساعت پیش",
    minutesAgo: "دقیقه پیش",
    justNow: "همین الان",
    unselect: "لغو انتخاب",
    shopper: "فروشنده",
    onlinestore: "فروشگاه آنلاین",
    onlinestoreExplain: "همه چیزهایی که برای فروش بیشتر نیاز دارید، در یک مکان.",
    influencerExplain: "تمام ابزارهای تبلیغ‌کنندگان و اینفلوئنسرها به صورت حرفه‌ای",
    advertiser: "تبلیغ‌کننده",
    influencer: "اینفلوئنسر",
    skip: "رد کردن",
    skipfornow: "فعلاً رد کن",
    freedays: "۴۰ روز",
    freedaysExplain:
      "اگر یک پیج اینستاگرام فعال دارید و در حال رشد هستید، این پلن مخصوص شما طراحی شده. دسترسی کامل به امکانات ابزارها، آمارگیری، مدیریت محتوا، پیام‌ها و کامنت‌ها و ساخت ادمین همکار در برنسی برایتان فعال است.",
    instagramerplanactive: "پلن اینستاگرامی شما فعال است",
    influencerplanactive: "پلن اینفلوئنسر شما فعال است",
    onlinestoreplanactive: "پلن فروشگاه آنلاین شما فعال است",

    SwitchtoUserpanel: "ورود به عنوان کاربر",
    chooselanguage: "انتخاب زبان",
    chooselanguageExplain: "زبان مورد نظر خود را انتخاب کنید",
    chooseTheme: "انتخاب تم",
    chooseThemeExplain: "تم مورد علاقه خود را انتخاب کنید",
    chooseCalendar: "انتخاب تقویم",
    chooseCalendarExplain: "نوع تقویم مورد نظر خود را انتخاب کنید",
    setupchooseexplain: "این تنظیمات بعداً در قسمت ستینگ قابل تغییر و عوض شدن هستند",

    Lottery: "قرعه‌کشی",
    services: "امکانات",
    markets: "پلتفرم‌ها",
    pricing: "قیمت‌گذاری",
    page1_text1: "مدیریت کسب‌وکار اینستاگرام",
    page1_text2: "با نسل جدید",
    page1_StartNow: "شروعی رایگان با دسترسی به ابزارهای حرفه‌ای",
    page1_services: "سرویس‌ها",
    page1_analytics: "تحلیل‌ها",
    page1_transportation: "حمل و نقل",
    page1_financial_solutions: "راهکارهای مالی",
    page1_customer_communication: "ارتباط با مشتریان",
    page1_content_management: "مدیریت محتوا",
    page1_artificial_intelligence: "هوش مصنوعی",
    page1_tools: "ابزارها",
    page1_advertises: "مدیریت تبلیغات",
    page2_text1: "کامل‌ترین راهکارها و خدمات  کسب‌وکار",
    page2_text2:
      "برنسی یک ابزار قدرتمند برای مدیریت اکانت اینستاگرام شماست و ابزارهای لازم برای موفقیت را در اختیارتان قرار می‌دهد.",
    page2_ads_statistics_title: "آمارگیری",
    page2_ads_statistics_description: "ابزار پیشرفته تحلیل عملکرد",
    page2_ads_statistics_servicedescription:
      "با این ابزار دقیق و لحظه‌ای، همه شاخص‌های کلیدی تبلیغات پیج خود را مشاهده و کمپین‌ها را بهینه کنید.",
    page2_ads_calendar_title: "تقویم کاری",
    page2_ads_calendar_description: "کارآمدترین مدیریت تبلیغات",
    page2_ads_calendar_servicedescription:
      "تبلیغات پذیرفته‌شده و پیشنهادی هوش مصنوعی را در تقویم هوشمند مدیریت و برنامه‌ریزی سریع و بدون خطا داشته باشید.",
    page2_ads_adlist_title: "لیست تبلیغات",
    page2_ads_adlist_description: "نمایش صف تبلیغات در انتظار تایید",
    page2_ads_adlist_servicedescription:
      "لیست شفاف و دسته‌بندی‌شده تبلیغات منتظر تایید را ببینید و با یک کلیک تایید یا رد کنید؛ مدیریت آسان و حرفه‌ای.",
    page2_store_addproduct_title: "افزودن محصول",
    page2_store_addproduct_description: "شناسایی همه محصولات از پیج",
    page2_store_addproduct_servicedescription:
      "سیستم هوشمند ما تمام محصولات پست‌های پیج شما را شناسایی و خودکار آماده افزودن می‌کند. سرعت را افزایش و خطا را کم می‌کند.",
    page2_store_productlist_title: "لیست محصولات",
    page2_store_productlist_description: "مدیریت انبار و محصولات",
    page2_store_productlist_servicedescription:
      "محصولات و موجودی را به‌صورت حرفه‌ای، دقیق و بدون دغدغه مدیریت کنید. همه‌چیز هوشمند و با گزارش کامل در دسترس است.",
    page2_store_orders_title: "سفارشات",
    page2_store_orders_description: "مدیریت سفارش، فاکتور و ارسال",
    page2_store_orders_servicedescription:
      "تمام مراحل سفارش، از ثبت تا فاکتور و ارسال با کد رهگیری، به صورت خودکار و دقیق انجام می‌شود. تجربه‌ای سریع و بی‌نقص برای مشتریان.",
    page2_store_statistics_title: "آمارگیری",
    page2_store_statistics_description: "ابزار پیشرفته تحلیل عملکرد",
    page2_store_statistics_servicedescription:
      "با آمارگیری پیشرفته فروش، درآمد و روند رشد فروشگاه را بررسی و با تحلیل دقیق، تصمیم‌های هوشمندانه بگیرید.",
    page2_delivery_smartshipping_title: "هزینه ارسال هوشمند",
    page2_delivery_smartshipping_description: "هزینه بر اساس مبدا، مقصد، ابعاد و وزن",
    page2_delivery_smartshipping_servicedescription:
      "محاسبه دقیق و خودکار هزینه ارسال با توجه به مبدا، مقصد، اندازه و وزن مرسوله، بدون خطای انسانی.",
    page2_delivery_postalservice_title: "خدمات پستی",
    page2_delivery_postalservice_description: "جمع‌آوری و ارسال مرسوله",
    page2_delivery_postalservice_servicedescription:
      "مرسولات به‌صورت هوشمند از فروشگاه جمع‌آوری و بدون نیاز به پیگیری دستی به مقصد ارسال می‌شوند. تجربه‌ای سریع و منظم در لجستیک.",
    page2_delivery_tracking_title: "رهگیری مرسوله",
    page2_delivery_tracking_description: "نمایش و رهگیری خودکار مرسوله",
    page2_delivery_tracking_servicedescription:
      "رهگیری خودکار با نمایش دقیق و لحظه‌ای وضعیت برای مشتریان، ایجاد شفافیت و اعتماد کامل.",
    page2_jobs_subadmin_title: "ادمین همکار",
    page2_jobs_subadmin_description: "امکان اضافه کردن ادمین همکار",
    page2_jobs_subadmin_servicedescription:
      "بدون اشتراک رمز، ادمین همکار اضافه کنید و دسترسی‌ها را سفارشی کنید. کنترل کامل و امنیت تضمین‌شده.",
    page2_ids_store_title: "فروشگاه ID",
    page2_ids_store_description: "خرید و فروش ای دی اینستاگرام",
    page2_ids_store_servicedescription:
      "خرید و فروش اکانت‌های اینستاگرام با احراز هویت و امنیت. آنالیز دقیق، قیمت‌گذاری هوشمند، مزایده و اعتبارسنجی آمار—all in one place.",
    page2_publish_contentmanagement_title: "مدیریت محتوا",
    page2_publish_contentmanagement_description: "مدیریت پست‌ها و استوری‌ها",
    page2_publish_contentmanagement_servicedescription:
      "مدیریت همه پست‌ها و استوری‌ها در یک پلتفرم پیشرفته و هوشمند با زمان‌بندی، دسته‌بندی و انتشار سریع برای کنترل راحت شبکه اجتماعی.",
    page2_publish_contentpublishing_title: "انتشار محتوا",
    page2_publish_contentpublishing_description: "انتشار زمان‌بندی‌شده پست‌ها و استوری‌ها",
    page2_publish_contentpublishing_servicedescription:
      "پست‌ها و استوری‌ها را به‌صورت هوشمند و زمان‌بندی‌شده منتشر کنید. سیستم بهترین زمان را بر اساس تحلیل رفتار فالورها پیشنهاد می‌دهد.",
    page2_publish_analytics_title: "آنالیز پست و استوری",
    page2_publish_analytics_description: "آنالیز کامل محتوا",
    page2_publish_analytics_servicedescription:
      "دید عمیقی از عملکرد محتوا و بازخورد مخاطبان به دست آورید و استراتژی محتوایی خود را بهینه کنید.",
    page2_publish_statistics_title: "آمارگیری",
    page2_publish_statistics_description: "ابزار پیشرفته تحلیل عملکرد",
    page2_publish_statistics_servicedescription:
      "پیشرفته‌ترین ابزار تحلیل محتوا با جزئیات کامل عملکرد پست‌ها و استوری‌ها، نمودارها و تحلیل دقیق برای تصمیم‌گیری بهتر.",
    page2_extension_biolink_title: "بایو لینک",
    page2_extension_biolink_description: "بیش از یک لینک ساده در بایو",
    page2_extension_biolink_servicedescription:
      "صفحه‌ای اختصاصی و زیبا برای نمایش تمام لینک‌های مهم شما با طراحی واکنش‌گرا و شخصی‌سازی کامل، فراتر از یک لینک ساده.",
    page2_extension_paymentgateway_title: "درگاه پرداخت",
    page2_extension_paymentgateway_description: "درگاه پرداخت اختصاصی",
    page2_extension_paymentgateway_servicedescription:
      "درگاه پرداخت امن و اختصاصی بدون نیاز به دانش فنی، با گزارش‌گیری دقیق و مدیریت تراکنش‌ها در محیط کاربرپسند.",
    page2_extension_customwebsite_title: "وبسایت اختصاصی",
    page2_extension_customwebsite_description: "وبسایت اختصاصی متناسب با پیج شما",
    page2_extension_customwebsite_servicedescription:
      "وبسایتی اختصاصی و هماهنگ با هویت بصری پیج، بدون نیاز به کدنویسی. محصولات و خدمات خود را حرفه‌ای نمایش دهید.",
    page4_menu_instagram_management: "مدیریت صفحه اینستاگرام",
    page4_menu_admin_subadmin: "ادمین و ساب‌ادمین",
    page4_menu_store_shipping: "فروشگاه و ارسال",
    page4_menu_advertising: "تبلیغات",
    page4_menu_hashtag_management: "مدیریت هشتگ",
    page4_menu_ai_analysis: "تحلیل هوشمند با هوش مصنوعی",
    page4_menu_ad_scheduling: "زمان‌بندی تبلیغات",
    page4_menu_financial_wallet: "مالی و کیف پول",
    page4_menu_page_statistics: "آمار صفحه",
    page4_menu_professional_messaging: "پیام‌رسانی حرفه‌ای",

    page4_content_instagram_management_text:
      "همه بخش‌های پیجتو—از انتشار محتوا تا پاسخ به کامنت‌ها و دایرکت‌ها—یکپارچه و حرفه‌ای مدیریت کن. بدون نیاز به چندین اپ!",
    page4_content_admin_subadmin_text:
      "تیم بساز! نقش‌ها را تعیین کن، دسترسی‌ها را محدود کن و فعالیت‌ها را بدون نگرانی از خطای انسانی کنترل کن.",
    page4_content_store_shipping_text:
      "فروشگاه واقعی اینستاگرامی! مدیریت موجودی، سفارشات، فاکتورها و ارسال از یک پنل واحد. فروش آنلاین راحت‌تر از همیشه!",
    page4_content_advertising_text:
      "تبلیغات اینستاگرامی را با چند کلیک طراحی، اجرا و تحلیل کن! مخاطب هدف بگیر، بازدهی بسنج و بودجه‌ات را هدر نده.",
    page4_content_hashtag_management_text:
      "هشتگ‌هایت را هوشمندانه انتخاب کن! بهترین هشتگ‌های مرتبط را تحلیل، ذخیره و دسته‌بندی کن و برای هر پست پیشنهاد بگیر.",
    page4_content_ai_analysis_text:
      "رفتار فالورها را دقیق تحلیل کن! الگوها، علایق و ساعات اوج فعالیت را با هوش مصنوعی کشف کن و استراتژیت را بهبود بده.",
    page4_content_ad_scheduling_text:
      "تبلیغاتت حتی وقتی خواب هستی فعال باشند! کمپین‌ها را برنامه‌ریزی کن، زمان شروع و پایان را تنظیم کن و بدون دغدغه رشد کن.",
    page4_content_financial_wallet_text:
      "تمام تراکنش‌ها را زیر نظر داشته باش! درآمد، هزینه، موجودی کیف پول و گزارش‌های مالی کامل برای مدیریت بهتر سرمایه.",
    page4_content_page_statistics_text:
      "آمار دقیق و واقعی رشد پیج: نرخ تعامل، رشد فالورها، عملکرد پست‌ها، بازدیدها و داده‌های ارزشمند برای تصمیم‌گیری هوشمند.",
    page4_content_professional_messaging_text:
      "دایرکت مارکتینگ واقعی را تجربه کن! پیام گروهی بفرست، پاسخ خودکار تنظیم کن و مکالمات با فالورها را حرفه‌ای مدیریت کن.",

    shipping: "خدمات پستی",
    jobs: "استخدام",
    IDstore: "فروشگاه ID",
    page3_text1: "راه‌حل تمام نیاز‌های کسب‌و‌کار شما",
    page5_whyBrancy: "چرا برنسی؟",
    page5_title1: "شریک رسمی و امن اینستاگرام",
    page5_title2: "اکوسیستم یکپارچه، صرفه‌جویی هوشمند",
    page5_title3: "تعامل هوشمند به صورت حرفه‌ای",
    page5_title4: "داشبورد فوق‌پیشرفته و هوشمند",
    page5_title5: "سیستم فروش و لجستیک هوشمند",
    page5_title6: "وب‌سایت هوشمند اختصاصی",
    page5_explain1: "مدیریت هوشمند بدون دسترسی به داده های حساس؛ امن و سازگار با اینستاگرام.",
    page5_explain2: "همه ابزارها یکجا؛ ۷۰٪ صرفه‌جویی هزینه، ۸۰٪ زمان.",
    page5_explain3: "پاسخ‌ خودکار با هوش مصنوعی؛ ۴۰٪ تعامل بیشتر، ۹۰٪ حفظ مشتری.",
    page5_explain4: "رابط سریع، تحلیل زنده، ادمین‌ها، زمان‌بندی و گزارش.",
    page5_explain5: "فروش در دایرکت؛ درگاه، فروشگاه، ارسال و موجودی هوشمند.",
    page5_explain6: "سایت و لینک بایو حرفه‌ای؛ فروش، رزرو، سئو و شبکه‌ها.",

    page9_planheader: "حرفه‌ای شروع کن و از امکانات لذت ببر!",
    page9_planexplain: "۴۰ روز دسترسی کامل، رایگان و نامحدود!",
    page9_plantitle: "تعداد فالور پیج اینستاگرم خود را انتخاب کنید تا پکیج مناسب نمایش داده شود",

    page9_freeplan: "رایگان",
    page9_basicplan: "پایه",
    page9_proplan: "حرفه‌ای",
    page9_adsplan: "تبلیغاتی",
    page9_storeplan: "فروشگاهی",
    page9_monthly: "ماهانه",
    page9_Compare: "مقایسه کامل پلن‌ها",
    page9_content_management: "مدیریت پست‌ها و استوری‌ها",
    page9_analize_management: "آنالیز پیشرفته و ابزارهای آماری",
    page9_message_management: "مدیریت دایرکت‌ها و کامنت‌ها",
    page9_biolink_management: "بایولینک و سایت اختصاصی",
    page9_subadmin_management: "استخدام و مدیریت ادمین‌های زیرمجموعه",

    page9_basicoption: "امکانات پایه",
    page9_ticket_management: "فروش از دایرکت و تیکت",
    page9_finance_management: "درگاه پرداخت و کیف پول",
    page9_store_management: "انبارداری هوشمند فروشگاه",
    page9_logestic_management: "ارسال و تحویل خودکار مرسولات",
    page9_storeanalize_management: "آمارگیری پیشرفته",
    page9_calendar_management: "تقویم زمانبندی تبلیغات",
    page9_advertise_management: "مدیریت تبلیغات هوشمند",
    page9_adsanalize_management: "آمارگیری پیشرفته تبلیغات",
    page9_campagin_management: "ایجادکردن و شرکت کردن در کمپین ها",
    page9_adsticket_management: "ارسال خودکار بازخورد تبلیغات به مشتریان",

    page6_Header: "هزاران کسب‌وکار فعال",
    page6_Explain: "اکثر کسب‌وکارهای موفق به جمع خانواده بزرگ برنسی اضافه شده‌اند",
    page10_header: "آنچه مشتریان ما می‌گویند",
    page8_HelpCenter: "مرکز راهنمایی",
    page8_Community: "انجمن کاربران",
    page8_learn: "یادگیری",
    page8_Blog: "بلاگ",
    page8_FAQ: "سؤالات متداول",
    Addfaq: "افزودن سؤالات متداول",
    addfaqexplain: "حداکثر ۴ سؤال متداول می‌توانید اضافه کنید",
    faqEmptyState: "سؤالات متداول شما در این قسمت اضافه خواهد شد",

    page8_Support: "پشتیبانی",
    support_Online: "پشتیبانی آنلاین",
    support_EnterBlog: "ورود به بلاگ",
    page8_CommunityExplain:
      "با دیگر کاربران در ارتباط باشید، تجربیات خود را به اشتراک بگذارید و از مشاوره جمعی برای رشد بیشتر بهره‌مند شوید.",
    page8_learnExplain:
      "در این بخش، جدیدترین استراتژی‌ها برای استفاده از اینستاگرام در کسب‌وکار را خواهید آموخت. هر آنچه برای رشد کسب‌وکارتان نیاز دارید، اینجا پیدا می‌کنید.",
    page8_BlogExplain:
      "به جدیدترین مقالات و مطالب آموزشی دسترسی داشته باشید. اطلاعات به‌روز در زمینه‌های مختلف کسب‌وکار و دیجیتال مارکتینگ منتظرتان است.",
    page8_FAQExplain:
      "سوالات متداول شما در اینجا پاسخ داده شده است. برای هر گونه راهنمایی درباره خدمات یا محصولات، به این بخش مراجعه کنید.",
    page8_SupportExplain:
      "تیم پشتیبانی ما آماده‌ است تا به شما کمک کند. هر گونه مشکل یا سوالی داشتید، کافیست با ما تماس بگیرید.",
    page8_CommunityBTN: "با هم یاد بگیریم",
    page8_learnBTN: "یادگیری سریع",
    page8_BlogBTN: "آخرین اخبار",
    page8_FAQBTN: "پاسخ‌های فوری",
    page8_SupportBTN: "ما پاسخگوییم",
    footer_Brancy: "برنسی",
    footer_AboutUs: "درباره ما",
    footer_ContactUs: "تماس با ما",
    footer_JoinUs: "به ما بپیوندید",
    footer_OrgChart: "نمودار سازمانی",
    footer_FollowUs: "ما را فالو کنید",
    footer_Solutions: "راهکارها",
    footer_HelpCenter: "مرکز راهنمایی",
    footer_Support: "پشتیبانی",
    footer_FAQ: "سؤالات متداول",
    footer_ReportAnIssue: "گزارش مشکل",
    footer_TrustLegal: "مسئولیت اجتماعی",
    footer_TermsAndConditions: "شرایط و ضوابط",
    footer_PrivacyNotice: "اعلان حریم خصوصی",
    footer_CookieNotice: "اعلان کوکی‌ها",
    footer_Blog: "بلاگ",
    footer_ProductUpdates: "آخرین بروزرسانی‌ها",
    footer_Articles: "مقالات",
    footer_LatestNews: "جدیدترین اخبار",

    installPromptMessage: "نصب وب اپلیکیشن برنسی",
    install: "نصب",
    installStep1: "در نوار پایین، دکمهٔ اشتراک‌گذاری را انتخاب کنید.",
    installStep2: "منوی باز شده را به بالا اسکرول کنید و Add to Home Screen را انتخاب کنید.",
    installStep3: "در بالای صفحه، دکمهٔ Add را انتخاب کنید.",

    joinUs_subtitle: "به برنسی بپیوندید؛ جایی که نوآوری و آینده‌ای پایدار شکل می‌گیرد.",
    joinUs_whyWorkWithUs: "چرا برنسی؟",
    joinUs_whyWorkWithUsDescription:
      "برنسی فقط یک محیط کاری نیست؛ بستری استراتژیک برای رشد حرفه‌ای و فردی است. ما باور داریم سازمان‌های پیشرو با استعدادهای برتر ساخته می‌شوند. تعهد ما ایجاد فضایی پویا، شفاف و حمایتگر است تا اعضای تیم بتوانند اثرگذاری ماندگار داشته باشند.",
    joinUs_openPositions: "موقعیت‌های شغلی باز",
    joinUs_openPositionsDescription:
      "فرصت‌های موجود را بررسی کنید و جایگاه متناسب با تخصص و مسیر حرفه‌ای خود را انتخاب نمایید.",
    joinUs_frontendDeveloper: "توسعه‌دهنده فرانت‌اند",
    joinUs_frontendDeveloperDescription:
      "طراحی و پیاده‌سازی تجربه‌های کاربری مدرن با React و TypeScript. نقش کلیدی در ارتقای کیفیت و کارایی محصولات خواهید داشت.",
    joinUs_backendDeveloper: "توسعه‌دهنده بک‌اند",
    joinUs_backendDeveloperDescription:
      "طراحی و توسعه سامانه‌های مقیاس‌پذیر و ایمن با Node.js و فناوری‌های ابری. نیازمند تفکر سیستمی و حل مسائل پیچیده.",
    joinUs_uiUxDesigner: "طراح UI/UX",
    joinUs_uiUxDesignerDescription:
      "خلق رابط‌های کاربری استاندارد و تجربه‌های شهودی برای رضایت و وفاداری کاربران. توجه به جزئیات و خلاقیت ضروری است.",
    joinUs_productManager: "مدیر محصول",
    joinUs_productManagerDescription:
      "هدایت استراتژی محصول و هماهنگی تیم‌ها برای ارائه راهکارهای رقابتی و کارآمد. مناسب افراد با دید تحلیلی و توانایی مدیریت ذی‌نفعان.",
    joinUs_marketingSpecialist: "متخصص بازاریابی",
    joinUs_marketingSpecialistDescription:
      "برنامه‌ریزی و اجرای کمپین‌های دیجیتال و ارتقای جایگاه برند. ترکیبی از مهارت‌های تحلیلی و خلاقیت.",
    joinUs_customerSupport: "کارشناس پشتیبانی مشتری",
    joinUs_customerSupportDescription:
      "ارائه پشتیبانی حرفه‌ای، حل مشکلات و بهبود تجربه کاربران. نیازمند دقت، صبر و مهارت ارتباطی.",
    joinUs_engineering: "مهندسی",
    joinUs_design: "طراحی",
    joinUs_product: "محصول",
    joinUs_marketing: "بازاریابی",
    joinUs_support: "پشتیبانی",
    joinUs_remoteOnsite: "دورکاری / حضوری",
    joinUs_onsite: "حضوری",
    joinUs_remote: "دورکاری",
    joinUs_fullTime: "تمام‌وقت",
    joinUs_partTimeFullTime: "پاره‌وقت / تمام‌وقت",
    joinUs_applyNow: "همین حالا درخواست دهید",
    joinUs_applicationProcess: "فرآیند جذب در برنسی",
    joinUs_submitApplication: "ارسال درخواست",
    joinUs_submitApplicationDescription: "رزومه و توانمندی خود را ارسال کنید. تیم ما با دقت بررسی خواهد کرد.",
    joinUs_initialScreening: "بررسی اولیه",
    joinUs_initialScreeningDescription:
      "واحد منابع انسانی رزومه‌ها را طی ۳ تا ۵ روز کاری بررسی و در صورت انطباق تماس می‌گیرد.",
    joinUs_technicalInterview: "مصاحبه فنی",
    joinUs_technicalInterviewDescription: "ارزیابی دانش و تجربه فنی از طریق مصاحبه تخصصی با تیم‌ها.",
    joinUs_finalInterview: "مصاحبه نهایی",
    joinUs_finalInterviewDescription:
      "جلسه پایانی با مدیران ارشد و تیم‌های کلیدی برای اطمینان از هماهنگی اهداف و ارزش‌ها.",
    joinUs_welcomeAboard: "خوش‌آمدید",
    joinUs_welcomeAboardDescription:
      "پس از پذیرش، فرآیند آنبوردینگ جامع آغاز خواهد شد تا با فرهنگ و اهداف سازمان آشنا شوید.",
    joinUs_readyToJoinUs: "موقعیت مورد نظر خود را نیافتید؟",
    joinUs_readyToJoinUsDescription:
      "ما همواره پذیرای افراد متخصص و باانگیزه هستیم. رزومه خود را ارسال کنید و چشم‌انداز همکاری خود با برنسی را شرح دهید.",
    joinUs_sendYourResume: "ارسال رزومه",

    aboutUs_pageTitle: "درباره برنسی",
    aboutUs_metaDescription:
      "با برنسی، پلتفرمی جامع و بین‌المللی برای مدیریت شبکه‌های اجتماعی و کسب‌وکارهای دیجیتال آشنا شوید؛ جایی که نوآوری، اعتماد و رشد پایدار در کنار هم آینده اقتصاد دیجیتال را می‌سازند.",
    aboutUs_subtitle: "مدیریت هوشمند اقتصاد دیجیتال با برنسی",
    aboutUs_ourStoryTitle: "داستان ما",
    aboutUs_ourStoryPara1:
      "برنسی با هدف بازتعریف مدیریت کسب‌وکارهای آنلاین متولد شد؛ نقطه‌ای که فناوری‌های پیشرفته و نیازهای واقعی صاحبان کسب‌وکار به هم پیوند می‌خورند. ما تنها یک ابزار ارائه نمی‌کنیم، بلکه بستری خلق کرده‌ایم که کسب‌وکارها بتوانند همانند یک سازمان بزرگ و حرفه‌ای فعالیت کنند.",
    aboutUs_ourStoryPara2:
      "این مسیر بر پایه یک باور شکل گرفت: فناوری باید مسیر رشد انسان و کسب‌وکار را هموار کند و نه اینکه مانعی بر سر راه آن باشد.",
    aboutUs_innovationTitle: "نوآوری به‌عنوان مزیت بنیادین",
    aboutUs_innovationPara1:
      "برنسی از هوش مصنوعی، کلان‌داده و فناوری‌های نوین وب بهره می‌گیرد تا تجربه‌ای یکپارچه، امن و کارآمد را برای کاربران خلق کند. هر ویژگی با تمرکز بر سادگی استفاده و حداکثر بهره‌وری طراحی شده است.",
    aboutUs_innovationPara2:
      "برای ما نوآوری تنها در تکنولوژی خلاصه نمی‌شود؛ بلکه رویکردی استراتژیک است که در فرهنگ سازمانی و نگاه ما به آینده ریشه دارد.",
    aboutUs_coreValuesTitle: "ارزش‌های بنیادین ما",
    aboutUs_innovationFirstTitle: "پیشرو در نوآوری",
    aboutUs_innovationFirstDesc:
      "ما همواره در جستجوی ارائه راهکارهایی هستیم که نیازهای آینده کسب‌وکارهای دیجیتال را پاسخ دهند.",
    aboutUs_trustSecurityTitle: "اعتماد و امنیت",
    aboutUs_trustSecurityDesc:
      "امنیت داده‌ها و شفافیت فرآیندها اولویت ماست تا کاربران بتوانند با اطمینان کامل رشد کنند.",
    aboutUs_globalCommunityTitle: "جامعه‌ای جهانی",
    aboutUs_globalCommunityDesc:
      "برنسی فراتر از مرزهای جغرافیایی، اکوسیستمی جهانی از کسب‌وکارها و متخصصان را به هم متصل می‌کند.",
    aboutUs_sustainableGrowthTitle: "رشد پایدار",
    aboutUs_sustainableGrowthDesc:
      "ما به گسترش هوشمند و پایدار پایبندیم؛ رشدی که همسو با اصول اخلاقی و مسئولیت‌پذیری اجتماعی باشد.",
    aboutUs_userEmpowermentTitle: "توانمندسازی کاربران",
    aboutUs_userEmpowermentDesc:
      "ابزارهای شهودی و منابع آموزشی ما دسترسی برابر به فرصت‌های دیجیتال را برای همه فراهم می‌کنند.",
    aboutUs_continuousEvolutionTitle: "تکامل مداوم",
    aboutUs_continuousEvolutionDesc:
      "در جهانی پویا، تغییر بخشی از مسیر ماست. ما همواره با یادگیری و بهبود مستمر پیش می‌رویم.",
    aboutUs_globalImpactTitle: "تأثیر جهانی",
    aboutUs_globalImpactPara:
      "برنسی امروز بستری برای توانمندسازی میلیون‌ها کارآفرین و کسب‌وکار است؛ پلی میان فرصت‌های دیجیتال و آینده‌ای بدون مرز.",
    aboutUs_activeUsers: "کاربران فعال",
    aboutUs_countries: "کشورهای تحت پوشش",
    aboutUs_uptime: "در دسترس بودن سیستم",
    aboutUs_support: "پشتیبانی اختصاصی",
    aboutUs_teamTitle: "تیم برنسی",
    aboutUs_teamPara1:
      "تیم ما ترکیبی از متخصصان فناوری، استراتژیست‌ها و خلاقان از سراسر دنیاست که با هدف مشترک توسعه اقتصاد دیجیتال گرد هم آمده‌اند.",
    aboutUs_teamPara2:
      "از تجربه پیشگامان صنعت تا انرژی استعدادهای جوان، ما در برنسی جنبشی جهانی را هدایت می‌کنیم که نسل جدیدی از تجارت دیجیتال را شکل خواهد داد.",

    // #region  landing page
    userpanel_yourorders: "وضعیت سفارش‌های شما",
    userpanel_SavedProducts: "محصولات ذخیره‌شده",
    userpanel_NoSavedProducts: "محصول ذخیره‌شده‌ای  ندارید.",
    userpanel_Startexplore: "بازارگردی مدرن میان میلیون‌ها",
    userpanel_Startexploreexplain: "محصول، فروشگاه و پیج",
    userpanel_TicketSupportExplain: "پیگیری سفارش، گفت‌وگو با فروشنده",
    userpanel_TicketSupport: "از طریق تیکت در ارتباط باش",

    userpanel_UseInstagram: "اینستاگرم را حرفه‌ای مدیریت کنید.",
    userpanel_FreeProPanel: "پنل پرو رایگان",
    userpanel_Premiumaccount: "حساب پرمیوم",
    userpanel_daysFreePremium: "۴۰ رو پرمیوم رایگان",
    userpanel_LimitedOffer: "فرصت محدود!",
    Dashboard: "داشبورد",
    greeting1: "خورشید هم با تو بیدار شده،",
    greeting2: "صبح پرانرژیت بخیر،",
    greeting3: "روزت بخیر،",
    greeting4: "ظهرت بخیر،",
    greeting5: "عصر طلاییت بخیر،",
    greeting6: "شب نزدیکه ",
    greeting7: "شب آرومت بخیر،",
    greetingtext1: "صبح زود واقعا جادوییه🌅",
    greetingtext2: "دنیا منتظر قدمای توئه 💪",
    greetingtext3: "وقت یه چای و لبخنده ☕😊",
    greetingtext4: "غذای خوشمزه نوش جونت 🍽️",
    greetingtext5: "خورشید هنوز تو آسمونه، برو جلو 🌟",
    greetingtext6: "یه پایان باحال بساز 🌇",
    greetingtext7: "رویاهای بزرگ ببین و فردا شروع کن🌙",
    // #region 0️⃣ General Section
    //0️⃣ General -> sidebar
    color: "رنگ",
    button: "دکمه",
    Liter: "لیتر",
    FrontFace: "نمای جلو",
    SideFace: "نمای کناری",
    TopFace: "نمای بالا",
    Area: "مساحت",
    Perimeter: "محیط",
    Volume: "حجم",
    inSystem: "داخل سیستم",
    sending: "در حال ارسال",
    uploadsRemaining: "بارگذاری‌های باقی‌مانده",
    logoutExplain: "شما در حال تلاش برای خروج از برنسی هستید",
    welcomeToBrancy: "به برنسی خوش آمدید!",
    notloginexplain: "برای استفاده از خدمات برنسی، حساب اینستاگرام خود را متصل کنید",
    welcomeToBrancyExplain: "آی‌دی اینستاگرام خود را وارد کنید تا پنل مدیریت حرفه‌ای خود را راه‌اندازی کنید.",
    welcomeToBrancyExplainPhone: "شماره تلفن خود را وارد کنید تا پنل مدیریت حرفه‌ای خود را راه‌اندازی کنید.",
    loginWithGoogle: "ورود با گوگل",
    loginWithMobile: "ورود با SMS",

    or: "یا",
    InstagramID: "نام کاربری (ID) اینستاگرام",
    EmptyNotification: "هنوز هیچ اعلانی وجود ندارد",
    Notification_NewMessage: "پیام جدیدی از {{sender}} دارید",
    Notification_NewOrder: "سفارش جدیدی از {{sender}} دارید",
    Notification_ImagesCreatedBy: "تصاویر شما با موفقیت توسط مدل {{version}} ایجاد شدند.",
    Notification_VideoCreatedBy: "ویدیوی شما با موفقیت توسط مدل {{version}} ایجاد شد.",
    Notification_MediaCreationFailed: "ایجاد رسانه شما توسط مدل {{version}} ناموفق بود: {{metadata}}",
    Notification_VideoCreationFailed: "ایجاد ویدیوی شما توسط مدل {{version}} ناموفق بود: {{metadata}}",
    Notification_NewPost: "پست جدید",
    Notification_UploadPostFailed: "آپلود پست ناموفق بود",
    Notification_NewStory: "استوری جدید",
    Notification_UploadStoryFailed: "آپلود استوری ناموفق بود",
    Notification_NewVideo: "ویدیوی جدید",
    Notification_VideoCreationFailedTitle: "ایجاد ویدیو ناموفق بود",
    Notification_YouHaveNewMessage: "پیام جدیدی دارید",
    Notification_AccountDeauthorized: "دسترسی حساب اینستاگرام لغو شد",
    EnterYourText: "متن خود را وارد کنید",
    EnterYourphonenumber: "شماره تلفن خود را وارد کنید",
    CopyText: "کپی کردن متن",
    successfulCopy: "کپی شد",
    download: "دانلود",
    automatic: "خودکار",
    manual: "دستی",
    phonenumber: "شماره تلفن",
    SendVerificationCode: "ارسال کد",
    ShowUserDashboard: "رفتن به داشبورد",
    VerificationCode: "کد تأیید",
    VerificationCodeExplain: "لطفاً کد تأییدی که به تلفن شما ارسال شده است را وارد کنید.",
    remainingTime: "زمان باقی‌مانده",
    createtime: "زمان ایجاد",
    ResendVerificationCode: "ارسال مجدد کد تأیید",
    Verify: "تأیید",
    VerifyAddress: "تأیید آدرس",
    VerifyCode: "تأیید کد",
    Continue: "ادامه",
    metaRedirect_aiAnalysisNotice: "توجه داشته باشید که تحلیل پیج شما با هوش مصنوعی ممکن است تا چند ساعت طول بکشد.",
    Efficiency: "کارایی",
    max: "حداکثر",
    logout: "خروج",
    notallowed: "مجاز نیست",
    notallowedExplain: "شما اجازه دسترسی به این قابلیت را ندارید",
    notallowedExplainPage: "شما اجازه دسترسی به این صفحه را ندارید",
    CreateAutomationFlow: "ساخت اتوماسیون با فلو",
    CreateAutomationFlowExplain: "خودکارسازی تمامی تعاملات اینستاگرام با استفاده از سازنده‌ی جریان کاری بصری",
    CreateAutomationAI: "ساخت اتوماسیون هوشمند",
    CreateAutomationAIExplain: "خودکارسازی تمامی تعاملات اینستاگرام با پاسخ‌های مبتنی بر هوش مصنوعی",
    flowProperties_notworking_privateReply:
      "⚠️ توجه: این فلو در چت خصوصی با دوستان اجرا نمی‌شود و فقط برای پاسخ خودکار به کامنت‌ها و دایرکت کاربرد دارد",
    flowProperties_privateReply_requiresFollower:
      "این فلو قابلیت استفاده در پاسخ خصوصی را ندارد. برای فعال‌سازی، گزینه «کاربر باید صفحه را دنبال کند» را در تنظیمات فعال کنید.",

    needPass: "تأیید و فعال‌سازی",
    needPassExplain: "برای دسترسی کامل به این قابلیت، پسورد اکانت اینستاگرم مورد نیاز است",
    soon: "به زودی",
    soonExplain: "این قابلیت به زودی در دسترس خواهد بود",
    underdevelop: "در حال توسعه",
    reject: "رد کردن",
    rejected: "رد شده",
    approved: "تأیید شده",
    ExpirationTime: "زمان انقضا",
    send: "ارسال",
    accept: "پذیرفتن",
    selectall: "انتخاب همه",
    General: "عمومی",
    Business: "پیام‌های کاری",
    undo: "بازگردانی",
    redo: "انجام دوباره",
    total: "مجموع کل",
    Unknown: "نامشخص",
    close: "بستن",
    closed: "بسته شده",
    admin: "ادمین",
    user: "کاربر",
    stop: "توقف",
    save: "ذخیره",
    discard: "حذف",
    all: "همه",
    update: "به‌روزرسانی",
    like: "لایک",
    dislike: "لغو لایک",
    next: "بعدی",
    cancel: "لغو",
    canceled: "لغو شده",
    comment: "کامنت",
    mention: "منشن",
    add: "افزودن",
    icon: "آیکن",
    copylist: "کپی لیست",
    reply: "ریپلای",
    replies: "ریپلای ها",
    PrivateReply: "پاسخ خصوصی",
    copy: "کپی",
    everywhere: "همه‌جا",
    UnHide: "نمایش دادن",
    show: "نمایش",
    Hide: "پنهان کردن",
    pageSummary: "خلاصه صفحه",
    summaryGeneralIntro: "معرفی کلی صفحه",
    summaryUserEngagement: "تحلیل تعامل کاربران",
    summaryContentStrategy: "بررسی استراتژی محتوا",
    summaryPostingSchedule: "ارزیابی زمان‌بندی انتشار",
    summaryImprovementSuggestions: "پیشنهادهای بهبود و رشد",
    Ignore: "نادیده گرفتن",
    Orange: "نارنجی",
    Purple: "بنفش",
    Green: "سبز",
    White: "سفید",
    DarkGray: "خاکستری تیره",
    Blue: "آبی",
    LightGray: "خاکستری روشن",
    Brown: "قهوه‌ای",
    Pink: "صورتی",
    Yellow: "زرد",
    Silver: "نقره‌ای",
    Black: "مشکی",
    Red: "قرمز",
    select: "انتخاب",
    back: "بازگشت",
    start: "شروع",
    country: "کشور",
    device: "دستگاه",
    yourdevice: "دستگاه شما",
    otherdevice: "دستگاه دیگر",
    SessionID: "شناسه نشست",
    header: "تیتر",
    upload: "آپلود",
    active: "فعال",
    activate: "فعال‌سازی",
    deactive: "غیرفعال",
    activateAll: "فعال‌سازی همه",
    DeactivateAll: "غیرفعال‌سازی همه",
    signout: "خروج",
    switchaccount: "تغییر حساب کاربری",
    instagramConnect: "اتصال حساب اینستاگرام",
    CollaboratorExplain: "اشتراک‌گذاری پست یا ریلز به‌صورت مشترک بین چند پیج اینستاگرام",

    addnewaccount: "افزودن اکانت",
    addedaccounts: "حساب‌های اضافه‌شده",
    SwitchtoAccountexplain: "تمام اکانت‌های شما که در برنسی اضافه شده‌اند اینجا نمایش داده می‌شوند",
    SwitchtoAccount: "ورود به اکانت",
    accountmanagement: "مدیریت اکانت",
    subadmininvitation: "دعوتنامه همکاری",
    subadmininvitationexplain: "دعوت‌نامه مدیریت اینستاگرام به عنوان همکار",
    Renew_Subscription: "تمدید اشتراک",
    upgrade: "ارتقاء",
    Deactivate: "غیرفعال‌سازی",
    done: "انجام‌شده",
    text: "متن",
    PlaceHolder: "در حال نوشتن...",
    media: "ویدیو/عکس",
    ReplyStory: "پاسخ به استوری",
    photo: "عکس",
    audio: "پیام صوتی",
    Generic: "عمومی",
    StoryMention: "منشن استوری",
    FileShare: "فایل",
    voice: "صوتی",
    abort: "لغو",
    Pending: "در انتظار",
    Preparing: "در حال آماده‌سازی",
    Finished: "پایان‌یافته",
    finish: "پایان",
    exportJPG: "خروجی JPG",
    exportPDF: "خروجی PDF",
    exportXlxs: "خروجی اکسل",
    dismiss: "بستن",
    empty: "خالی",
    searching: "...در حال جستجو ",
    searchMessage: "جستجوی افراد یا کلمه کلیدی",
    searchKeyword: "جستجوی کلمه کلیدی",
    Recommended: "توصیه شده",
    VERFIED: "تأیید شده",
    SuccessADS: "موفقیت تبلیغات",
    SuccessSALES: "موفقیت فروش",
    StartOrder: "شروع سفارش",
    Startshoping: "شروع خرید",
    question: "سوال",
    Answer: "پاسخ",
    shareStory: "اشتراک‌گذاری استوری",
    search: "جستجو",
    searchLocation: "جستجوی مکان",
    searchPeople: "جستجوی افراد",
    edit: "ویرایش",
    delete: "حذف",
    deletecover: "حذف کاور",
    details: "جزئیات",
    Insights: "اینسایت‌ها",
    new: "جدید",
    comments: "کامنت‌ها",
    nocomment: "هیچ نظری برای نمایش وجود ندارد",
    SimilarProducts: "محصولات مشابه",
    QandA: "پرسش‌ها",
    caption: "کپشن",
    collaborator: "پیج همکار",
    collaboratorpost: "پست همکار",
    sidebar_Home: "خانه",
    sidebar_Page: "مدیریت پیج",
    sidebar_Message: "پیام‌ها",
    sidebar_Wallet: "کیف پول",
    sidebar_biolink: "بایو لینک",
    sidebar_Advertise: "تبلیغات",
    sidebar_Store: "فروشگاه",
    sidebar_Stores: "فروشگاه‌ها",
    sidebar_Business: "کسب‌وکار",
    sidebar_Setting: "تنظیمات",
    //0️⃣ General -> navbar
    navbar_Post: "پست",
    navbar_Live: "لایو",
    navbar_Story: "استوری",
    navbar_Feed: "فید",
    navbar_Reels: "ریلز",
    navbar_Statistics: "آمار ها",
    navbarTools: "ابزار",
    navbar_Direct: "دایرکت‌ ",
    navbar_Comments: "کامنت‌",
    navbar_Ticket: "تیکت‌",
    navbar_AI: "هوش مصنوعی",
    navbar_ContentCreator: "تولید محتوا",
    navbar_Properties: "تنظیمات",
    navbar_AIAndFlow: "هوش مصنوعی و ایجنت",
    navbar_Payment: "پرداخت‌ها",
    navbar_Title: "عنوان",
    priceHistory: "تاریخچه قیمت",
    navbar_Home: "خانه",
    navbar_Biolink: "لینک من",
    navbar_Calendar: "تقویم",
    navbar_AdList: "لیست تبلیغات",
    navbar_General: "عمومی",
    navbar_SubAdmin: "ادمین همکار",
    navbar_Products: "محصولات",
    navbar_Orders: "سفارشات",
    navbar_totalOrders: "مجموع سفارشات",
    navbar_HelpCenter: "راهنمایی و پشتیبانی",

    //0️⃣ countdown
    countdown_Days: "روز",
    countdown_Hours: "ساعت",
    countdown_Minutes: "دقیقه",
    Expired: "منقضی شده",
    justnow: "همین الان",
    LessThanAMinute: "کمتر از یک دقیقه",
    ExpiresIn: "منقضی می‌شود در",
    ExportPDF: "خروجی PDF",
    ExportJPG: "خروجی JPG",
    ShareTo: "اشتراک‌گذاری به",
    Expand: "گسترش",
    // #endregion General Section
    // #region 1️⃣home Section
    // 1️⃣ Home -> cards
    home_FollowRequest: "درخواست‌های فالو",
    home_UnreadNewComments: "کامنت‌های جدید خوانده‌ نشده",
    home_Last24H: "۲۴ ساعت گذشته",
    home_Last30Days: "طی ۳۰ روز اخیر",
    home_LastLikes: "لایک‌های جدید",
    home_LastPost: "آخرین پست",
    home_Followings: "فالوینگ ها",
    home_Followers: "فالور ها",
    AudienceLocation: "موقعیت مخاطبین فعال",
    AudienceGender: "جنسیت مخاطبین فعال",
    AudienceAge: "سن مخاطبین فعال",

    AudienceGenderStats:
      "تعداد مخاطبین زن شما {{female}} نفر و تعداد مخاطبین مرد شما {{male}} نفر و {{unknown}} نفر هم نامشخص هستند",

    AudienceAgeStats:
      "بیشترین مخاطبین شما از رنج {{ageRange}} است ({{percentage}}%) پس محتوا باید برای رنج سنی {{ageCategory}} جذاب و مناسب باشد.",

    AgeCategoryYoung: "جوان",
    AgeCategoryMiddleAged: "میان‌سال",
    AgeCategoryOlder: "پیر",

    AudienceLocationStats:
      "بیشترین مخاطبین فعال شما از کشور {{country}} با تعداد {{countryCount, number}} نفر و از شهر {{city}} با تعداد {{cityCount, number}} نفر هستند",

    // 1️⃣ Home -> last like
    lastLike: "آخرین لایک‌ها",
    // 1️⃣ Home -> last message
    lastMessage: "آخرین پیام‌ها",
    lastOrder: "آخرین سفارشات",
    lastTransaction: "آخرین تراکنش‌ها",
    // 1️⃣ Home -> last follower
    LastFollowers: "آخرین فالورها",
    // #endregion home Section      // #region 2️⃣page Section
    // 2️⃣ Page -> Post
    SmartPageAnalysis: "آنالیز هوشمند پیج",
    EducationAndGuidance: "آموزش و راهنمایی",
    HowToUseBrancy: "نحوه کار با برنسی",
    CreateYourDigitalVersion: "ساخت نسخه دیجیتال شما",
    BrancyKnowsYou: "برنسی، شما را می‌شناسد",
    BrancyKnowsYouExplain:
      "برنسی با تحلیل عمیق پیج شما، یک تصویر کامل از هویت دیجیتال شما می‌سازد؛ از شخصیت، کسب‌وکار و فعالیت‌های شما گرفته تا لحن و سبک ارتباطی، نوع محتوا، نحوه ارائه مطالب، زمان‌بندی انتشار و شیوه تعامل با مخاطبین.\n\nاین تحلیل، نحوه فعالیت شما در تمام نقاط ارتباطی پیج را نیز در نظر می‌گیرد؛ از پاسخ‌گویی به کامنت‌ها و دایرکت‌ها گرفته تا سبک نوشتار، نوع برخورد با مخاطبین و واکنش به موقعیت‌های مختلف.\n\nبدون نیاز به آموزش دستی، تنظیم لحن یا وارد کردن اطلاعات اضافی؛ برنسی شما را می‌شناسد و هوش مصنوعی را بر اساس هویت و سبک واقعی شما هماهنگ می‌کند.",
    CreateNewPost: "ایجاد پست جدید",
    Postnotvisible: "پست نمایش داده نمی‌شود؟",
    Storynotvisible: "استوری نمایش داده نمی‌شود؟",
    CreateNewStrory: "ایجاد استوری جدید",
    PostDraft: "پیش‌نویس پست",
    StoryDraft: "پیش‌نویس استوری",
    publishError: "خطا در انتشار",
    DeletedPost: "پست حذف شده",
    errorDraft_title: "خطایی در انتشار پست رخ داد",
    errorDraft_configFailed: "تنظیمات انتشار پست نادرست است، لطفاً بررسی و اصلاح کنید.",
    errorDraft_invalidTags: "تگ‌های نامعتبر: ",
    errorDraft_unknown: "خطای ناشناخته! لطفاً مجدداً تلاش کنید.",
    errorDraft_uploadError: "آپلود تصویر ناموفق بود، لطفاً دوباره امتحان کنید.",
    errorDraft_userCancel: "انتشار پست توسط شما لغو شد.",
    InvalidAspectRatio: "نسبت ابعاد نامعتبر است",
    SizeLimitExceed: "حجم فایل از حد مجاز بیشتر است",
    UnSupportMediaType: "نوع مدیا پشتیبانی نمی‌شود",
    NotPublishedAtTheTime: "پست در زمان انتخاب‌شده منتشر نشده است",
    NotSuccessLogin: "ورود با موفقیت انجام نشد",

    NewScheduledPost: "پست زمان‌بندی‌شده جدید",
    thereAreNoPost: "هنوز پست زمان‌بندی‌شده‌ای نساخته‌اید",
    ScheduledPost: "پست زمان‌بندی‌شده",
    // 2️⃣ Page -> story
    pageStory_CreateNewStory: "ایجاد استوری جدید",
    pageStory_CreateNewStories: "استوری زمان‌بندی‌شده جدید",
    pageStory_thereAreNoStories: "هنوز استوری زمان‌بندی‌شده‌ای نساخته‌اید",
    pageStory_ScheduledStories: "استوری زمان‌بندی‌شده",
    // 2️⃣ Page -> highlight
    pageStory_highlightManagement: "مدیریت هایلایت‌ها",
    pageStory_thereAreNoHighlight: "هایلایت وجود ندارد",
    pageStory_HighlightTitle: "هایلایت‌ها / پوشه‌ها",
    // 3️⃣ Page -> statistics
    pageStatistics_YourBestFollowers: "بهترین فالوورهایتان",
    pageStatistics_YourBestFollowersExplain:
      "محاسبه بر اساس مجموع امتیاز کل تعامل در صفحه (شامل لایک‌ها، کامنت‌ها و اشتراک‌گذاری‌ها).",
    pageStatistics_LoadMore: "بارگذاری بیشتر",
    pageStatistics_UnFollowers: "آنفالوورها",
    pageStatistics_Followers: "فالوورها",
    pageStatistics_NewFollowers: "فالوورهای جدید",
    pageStatistics_ActiveFollowers: "مخاطبین فعال",
    pageStatistics_MediaFollows: "فالو از محتوا",
    pageStatistics_Reach: "ریچ",
    pageStatistics_ProfileVisit: "بازدید پروفایل",
    pageStatistics_30Days: "۳۰ روز",
    pageStatistics_60Days: "۶۰ روز",
    pageStatistics_90Days: "۹۰ روز",
    pageStatistics_120Days: "۱۲۰ روز",
    pageStatistics_WorstTime: "بدترین زمان",
    pageStatistics_BestTime: "بهترین زمان",
    pageStatistics_likes: "لایک‌ها",
    pageStatistics_Engagements: "نرخ تعامل",
    pageStatistics_Impression: "ایمپریشن",
    pageStatistics_Views: "بازدید",
    pageStatistics_RePosts: "بازنشرها",
    pageStatistics_followerViews: "فالوورهای بازدیدکننده",
    pageStatistics_ghostViewers: "بازدیدکنندگان مخفی(روح)",
    pageStatistics_Comments: "کامنت‌ها",
    pageStatistics_Shares: "اشتراک‌گذاری",
    pageStatistics_summary: "خلاصه",
    pageStatistics_EmptyList: "!هنوز داده‌ای وجود ندارد",
    pageStatistics_from: "نسبت به",
    pageStatistics_post: "پست‌ها",
    pageStatistics_stories: "استوری‌ها",
    pageStatistics_MaxView: "بیشترین بازدید",
    pageStatistics_MinView: "کمترین بازدید",
    pageStatistics_MaxCommentLike: "بیشترین کامنت و لایک",
    pageStatistics_MinCommentLike: "کمترین کامنت و لایک",
    pageStatistics_PostTimeAnalysis: "تحلیل زمان پست گذاری",
    pageStatistics_Rate: "نرخ",
    pageStatistics_RateExplain: "بر اساس بالاترین تعداد کامنت دریافت‌شده در کل صفحه",

    pageStatistics_24HourHeatmap: "نقشه حرارتی 24 ساعته",
    pageStatistics_Low: "کم",
    pageStatistics_High: "زیاد",
    pageStatistics_TopHour: "ساعت برتر",
    pageStatistics_WeakHour: "ساعت ضعیف",
    pageStatistics_AverageHour: "ساعت متوسط",
    pageStatistics_TopMinute: "دقیقه برتر",
    pageStatistics_WeakMinute: "دقیقه ضعیف",
    pageStatistics_AverageMinute: "دقیقه متوسط",
    pageStatistics_HourExcellentLevel:
      "این ساعت در سطح عالی تعامل قرار دارد (بالاتر از 80% ظرفیت). تعاملات در این بازه زمانی {{percentage}}% بیشتر از میانگین است و برای انتشار محتوای مهم بسیار مناسب می‌باشد.",
    pageStatistics_HourGoodLevel:
      "این ساعت در سطح خوب تعامل قرار دارد (60-80% ظرفیت). تعاملات در این بازه {{percentage}}% بالاتر از میانگین است. برای انتشار محتوای معمولی مناسب می‌باشد.",
    pageStatistics_HourAverageLevel:
      "این ساعت در سطح متوسط تعامل قرار دارد (40-60% ظرفیت). برای نتایج بهتر، ساعات با شدت بالاتر (رنگ سبز) را امتحان کنید. اختلاف با بهترین زمان: {{difference}}%.",
    pageStatistics_HourWeakLevel:
      "این ساعت در سطح ضعیف تعامل قرار دارد (20-40% ظرفیت). انتشار در ساعات با شدت بالاتر توصیه می‌شود.",
    pageStatistics_HourVeryWeakLevel:
      "این ساعت در سطح بسیار ضعیف تعامل قرار دارد (زیر 20% ظرفیت). تعاملات در این بازه پایین‌تر از حد انتظار است و توصیه نمی‌شود.",
    pageStatistics_MinuteTopDescription:
      "این دقیقه در بین 10 دقیقه برتر ساعت {{hour}}:00 قرار دارد. برای حداکثر تعامل، انتشار دقیقاً در این زمان توصیه می‌شود. اختلاف با ضعیف‌ترین دقیقه: {{difference}}%.",
    pageStatistics_MinuteWeakDescription:
      "تعامل در این دقیقه پایین است. انتشار در دقایق ابتدایی یا میانی ساعت می‌تواند نتایج بهتری به همراه داشته باشد. اختلاف با بهترین دقیقه: {{difference}}%.",
    pageStatistics_MinuteAverageDescription:
      "تعامل در حد معمول است. برای بهینه‌سازی بیشتر، دقایق با رتبه بالاتر در این ساعت را بررسی کنید.",
    pageStatistics_PeakEngagement: "بیشترین تعامل",
    pageStatistics_StableGrowth: "رشد پایدار",
    pageStatistics_HighEngagementProbability: "احتمال تعامل بالا",
    pageStatistics_LowestEngagement: "کمترین تعامل لحظه‌ای",
    pageStatistics_SustainedLowPeriod: "دوره ضعیف پایدار",
    pageStatistics_LowEngagementProbability: "احتمال تعامل پایین",
    pageStatistics_BestTimes: "بهترین زمان‌ها",
    pageStatistics_WorstTimes: "بدترین زمان‌ها",
    pageStatistics_EngagementPrediction: "پیش‌بینی تعامل",
    pageStatistics_PeakTimeDescription:
      "بیشترین میزان تعامل در این لحظه وجود دارد. برای حداکثر دسترسی به مخاطبان این ساعت توصیه می‌شود.",
    pageStatistics_StableTimeDescription:
      "از این زمان تعامل شروع به رشد کرده و در میانگین بالا باقی مانده است. برای تعامل پایدار مناسب است.",
    pageStatistics_SecondaryTimeDescription: "می‌توان انتظار داشت انتشار در این زمان نتایج خوبی به همراه داشته باشد.",
    pageStatistics_LowestTimeDescription:
      "کمترین میزان تعامل لحظه‌ای در این زمان است. انتشار در این ساعت {{percentage}}% از تعامل بالقوه را از دست می‌دهد.",
    pageStatistics_SustainedLowTimeDescription:
      "از این زمان تعامل شروع به کاهش کرده و برای مدتی در سطح پایین می‌ماند. برای انتشار مناسب نیست.",
    pageStatistics_SecondaryLowTimeDescription:
      "لحظه ضعیف دیگری با احتمال پایین تعامل. انتشار در این زمان توصیه نمی‌شود.",
    pageStatistics_HourEngagementTooltip: "{{hour}}:00 - {{count}} تعامل ({{percentage}}%)",
    pageStatistics_MinuteEngagementTooltip: "{{hour}}:{{minute}} - {{count}} تعامل",
    // statistics suggestions box

    Statistics_UnFollowers_up_title: "کاهش آنفالور 💡وقتشه استراتژی نگهداشت رو تقویت کنی",
    Statistics_UnFollowers_up_summary: "ریزش کمتر شده و یعنی محتوای اخیر جواب داده. همین مسیر رو دقیق‌تر ادامه بده.",
    Statistics_UnFollowers_up_action1: "سه پست آخر رو از نظر کاور، جمله اول و CTA آنالیز کن.",
    Statistics_UnFollowers_up_action2: "یه تقویم هفتگی روی همین فرمت‌ها ببند و تغییرات رو ثبت کن.",
    Statistics_UnFollowers_up_action3: "برای فالورهای جدید یه استوری خوش‌آمد و یه هایلایت مرتب بساز.",
    Statistics_UnFollowers_up_urgency: "متوسط",

    Statistics_UnFollowers_neutral_title: "ریزش ثابت 💡قبل هر تغییری از خود کاربر دیتا بگیر",
    Statistics_UnFollowers_neutral_summary:
      "رفتار مخاطب تغییری نکرده؛ باید مستقیم نظرشون رو بسنجی و تست‌های کوتاه انجام بدی.",
    Statistics_UnFollowers_neutral_action1: "یه نظرسنجی استوری بذار و بپرس چی براشون جذاب‌تره.",
    Statistics_UnFollowers_neutral_action2: "هفته‌ای یه پست با فرمت ثابت منتشر کن و نتایج رو مقایسه کن.",
    Statistics_UnFollowers_neutral_action3: "سه مشکل پرتکرار کامنت‌ها رو جمع کن و برای هرکدوم یه پست حل‌مسئله بساز.",
    Statistics_UnFollowers_neutral_urgency: "کم",

    Statistics_UnFollowers_down_title: "افزایش آنفالور 💡باید سریع اصلاح کنی",
    Statistics_UnFollowers_down_summary:
      "صعود آنفالور یعنی یک سیگنال منفی در محتوا یا ریتم انتشار وجود داره؛ نیاز به تست و واکنش سریع داری.",
    Statistics_UnFollowers_down_action1: "داده ۷ روز اخیر رو چک کن و دو پستی که بیشترین آنفالور داشتن رو مشخص کن.",
    Statistics_UnFollowers_down_action2: "یک پست صادقانه یا پشت‌صحنه منتشر کن و دلیل رو مستقیم از مخاطب بپرس.",
    Statistics_UnFollowers_down_action3: "یک استوری سؤال باز بذار «چرا آنفالو کردی؟» و جواب‌ها رو دسته‌بندی کن.",
    Statistics_UnFollowers_down_urgency: "زیاد",

    Statistics_UnFollowers_zero_title: "هیچ فعالیتی ثبت نشده 💡دیتایی برای تحلیل نیست",
    Statistics_UnFollowers_zero_summary:
      "به‌خاطر نبود فعالیت، هیچ سیگنالی برای بررسی ساخته نشده؛ باید چرخه انتشار رو دوباره فعال کنی.",
    Statistics_UnFollowers_zero_action1: "یک پست ارزش‌محور منتشر کن تا اولین سیگنال رفتاری ساخته بشه.",
    Statistics_UnFollowers_zero_action2: "دو استوری تعامل‌محور بذار (Poll یا Question) تا ری‌اکشن اولیه بگیری.",
    Statistics_UnFollowers_zero_action3: "یک پست کوتاه معرفی یا آپدیت بده تا بازدید طبیعی شروع بشه.",
    Statistics_UnFollowers_zero_urgency: "زیاد",

    Statistics_Followers_up_title: "افزایش فالورها 💡ورودی‌ها رو درست خوش‌آمد بگو",
    Statistics_Followers_up_summary:
      "جذب رو به بالاست؛ از همون لحظه ورود باید تجربه مثبت براشون بسازی تا تبدیل به فالوور فعال بشن.",
    Statistics_Followers_up_action1: "یه هایلایت خوش‌آمد بساز با فرمت «چی پیدا می‌کنی و چی کمکت می‌کنه».",
    Statistics_Followers_up_action2: "دو همکاری یا منشن سبک برنامه‌ریزی کن تا جذب ادامه‌دار و باکیفیت بمونه.",
    Statistics_Followers_up_action3: "کیفیت فالورها رو از طریق آمار کمپین و ورودی ریلزها بررسی کن.",
    Statistics_Followers_up_urgency: "متوسط",

    Statistics_Followers_neutral_title: "رشد یکنواخت 💡وقت تست‌های کوتاهه",
    Statistics_Followers_neutral_summary: "رشد پیج ثابت مونده؛ باید با تست‌های ۷ روزه بفهمی چه چیز روی جذب تأثیر داره.",
    Statistics_Followers_neutral_action1: "یه تست ۷ روزه روی هشتگ، زمان انتشار و کاورهای مختلف اجرا کن.",
    Statistics_Followers_neutral_action2: "نتایج رو ثبت کن و بهترین ترکیب رو به یه فرمت ثابت تبدیل کن.",
    Statistics_Followers_neutral_action3:
      "یه ویدیوی معرفی کوتاه منتشر کن تا ورودی‌ها سریع بفهمن چی انتظارشون رو می‌کشه.",
    Statistics_Followers_neutral_urgency: "متوسط",

    Statistics_Followers_down_title: "افت جذب 💡احتمالا محتوای اخیر با پرسونا نمی‌خونه",
    Statistics_Followers_down_summary: "کاهش جذب یعنی سیگنال ناهماهنگی بین محتوای فعلی و مخاطب هدفت.",
    Statistics_Followers_down_action1: "سه اختلاف بین پرسونا و محتوای اخیر رو پیدا کن و اصلاحشون کن.",
    Statistics_Followers_down_action2: "بیو، CTA و کاور چند پست اخیر رو سریع بازنویسی و تست کن.",
    Statistics_Followers_down_action3: "یه کمپین کوچک همکاری یا UGC اجرا کن تا تصویر پیج دوباره فعال بشه.",
    Statistics_Followers_down_urgency: "زیاد",

    Statistics_Followers_zero_title: "هیچ فعالیت اخیری نبوده 💡دیتای جذب ساخته نشده",
    Statistics_Followers_zero_summary:
      "به‌خاطر نبود انتشار یا اقدام جذب، هیچ سیگنالی برای تحلیل وجود نداره؛ باید چرخه جذب رو دوباره فعال کنی.",
    Statistics_Followers_zero_action1: "پنج ریلز کوتاه با قلاب ۳ ثانیه‌ای منتشر کن تا اولین ورودی‌ها ساخته بشن.",
    Statistics_Followers_zero_action2: "یه پست معرفی یا آپدیت بده تا بازدید اولیه شکل بگیره.",
    Statistics_Followers_zero_action3: "یه کمپین جذب کوچیک (حتی لوکال) اجرا کن تا روند جذب دوباره راه بیفته.",
    Statistics_Followers_zero_urgency: "زیاد",

    Statistics_MediaFollows_up_title: "جذب از اکسپلور بالا رفته 💡سری‌سازی بهترین راهه",
    Statistics_MediaFollows_up_summary: "ارجاع و ورودی بیرونی داری؛ همون فرمت‌های موفق رو تبدیل به یک سری منظم کن.",
    Statistics_MediaFollows_up_action1: "فرمت موفق رو به ۳ تا ۵ قسمت تبدیل کن با CTA مشترک در همه قسمت‌ها.",
    Statistics_MediaFollows_up_action2: "یه کاور ثابت و زمان‌بندی منظم انتخاب کن تا مخاطب به ادامه سری عادت کنه.",
    Statistics_MediaFollows_up_action3: "توزیع روزهای اول رو رصد کن و روی منبعی که سریع جذب می‌ده تمرکز بذار.",
    Statistics_MediaFollows_up_urgency: "متوسط",

    Statistics_MediaFollows_neutral_title: "ارجاع متوسط 💡وقت A/B روی کاور و منبعه",
    Statistics_MediaFollows_neutral_summary: "برای بیشتر شدن ورودی اکسپلور، کاور و منبع ارجاع باید بهینه‌تر شن.",
    Statistics_MediaFollows_neutral_action1: "دو کاور A/B منتشر کن و عملکرد ۴۸ ساعتشون رو مقایسه کن.",
    Statistics_MediaFollows_neutral_action2: "منابعی که بیشترین ورودی دادن رو لیست کن و دوباره هدف‌گیری کن.",
    Statistics_MediaFollows_neutral_action3: "یه بانک از فرمت‌های موفق بساز تا تکرارشون راحت باشه.",
    Statistics_MediaFollows_neutral_urgency: "کم",
    Statistics_MediaFollows_down_title: "افت جذب از اکسپلور 💡محتوای جذاب‌تر لازمه",
    Statistics_MediaFollows_down_summary: "برای جذب از اکسپلور، محتوای کاربردی‌تر یا قابل‌دانلود تأثیر بیشتری داره.",
    Statistics_MediaFollows_down_action1: "یه PDF یا چک‌لیست قابل‌دانلود بساز و لینک بده برای اشتراک‌گذاری راحت‌تر.",
    Statistics_MediaFollows_down_action2: "محتوای آموزشی کوتاه منتشر کن و روش تبلیغ هدفمند تست کن.",
    Statistics_MediaFollows_down_action3: "لینک‌ها و مسیرهای ارجاع رو از نظر فنی چک کن که خراب نباشن.",
    Statistics_MediaFollows_down_urgency: "زیاد",

    Statistics_MediaFollows_zero_title: "هیچ فعالیتی نبوده 💡سیگنال اکسپلور ساخته نشده",
    Statistics_MediaFollows_zero_summary:
      "به‌خاطر نبود انتشار یا اقدام جذب، هیچ دیتایی برای تحلیل نیست؛ اول باید چرخه تولید رو فعال کنی.",
    Statistics_MediaFollows_zero_action1: "تداوم توی ساخت و انتشار محتوای جذاب برای کاربران رو شروع کن.",
    Statistics_MediaFollows_zero_action2: "پنج محتوای کوتاه روزانه منتشر کن تا اولین سیگنال‌های ارجاع شکل بگیره.",
    Statistics_MediaFollows_zero_action3: "روز اول یه پست تقویتی بذار تا ورودی اولیه ایجاد بشه.",
    Statistics_MediaFollows_zero_urgency: "زیاد",

    Statistics_Reach_up_title: "Reach رشد کرده 💡وقت مقیاسه",
    Statistics_Reach_up_summary: "دسترسی بالا رفته؛ بهترین فرمت‌ها رو تکرار کن تا موج رشد ادامه پیدا کنه.",
    Statistics_Reach_up_action_1: "دو تا از بالاترین فرمت‌های Reach رو در زمان اوج دوباره منتشر کن.",
    Statistics_Reach_up_action_2: "هشتگ‌های موثر رو ثابت کن و همیشه داخل کپشن قرار بده.",
    Statistics_Reach_up_action_3: "پست‌هایی بساز که قابلیت اشتراک‌گذاری بالا دارن تا Reach ارگانیک بیشتر شه.",
    Statistics_Reach_up_urgency: "متوسط",

    Statistics_Reach_neutral_title: "Reach ثابت مونده 💡نیاز به تست داری",
    Statistics_Reach_neutral_summary: "برای خروج از حالت سکون، همکاری سبک یا تست هشتگ بهترین گزینه‌ست.",
    Statistics_Reach_neutral_action_1: "یه کراس‌پست با یک پیج هم‌حوزه هماهنگ کن.",
    Statistics_Reach_neutral_action_2: "دو ریلز آموزشی یا سرگرمی منتشر کن و بازخوردش رو ارزیابی کن.",
    Statistics_Reach_neutral_action_3: "لیست هفتگی هشتگ‌ها رو چک کن و بهترین ترکیب رو پیدا کن.",
    Statistics_Reach_neutral_urgency: "کم",

    Statistics_Reach_down_title: "افت Reach 💡باید سریع واکنش بدی",
    Statistics_Reach_down_summary: "دسترسی پایین اومده؛ محتوای اشتراک‌پذیر و تست‌های کوتاه‌مدت اولویت هستن.",
    Statistics_Reach_down_action_1: "یه تست ۷روزه روی ریلزهای پتانسیل‌دار اجرا کن.",
    Statistics_Reach_down_action_2: "پست‌های اشتراک‌پذیر بساز و با یک تبلیغ کوتاه تقویتشون کن.",
    Statistics_Reach_down_action_3: "عنوان، کاور و هشتگ‌ها رو بازنویسی کن و پست رو دوباره منتشر کن.",
    Statistics_Reach_down_urgency: "زیاد",

    Statistics_Reach_zero_title: "Reach ثبت نشده 💡فعالیت کم بوده",
    Statistics_Reach_zero_summary:
      "به‌خاطر نبود انتشار یا سیگنال کافی، دیتایی برای Reach ساخته نشده؛ چرخه محتوا باید فعال شه.",
    Statistics_Reach_zero_action_1: "اتصال داده‌برداری (API/logs) رو چک کن که درست کار کنه.",
    Statistics_Reach_zero_action_2: "۵ ریلز ترندی منتشر کن و یکی رو از روز دوم تقویت کن.",
    Statistics_Reach_zero_action_3: "سیستم یا برنامه زمان‌بندی انتشار رو تست و در صورت نیاز ری‌ست کن.",
    Statistics_Reach_zero_urgency: "زیاد",

    Statistics_ProfileVisit_up_title: "بازدید پروفایل بالاست 💡تمرکز روی تبدیل",
    Statistics_ProfileVisit_up_summary:
      "ورودی خوب داری؛ بیو و CTA باید سریع بهینه بشن تا بازدیدها به فالو و کلیک تبدیل بشن.",
    Statistics_ProfileVisit_up_action_1: "بیو رو با یک ارزش پیشنهادی واضح و یک CTA مستقیم بازنویسی کن.",
    Statistics_ProfileVisit_up_action_2: "هایلایت‌های شاخص بساز تا کاربر بفهمه چی دیده و چی منتظرشه.",
    Statistics_ProfileVisit_up_action_3: "یک پست با پیشنهاد ویژه منتشر کن تا نرخ کلیک روی لینک بالا بره.",
    Statistics_ProfileVisit_up_urgency: "زیاد",

    Statistics_ProfileVisit_neutral_title: "بازدید هست، تبدیل نه 💡لید بساز",
    Statistics_ProfileVisit_neutral_summary:
      "ورود داری ولی تبدیل پایین مونده؛ یک لید مغناطیسی می‌تونه جریان رو تغییر بده.",
    Statistics_ProfileVisit_neutral_action_1: "یک فایل رایگان یا چک‌لیست داخل هایلایت قرار بده.",
    Statistics_ProfileVisit_neutral_action_2: "کپشن‌ها رو با CTA مرتبط با پروفایل تقویت کن.",
    Statistics_ProfileVisit_neutral_action_3: "استوری‌های دعوت‌کننده و هدایت‌کننده به پروفایل رو بیشتر کن.",
    Statistics_ProfileVisit_neutral_urgency: "متوسط",

    Statistics_ProfileVisit_down_title: "افت بازدید 💡قلاب قوی‌تر لازم داری",
    Statistics_ProfileVisit_down_summary: "کنجکاوی کمتر شده؛ شروع کپشن‌ها و CTA باید جذاب‌تر و شفاف‌تر باشه.",
    Statistics_ProfileVisit_down_action_1: "کپشن‌هارو با قلاب ۳ تا ۵ کلمه‌ای بازنویسی کن.",
    Statistics_ProfileVisit_down_action_2: "استوری هدایت‌کننده بذار و لینک رو بولد کن.",
    Statistics_ProfileVisit_down_action_3: "یک پست دعوت‌کننده منتشر کن که کاربران رو به بازدید پروفایل ترغیب کنه.",
    Statistics_ProfileVisit_down_urgency: "زیاد",

    Statistics_ProfileVisit_zero_title: "بازدید ثبت نشده 💡فعالیت کافی نبوده",
    Statistics_ProfileVisit_zero_summary:
      "به‌خاطر نبود انتشار یا سیگنال کافی، بازدید پروفایل ثبت نشده؛ چرخه‌ی جذب باید دوباره فعال بشه.",
    Statistics_ProfileVisit_zero_action_1: "وضعیت اکانت رو چک کن که روی public باشه.",
    Statistics_ProfileVisit_zero_action_2: "یک پست دعوت‌کننده با CTA واضح منتشر کن.",
    Statistics_ProfileVisit_zero_action_3: "هایلایت‌های مهم رو آپدیت کن تا اولین سیگنال بازدید ساخته بشه.",
    Statistics_ProfileVisit_zero_urgency: "زیاد",

    Statistics_Likes_up_title: "لایک‌ها خوبه 💡عادت‌سازی کن",
    Statistics_Likes_up_summary: "کاربر لایک می‌کنه؛ حالا هدف تبدیل این رفتار به عادتِ ثابت باشه.",
    Statistics_Likes_up_action_1: "فرمت‌های موفق (کاور، تمپلیت، طول) رو مستندسازی کن.",
    Statistics_Likes_up_action_2: "در انتهای پست یک CTA ساده برای لایک بذار (مثلاً 'اگر موافقی ❤').",
    Statistics_Likes_up_action_3: "یک A/B کوچک برای کاور و ۳ ثانیه اول اجرا کن.",
    Statistics_Likes_up_urgency: "متوسط",

    Statistics_Likes_neutral_title: "لایک قابل‌افزایشه 💡قلاب و کاور رو بهتر کن",
    Statistics_Likes_neutral_summary: "پتانسیل هست؛ با تغییر کاور و قلاب می‌تونی نرخ لایک رو بالا ببری.",
    Statistics_Likes_neutral_action_1: "کاور و ۳ ثانیه اول رو بهینه کن و تست کن.",
    Statistics_Likes_neutral_action_2: "از CTAهای احساسی یا پرسشی برای دعوت به لایک استفاده کن.",
    Statistics_Likes_neutral_action_3: "یک نظرسنجی کوچک برای فهم سلیقهٔ بصری مخاطب اجرا کن.",
    Statistics_Likes_neutral_urgency: "کم",

    Statistics_Likes_down_title: "لایک افت کرده 💡هویت بصری رو بازطراحی کن",
    Statistics_Likes_down_summary: "ممکنه پیام یا تصویر قوی نباشه؛ روی اولین لحظه محتوا کار کن.",
    Statistics_Likes_down_action_1: "کاور و جملهٔ اول کپشن رو بازنویسی کن.",
    Statistics_Likes_down_action_2: "یک تست A/B برای رنگ/طرح کاور اجرا کن.",
    Statistics_Likes_down_action_3: "پست‌های بصری قوی و مرتبط منتشر کن.",
    Statistics_Likes_down_urgency: "زیاد",

    Statistics_Likes_zero_title: "لایک صفر 💡یا دیتا نیست یا محتوا نیست",
    Statistics_Likes_zero_summary: "اگر محتوا هست اما لایک ثبت نشده، دیتا رو چک کن؛ وگرنه شروع به تولید کن.",
    Statistics_Likes_zero_action_1: "صحت ثبت آمار رو بررسی کن.",
    Statistics_Likes_zero_action_2: "اگر محتوا نداریم، چند پست با کاور قوی بذار.",
    Statistics_Likes_zero_action_3: "از شبکه‌های همکار برای گرفتن بازخورد استفاده کن.",
    Statistics_Likes_zero_urgency: "زیاد",

    Statistics_Comments_up_title: "کامنت زیاد شده 💡گفتگو رو جدی بگیر",
    Statistics_Comments_up_summary: "مردم صحبت می‌کنند؛ با پاسخ و تبدیل نظرات به محتوا ازشون استفاده کن.",
    Statistics_Comments_up_action1: "به نظرات پاسخ بده و ۳ ایدهٔ برتر رو به پست تبدیل کن.",
    Statistics_Comments_up_action2: "به بهترین کامنت‌ها اشاره کن یا استوری‌شون کن.",
    Statistics_Comments_up_action3: "در کپشن سوالی بذار که مردم رو وادار به جواب کنه.",
    Statistics_Comments_up_urgency: "متوسط",

    Statistics_Comments_neutral_title: "کامنت کمه 💡محرک بذار",
    Statistics_Comments_neutral_summary: "برای داشتن گفتگو، سوال‌های ساده و مستقیم بذار.",
    Statistics_Comments_neutral_action1: "در انتهای پست یک سوال باز بذار.",
    Statistics_Comments_neutral_action2: "به ۵ کامنت اول سریع پاسخ بده تا بقیه ترغیب شن.",
    Statistics_Comments_neutral_action3: "یک چالش یا رأی‌گیری کوتاه اجرا کن.",
    Statistics_Comments_neutral_urgency: "کم",

    Statistics_Comments_down_title: "کامنت کم شده 💡محرک‌های واضح بذار",
    Statistics_Comments_down_summary: "نیاز به CTAها و دعوت مستقیم داری تا مکالمه راه بیفته.",
    Statistics_Comments_down_action1: "یک چالش یا درخواست تجربه شخصی منتشر کن.",
    Statistics_Comments_down_action2: "در کپشن CTA صریح برای کامنت بذار (مثلاً 'نظر تو چیه؟').",
    Statistics_Comments_down_action3: "نسبت به نظرات اولیه سریع واکنش نشون بده.",
    Statistics_Comments_down_urgency: "زیاد",

    Statistics_Comments_zero_title: "بدون کامنت 💡دعوت‌کننده باش",
    Statistics_Comments_zero_summary: "محتوا طوری نیست که آدم بخواد نظر بده؛ فرمت‌ها رو دعوت‌کننده کن.",
    Statistics_Comments_zero_action1: "سوال‌های ساده و جذاب طراحی کن (مثلاً انتخاب بین دو گزینه).",
    Statistics_Comments_zero_action2: "به اولین کامنت‌ها سریع پاسخ بده تا بقیه تشویق شن.",
    Statistics_Comments_zero_action3: "از CTAهای مستقیم برای نظر دادن استفاده کن.",
    Statistics_Comments_zero_urgency: "زیاد",

    Statistics_Views_up_title: "ویوها بالا رفته 💡از ترافیک استفاده کن",
    Statistics_Views_up_summary: "دید ویدیوها خوبه؛ از انتهای ویدیو برای هدایت استفاده کن (پروفایل/ذخیره).",
    Statistics_Views_up_action1: "در انتهای ویدیو یک CTA مشخص بذار (مثلاً 'برای بیشتر ذخیره کن').",
    Statistics_Views_up_action2: "لینک محتوای تکمیلی رو توی بیو یا هایلایت قرار بده.",
    Statistics_Views_up_action3: "نسخهٔ کوتاه‌تر یا تیزر تولید کن و منتشر کن.",
    Statistics_Views_up_urgency: "متوسط",

    Statistics_Views_neutral_title: "ویو ثابت 💡قلاب و کاور رو تقویت کن",
    Statistics_Views_neutral_summary: "روی ۳ ثانیه اول و کاور کار کن تا نرخ مشاهده بهتر بشه.",
    Statistics_Views_neutral_action1: "قلاب شروع و کاور رو بازنویسی کن.",
    Statistics_Views_neutral_action2: "یک نسخه کوتاه‌تر برای تست منتشر کن.",
    Statistics_Views_neutral_action3: "از مخاطب بازخورد بصری بگیر.",
    Statistics_Views_neutral_urgency: "کم",

    Statistics_Views_down_title: "ویو افت کرده 💡قلاب رو قوی‌تر کن",
    Statistics_Views_down_summary: "ابتدای ویدیو ضعیفه؛ تست نسخه‌های کوتاه و جذاب رو شروع کن.",
    Statistics_Views_down_action1: "۵ ویدیوی 15 ثانیه‌ای با قلاب قوی تولید کن.",
    Statistics_Views_down_action2: "ابتدای ویدیو رو بازنویسی و A/B تست کن.",
    Statistics_Views_down_action3: "سرعت ادیت رو بالا ببر تا توجه حفظ بشه.",
    Statistics_Views_down_urgency: "زیاد",

    Statistics_Views_zero_title: "ویو صفر؟ 💡هرچه سریع تر محتوا منتشر کن",
    Statistics_Views_zero_summary: "در اولین فرصت سعی کن تولید محتوا رو سریعا شروع کنی",
    Statistics_Views_zero_action1: "با تحلیل روند کاری پیج فقط شروع کن.",
    Statistics_Views_zero_action2: "اگر ویدیو منتشر نشده، ۳ ریلز کوتاه تولید کن.",
    Statistics_Views_zero_action3: "یک پست تقویتی اجرا کن تا نمایش اولیه ایجاد بشه.",
    Statistics_Views_zero_urgency: "زیاد",

    Statistics_FollowerViews_up_title: "فالوورها می‌بینن 💡تعامل داخلی بساز",
    Statistics_FollowerViews_up_summary: "فالورها فعالن؛ ازشون برای تعامل داخلی استفاده کن (AMA، نظرسنجی).",
    Statistics_FollowerViews_up_action1: "توی استوری از فالورها سؤال بپرس یا رأی‌گیری بذار.",
    Statistics_FollowerViews_up_action2: "برای فالورها محتوای اختصاصی منتشر کن (مثل AMA).",
    Statistics_FollowerViews_up_action3: "فرمت‌هارو با پرسونا چک کن تا دقیقتر روی سلیقه‌شون بشینه.",
    Statistics_FollowerViews_up_urgency: "متوسط",

    Statistics_FollowerViews_neutral_title: "ویو توسط فالورها معمولیه 💡زمان‌بندی و فرمت رو تست کن",
    Statistics_FollowerViews_neutral_summary:
      "ممکنه زمان انتشار یا نوع محتوا نیاز به تغییر داشته باشه؛ تست‌های ساده انجام بده.",
    Statistics_FollowerViews_neutral_action1: "زمان انتشار رو جابه‌جا کن و تاثیرش رو ثبت کن.",
    Statistics_FollowerViews_neutral_action2: "یک فرمت جدید مخصوص فالورها تست کن.",
    Statistics_FollowerViews_neutral_action3: "براساس رفتار قبلی مخاطب محتوا رو شخصی‌سازی کن.",
    Statistics_FollowerViews_neutral_urgency: "کم",

    Statistics_FollowerViews_down_title: "ویو توسط فالورها کم شده 💡بازخورد بگیر",
    Statistics_FollowerViews_down_summary: "احتمال فاصله گرفتن از پرسونا هست؛ بازخورد جمع کن و سریع ۳ تغییر اجرا کن.",
    Statistics_FollowerViews_down_action1: "بازخوردهای اخیر رو جمع کن و سه تغییر سریع اعمال کن.",
    Statistics_FollowerViews_down_action2: "استوری‌های تحریک‌کننده بذار تا مخاطب دوباره فعال شه.",
    Statistics_FollowerViews_down_action3: "نسخه‌های شخصی‌سازی‌شده رو تست کن.",
    Statistics_FollowerViews_down_urgency: "زیاد",

    Statistics_FollowerViews_zero_title: "ویو توسط فالورها صفر 💡اول مطمئن شو فالور فعالی هست",
    Statistics_FollowerViews_zero_summary: "احتمالاً فالور فعال کم داری؛ اول بیدارسازی و بعد تعامل.",
    Statistics_FollowerViews_zero_action1: "چند استوری و پست برای بیدار کردن مخاطب منتشر کن.",
    Statistics_FollowerViews_zero_action2: "با ۱۰ فالور فعال تعامل مستقیم داشته باش.",
    Statistics_FollowerViews_zero_action3: "بر اساس علایق قبلی محتوا تولید کن.",
    Statistics_FollowerViews_zero_urgency: "زیاد",

    Statistics_NonFollowerViews_up_title: "ویو توسط غیرفالورها بالا 💡فرصت جذب جدید",
    Statistics_NonFollowerViews_up_summary:
      "آدم‌هایی خارج از فالورها دارن می‌بینن؛ هر پست باید یک دلیل محکم برای فالو داشته باشه.",
    Statistics_NonFollowerViews_up_action1: "توی کپشن یک دلیل جدی برای فالو بذار (مثل سری‌سازی یا آموزش‌های مرحله‌ای).",
    Statistics_NonFollowerViews_up_action2: "ریلز ترندی و جذب‌کن طراحی کن تا غیرفالورها وارد حلقه تعامل شن.",
    Statistics_NonFollowerViews_up_action3: "از هشتگ هدفمند و همکاری‌های مرتبط استفاده کن.",
    Statistics_NonFollowerViews_up_urgency: "متوسط",

    Statistics_NonFollowerViews_neutral_title: "ویو توسط غیرفالورها ثابته 💡هشتگ و توزیع رو بهینه کن",
    Statistics_NonFollowerViews_neutral_summary:
      "بهینه‌سازی هشتگ و تولید محتوای قابل‌اشتراک می‌تونه ورودی غیرفالورها رو بالا ببره.",
    Statistics_NonFollowerViews_neutral_action1: "هشتگ‌های موثر رو مشخص و روی چندتا ثابت کن.",
    Statistics_NonFollowerViews_neutral_action2: "محتوای قابل‌اشتراک بیشتری بساز.",
    Statistics_NonFollowerViews_neutral_action3: "یک همکاری کوتاه با پیج‌های هم‌موضوع انجام بده.",
    Statistics_NonFollowerViews_neutral_urgency: "کم",

    Statistics_NonFollowerViews_down_title: "ویو توسط غیرفالورها کم شده 💡همکاری و تبلیغ لازمه",
    Statistics_NonFollowerViews_down_summary: "دسترسی به اکسپلور افت کرده؛ با همکاری یا یک تبلیغ سبک ورودی رو برگردون.",
    Statistics_NonFollowerViews_down_action1: "یک همکاری سریع با یک پیج مرتبط تنظیم کن.",
    Statistics_NonFollowerViews_down_action2: "پست‌های قابل‌اشتراک بیشتری بساز و تقویتی منتشر کن.",
    Statistics_NonFollowerViews_down_action3: "یک تبلیغ کوچک و هدفمند برای بازگشت ورودی اجرا کن.",
    Statistics_NonFollowerViews_down_urgency: "زیاد",

    Statistics_NonFollowerViews_zero_title: "ویو توسط غیرفالورها صفر 💡باید سیگنال برای اکسپلور بسازی",
    Statistics_NonFollowerViews_zero_summary: "برای ساخت اولین ورودی، ریلز ترندی و همکاری بهترین شروعه.",
    Statistics_NonFollowerViews_zero_action1: "۳ ریلز ترندمحور تولید کن.",
    Statistics_NonFollowerViews_zero_action2: "یک پست تقویتی اجرا کن تا ورودی اولیه بیاد.",
    Statistics_NonFollowerViews_zero_action3: "با یک پیج مرتبط یک همکاری سریع راه بنداز.",
    Statistics_NonFollowerViews_zero_urgency: "زیاد",

    Statistics_Shares_up_title: "اشتراک‌گذاری بالا 💡محتوای تو ارزش انتقال داره",
    Statistics_Shares_up_summary: "آدم‌ها پست‌هاتو می‌فرستن؛ یعنی محتوا فوری ارزش داره و می‌تونه تبدیل بسازه.",
    Statistics_Shares_up_action1: "بازخوردهای اشتراک‌گذاری رو آنالیز کن و الگوها رو پیدا کن.",
    Statistics_Shares_up_action2: "توی کپشن یک دلیل واضح برای اشتراک‌گذاری بذار («برای دوستت بفرست»).",
    Statistics_Shares_up_action3: "یک سری آموزشی قابل‌اشتراک طراحی کن.",
    Statistics_Shares_up_urgency: "متوسط",

    Statistics_Shares_neutral_title: "اشتراک‌گذاری کم یا ثابته 💡فقط یک محرک ساده می‌خوای",
    Statistics_Shares_neutral_summary: "گاهی فقط یک CTA کوتاه کافیه تا اشتراک‌گذاری بالا بره.",
    Statistics_Shares_neutral_action1: "در انتهای پست یک CTA خیلی کوتاه برای اشتراک بذار.",
    Statistics_Shares_neutral_action2: "محتوای ذخیره‌پذیر و قابل ارسال بیشتر تولید کن.",
    Statistics_Shares_neutral_action3: "یک قالب تستی «برای دوستت بفرست» اجرا کن.",
    Statistics_Shares_neutral_urgency: "کم",

    Statistics_Shares_down_title: "اشتراک‌گذاری کاهش داشته 💡محتوای کاربردی‌تر لازم داری",
    Statistics_Shares_down_summary: "محتوا کمتر قابل ارسال شده؛ باید چیزی بسازی که مردم بخوان بفرستن برای بقیه.",
    Statistics_Shares_down_action1: "چک‌لیست یا محتوای مرحله‌ای طراحی کن.",
    Statistics_Shares_down_action2: "آموزش‌های کوتاه و خلاصه منتشر کن.",
    Statistics_Shares_down_action3: "یک CTA واضح برای اشتراک‌گذاری بذار.",
    Statistics_Shares_down_urgency: "زیاد",

    Statistics_Shares_zero_title: "هیچ اشتراکی ثبت نشده 💡باید نقطه شروع بسازی",
    Statistics_Shares_zero_summary: "یا دیتایی نیست یا محتوا قابل اشتراک‌گذاری نیست؛ سریع یک پلن توزیع طراحی کن.",
    Statistics_Shares_zero_action1: "چند محتوای ۵ نکته‌ای یا چک‌لیستی تولید کن.",
    Statistics_Shares_zero_action2: "برای گرفتن اولین سیگنال، یک تقویت کوچک اجرا کن.",
    Statistics_Shares_zero_action3: "در کپشن یک دلیل روشن برای اشتراک‌گذاری بنویس.",
    Statistics_Shares_zero_urgency: "زیاد",

    Statistics_Engagement_up_title: "تعامل در حال رشد 💡فرمول رو تثبیت کن",
    Statistics_Engagement_up_summary: "به یک الگوی برنده رسیدی؛ وقتشه همونو تکرار و بزرگ‌ترش کنی.",
    Statistics_Engagement_up_action1: "فرمت‌ و زمان‌های موفق رو دقیق ثبت کن.",
    Statistics_Engagement_up_action2: "فرمت‌های تعامل‌ساز رو وارد تقویم محتوایی کن.",
    Statistics_Engagement_up_action3: "هفته‌ای یک فرمت جدید برای نگهداشت تست کن.",
    Statistics_Engagement_up_urgency: "متوسط",

    Statistics_Engagement_neutral_title: "تعامل معمولیه 💡یک محرک تازه لازم داری",
    Statistics_Engagement_neutral_summary:
      "برای رشد باید محرک‌های جدید وارد بازی کنی؛ مثل سوال، چالش یا دعوت به کامنت.",
    Statistics_Engagement_neutral_action1: "هفته‌ای یک پست مخصوص دعوت به نظر منتشر کن.",
    Statistics_Engagement_neutral_action2: "تعامل‌ها رو کانالیزه کن و نتایج چند فرمت رو مقایسه کن.",
    Statistics_Engagement_neutral_action3: "چند قالب مخصوص تعامل سریع طراحی کن.",
    Statistics_Engagement_neutral_urgency: "کم",

    Statistics_Engagement_down_title: "تعامل افت کرده 💡بازطراحی سریع ضروریه",
    Statistics_Engagement_down_summary: "باید فوری تست‌های جدید اجرا بشه؛ یک برنامه ۱۴ روزه بهترین شروعه.",
    Statistics_Engagement_down_action1: "پلن ۱۴ روزه با ۳ فرمت متفاوت اجرا کن.",
    Statistics_Engagement_down_action2: "هر روز داده‌ها رو ثبت کن و سریع pivot کن.",
    Statistics_Engagement_down_action3: "مستقیم از مخاطب بپرس چه محتوایی براش جذابه.",
    Statistics_Engagement_down_urgency: "زیاد",

    Statistics_Engagement_zero_title: "تعامل صفر 💡یک برنامه فشرده ۷ روزه لازم داری",
    Statistics_Engagement_zero_summary: "باید سریع سیگنال تعامل بسازی؛ روزانه پست تعاملی بده و دیتا رو دنبال کن.",
    Statistics_Engagement_zero_action1: "نظرسنجی، سوال باز و چالش‌های کوچک منتشر کن.",
    Statistics_Engagement_zero_action2: "برای هر فرمت ۳ روز تست قرار بده.",
    Statistics_Engagement_zero_action3: "به کامنت‌ها و پیام‌ها سریع جواب بده.",
    Statistics_Engagement_zero_urgency: "زیاد",

    Statistics_Replies_up_title: "پاسخ‌های استوری زیاد 💡ازش محتوا دربیار",
    Statistics_Replies_up_summary: "مخاطب می‌نویسه؛ یعنی تشنهٔ تعامل با توئه. این یعنی خوراک تولید محتوا.",
    Statistics_Replies_up_action_1: "۳ تا از بهترین جواب‌ها رو انتخاب کن و تبدیلشون کن به پست یا ریل.",
    Statistics_Replies_up_action_2: "یه Q&A یا FAQ با پاسخ‌های پرتکرار بساز.",
    Statistics_Replies_up_action_3: "تو استوری بعدی چندتا جواب رو نشون بده تا بقیه هم انگیزه بگیرن.",
    Statistics_Replies_up_urgency: "متوسط",

    Statistics_Replies_neutral_title: "پاسخ‌ها کم 💡محرک بذار",
    Statistics_Replies_neutral_summary: "برای گرفتن جواب بیشتر، فقط یه سوال ساده هم میتونه کافی باشه.",
    Statistics_Replies_neutral_action_1: "استیکر سؤال، Poll یا Quiz بذار.",
    Statistics_Replies_neutral_action_2: "سوال‌های کوتاه و جذاب بپرس.",
    Statistics_Replies_neutral_action_3: "به جواب‌ها سریع ری‌اکت بده تا حس تعامل بالا بره.",
    Statistics_Replies_neutral_urgency: "کم",

    Statistics_Replies_down_title: "پاسخ‌ها افت کرده 💡صمیمیت رو زیاد کن",
    Statistics_Replies_down_summary: "مخاطب انگار فاصله گرفته؛ با محتوای شخصی‌تر دوباره نزدیکش کن.",
    Statistics_Replies_down_action_1: "چندتا استوری شخصی‌تر، تجربه‌محور یا احساسی بذار.",
    Statistics_Replies_down_action_2: "سوال‌هایی بپرس که جوابش نیاز به تجربه شخصی داره.",
    Statistics_Replies_down_action_3: "به اولین جواب‌ها حتماً اهمیت بده و ری‌اکت یا ریپلای کن.",
    Statistics_Replies_down_urgency: "زیاد",

    Statistics_Replies_zero_title: "پاسخ صفر 💡دعوت مستقیم لازم داری",
    Statistics_Replies_zero_summary: "وقتی هیچ جوابی نیست، باید وسوسه‌گر و مستقیم سؤال بپرسی.",
    Statistics_Replies_zero_action_1: "سوال‌های خیلی ساده و جذاب بذار (مثل انتخاب بین دو گزینه).",
    Statistics_Replies_zero_action_2: "پاسخ‌هایی که می‌گیری رو هایلایت کن تا بقیه تشویق بشن.",
    Statistics_Replies_zero_action_3: "هر روز یه استوری تعاملی سبک اجرا کن.",
    Statistics_Replies_zero_urgency: "زیاد",

    Statistics_TotalTime_up_title: "زمان مشاهده زیاد شده 💡محتوای عمیق‌تر بده",
    Statistics_TotalTime_up_summary: "مخاطب داره وقت می‌ذاره؛ یعنی آماده‌ست برای محتواهای فصل‌دار و طولانی‌تر.",
    Statistics_TotalTime_up_action_1: "ویدیوهای بلندتر با ساختار مقدمه/میانه/جمع‌بندی بساز.",
    Statistics_TotalTime_up_action_2: "لینک محتوای تکمیلی رو توی بیو یا هایلایت قرار بده.",
    Statistics_TotalTime_up_action_3: "داخل ویدیو فصل‌بندی مشخص کن تا retention بالا بره.",
    Statistics_TotalTime_up_urgency: "متوسط",

    Statistics_TotalTime_neutral_title: "زمان مشاهده معمولی 💡ساختار رو محکم‌تر کن",
    Statistics_TotalTime_neutral_summary: "مخاطب می‌مونه، ولی قفل نمی‌شه؛ با ساختار بهتر نگهش دار.",
    Statistics_TotalTime_neutral_action_1: "ساختار سه‌لایه برای ویدیوها پیاده کن.",
    Statistics_TotalTime_neutral_action_2: "نقاط کلیدی رو مشخص کن تا بدونن قراره چی ببینن.",
    Statistics_TotalTime_neutral_action_3: "یه نسخهٔ خلاصه هم برای تست و مقایسه بساز.",
    Statistics_TotalTime_neutral_urgency: "کم",

    Statistics_TotalTime_down_title: "مدت تماشا افت کرده 💡قلاب اول ضعیفه",
    Statistics_TotalTime_down_summary: "۳ ثانیهٔ اول باید خط‌کشی باشه؛ جذاب‌تر، سریع‌تر، محکم‌تر.",
    Statistics_TotalTime_down_action_1: "۳ ثانیهٔ اول رو بازنویسی کن و چند نسخه تست کن.",
    Statistics_TotalTime_down_action_2: "نسخه‌های خیلی کوتاه 15–30 ثانیه‌ای بساز.",
    Statistics_TotalTime_down_action_3: "ریتم ادیت، cuts و موسیقی رو تیزتر کن.",
    Statistics_TotalTime_down_urgency: "زیاد",

    Statistics_TotalTime_zero_title: "زمان مشاهده صفر 💡هنوز چیزی منتشر نکردی ؟",
    Statistics_TotalTime_zero_summary: "اگر ویدیو هست ولی زمان ثبت نشده، اول مشکل فنی رو چک کن.",
    Statistics_TotalTime_zero_action_1: "محتوا رو چک کن که منتشر شده باشه.",
    Statistics_TotalTime_zero_action_2: "اگه ویدیو منتشر نشده، ۳ تا ریلز کوتاه پشت‌سرهم بذار.",
    Statistics_TotalTime_zero_action_3: "یک پست boost یا نمایش اولیه اجرا کن تا دیتا جمع بشه.",
    Statistics_TotalTime_zero_urgency: "زیاد",

    Statistics_ReachMonth_up_title: "Reach ماهانه رشد کرده 💡الگوها رو قفل کن",
    Statistics_ReachMonth_up_summary: "ماه‌های موفق روشنه؛ الگوها رو یادداشت کن و برای ماه بعد برنامه بچین.",
    Statistics_ReachMonth_up_action_1: "ماه‌های پربازده رو آنالیز کن و الگوها رو ثبت کن.",
    Statistics_ReachMonth_up_action_2: "تقویم محتوا رو با این الگوها آپدیت کن.",
    Statistics_ReachMonth_up_action_3: "فرمت‌های برنده رو برای ماه بعد دوباره منتشر کن.",
    Statistics_ReachMonth_up_urgency: "متوسط",

    Statistics_ReachMonth_neutral_title: "Reach ماهانه ثابت 💡وقت تست و رشد آزمایشی",
    Statistics_ReachMonth_neutral_summary: "برای بالا بردن Reach ماهانه، کمپین کوتاه یا تبلیغ محدود اجرا کن.",
    Statistics_ReachMonth_neutral_action_1: "یک کمپین مشترک یا تبلیغ محدود راه بنداز.",
    Statistics_ReachMonth_neutral_action_2: "نتایج رو ثبت و مقایسه کن و بهینه‌سازی کن.",
    Statistics_ReachMonth_neutral_action_3: "پست‌های موفق قبلی رو دوباره تقویت کن.",
    Statistics_ReachMonth_neutral_urgency: "کم",

    Statistics_ReachMonth_down_title: "افت Reach ماهانه 💡محتوا رو بازآفرینی کن",
    Statistics_ReachMonth_down_summary: "برای برگردوندن دسترسی، پست‌های کلیدی رو بازنشر یا بازسازی کن.",
    Statistics_ReachMonth_down_action_1: "پست‌های کلیدی رو بازنشر یا بازآفرینی کن.",
    Statistics_ReachMonth_down_action_2: "یک کمپین ۱۴ روزه تولید و تبلیغ اجرا کن.",
    Statistics_ReachMonth_down_action_3: "هشتگ‌ها و تگ‌ها رو دوباره بررسی کن.",
    Statistics_ReachMonth_down_urgency: "زیاد",

    Statistics_ReachMonth_zero_title: "Reach ماهانه صفر 💡اول دیتا رو چک کن",
    Statistics_ReachMonth_zero_summary: "دیتا ثبت نشده یا ناقصه؛ اول فنی چک کن، بعد برنامه ۱۴ روزه بذار.",
    Statistics_ReachMonth_zero_action_1: "اتصال داده‌ها و ثبت دیتا رو بررسی کن.",
    Statistics_ReachMonth_zero_action_2: "برنامهٔ ۱۴ روزه تولید محتوا اجرا کن.",
    Statistics_ReachMonth_zero_action_3: "نتایج روزانه رو پیگیری کن.",
    Statistics_ReachMonth_zero_urgency: "زیاد",

    Statistics_MonthEngagement_up_title: "تعامل ماهانه رو به رشده 💡مقیاس کن",
    Statistics_MonthEngagement_up_summary: "الگوهای مثبت ماهانه رو ثبت کن و تکرار کن.",
    Statistics_MonthEngagement_up_action_1: "قالب‌ها و فرمت‌های موفق رو مستندسازی کن.",
    Statistics_MonthEngagement_up_action_2: "برای ماه بعد KPI و برنامه مشخص بذار.",
    Statistics_MonthEngagement_up_action_3: "تست‌های کوچک هفتگی برای بهبود تعامل اجرا کن.",
    Statistics_MonthEngagement_up_urgency: "متوسط",

    Statistics_MonthEngagement_neutral_title: "تعامل ماهانه معمولیه 💡عنصر چالشی اضافه کن",
    Statistics_MonthEngagement_neutral_summary: "یک چالش یا سوال هفتگی می‌تونه تعامل رو افزایش بده.",
    Statistics_MonthEngagement_neutral_action_1: "هر هفته یک محتوای چالشی یا پرسش‌محور منتشر کن.",
    Statistics_MonthEngagement_neutral_action_2: "نتایج رو ثبت و مقایسه کن.",
    Statistics_MonthEngagement_neutral_action_3: "یک سری هفتگی برای تعامل بساز.",
    Statistics_MonthEngagement_neutral_urgency: "کم",

    Statistics_MonthEngagement_down_title: "تعامل ماهانه افت کرده 💡پلن ۱۴ روزه بذار",
    Statistics_MonthEngagement_down_summary: "فرمت‌ها رو بازنگری و یک پلن ۱۴ روزه اجرا کن.",
    Statistics_MonthEngagement_down_action_1: "پلن ۱۴ روزه با ۳ فرمت مختلف اجرا کن.",
    Statistics_MonthEngagement_down_action_2: "هر روز نتایج رو آنالیز کن.",
    Statistics_MonthEngagement_down_action_3: "بازخورد مستقیم از مخاطب جمع‌آوری کن.",
    Statistics_MonthEngagement_down_urgency: "زیاد",

    Statistics_MonthEngagement_zero_title: "تعامل ماهانه صفر 💡برنامه فوری ۷ روزه",
    Statistics_MonthEngagement_zero_summary: "۷ پست تعاملی سریع منتشر و روزانه رصد کن.",
    Statistics_MonthEngagement_zero_action_1: "۷ پست تعاملی تولید کن.",
    Statistics_MonthEngagement_zero_action_2: "نتایج رو روزانه بررسی کن.",
    Statistics_MonthEngagement_zero_action_3: "با مخاطب در دایرکت و کامنت تعامل داشته باش.",
    Statistics_MonthEngagement_zero_urgency: "زیاد",

    Statistics_MonthView_up_title: "بازدید ماهانه افزایش یافته 💡ساختار رو قفل کن",
    Statistics_MonthView_up_summary: "استراتژی ویدیویی جواب داده؛ این فرمت‌ها رو منظم منتشر کن.",
    Statistics_MonthView_up_action_1: "استراتژی ویدیویی رو مستندسازی کن.",
    Statistics_MonthView_up_action_2: "تولید منظم رو به فرمت استاندارد تبدیل کن.",
    Statistics_MonthView_up_action_3: "شاخص‌های کلیدی هر ماه رو بررسی و ثبت کن.",
    Statistics_MonthView_up_urgency: "متوسط",

    Statistics_MonthView_neutral_title: "بازدید ماهانه پایدار 💡ترکیب فرمت امتحان کن",
    Statistics_MonthView_neutral_summary: "ترکیب ریلز و استوری می‌تونه کانال‌های جدید ترافیک ایجاد کنه.",
    Statistics_MonthView_neutral_action_1: "ریلز+استوری ترکیبی تولید کن.",
    Statistics_MonthView_neutral_action_2: "عملکرد رو ثبت و مقایسه کن.",
    Statistics_MonthView_neutral_action_3: "کپشن‌های هدایت‌کننده به ویدیو اضافه کن.",
    Statistics_MonthView_neutral_urgency: "کم",

    Statistics_MonthView_down_title: "افت بازدید ماهانه 💡روی ریلز تمرکز کن",
    Statistics_MonthView_down_summary: "ریلز کوتاه و کاور جذاب سریع‌ترین راه برای برگشت مشاهده‌ان.",
    Statistics_MonthView_down_action_1: "ریلزهای 15-30 ثانیه‌ای تولید کن.",
    Statistics_MonthView_down_action_2: "کاورهای جذاب طراحی کن.",
    Statistics_MonthView_down_action_3: "تست‌های زمان‌بندی اجرا کن.",
    Statistics_MonthView_down_urgency: "زیاد",

    Statistics_MonthView_zero_title: "بازدید ماهانه صفر 💡اول فنی چک کن",
    Statistics_MonthView_zero_summary: "دیتا یا انتشار مشکل داره؛ اول فنی بررسی کن و بعد برنامه ۱۴ روزه بذار.",
    Statistics_MonthView_zero_action_1: "بررسی فنی دیتای ویدیو.",
    Statistics_MonthView_zero_action_2: "برنامهٔ ۱۴ روزه تولید محتوا اجرا کن.",
    Statistics_MonthView_zero_action_3: "نتایج رو روزانه رصد کن.",
    Statistics_MonthView_zero_urgency: "زیاد",
    Statistics_RePosts_up_title: "ری‌پست‌ها افزایش یافته 💡 ازش استفاده کن",
    Statistics_RePosts_up_summary: "مخاطب داره پست‌هاتو به اشتراک می‌ذاره؛ این یعنی محتوای تو ارزش انتقال داره.",
    Statistics_RePosts_up_action_1: "در کپشن یک دلیل واضح برای ری‌پست بذار («برای دوستت بفرست»).",
    Statistics_RePosts_up_action_2: "یک سری آموزشی قابل‌اشتراک طراحی کن.",
    Statistics_RePosts_up_action_3: "بازخوردهای ری‌پست رو آنالیز کن و الگوها رو پیدا کن.",
    Statistics_RePosts_up_urgency: "متوسط",
    Statistics_RePosts_neutral_title: "ری‌پست‌ها کم یا ثابت 💡 فقط یک محرک ساده می‌خوای",
    Statistics_RePosts_neutral_summary: "گاهی فقط یک CTA کوتاه کافیه تا ری‌پست‌ها افزایش پیدا کنه.",
    Statistics_RePosts_neutral_action_1: "در انتهای پست یک CTA خیلی کوتاه برای ری‌پست بذار.",
    Statistics_RePosts_neutral_action_2: "محتوای ذخیره‌پذیر و قابل ارسال بیشتری تولید کن.",
    Statistics_RePosts_neutral_action_3: "یک قالب تستی «برای دوستت بفرست» اجرا کن.",
    Statistics_RePosts_neutral_urgency: "کم",
    Statistics_RePosts_down_title: "ری‌پست‌ها کاهش داشته 💡 محتوای کاربردی‌تر لازم داری",
    Statistics_RePosts_down_summary: "محتوا کمتر قابل ارسال شده؛ باید چیزی بسازی که مردم بخوان برای بقیه بفرستن.",
    Statistics_RePosts_down_action_1: "چک‌لیست یا محتوای مرحله‌ای طراحی کن.",
    Statistics_RePosts_down_action_2: "آموزش‌های کوتاه و خلاصه منتشر کن.",
    Statistics_RePosts_down_action_3: "یک CTA واضح برای ری‌پست بذار.",
    Statistics_RePosts_down_urgency: "زیاد",
    Statistics_RePosts_zero_title: "هیچ ری‌پستی ثبت نشده 💡 باید نقطه شروع بسازی",
    Statistics_RePosts_zero_summary: "یا دیتایی نیست یا محتوا قابل ری‌پست نیست؛ سریع یک پلن توزیع طراحی کن.",
    Statistics_RePosts_zero_action_1: "چند محتوای ۵ نکته‌ای یا چک‌لیستی تولید کن.",
    Statistics_RePosts_zero_action_2: "برای گرفتن اولین سیگنال، یک تقویت کوچک اجرا کن.",
    Statistics_RePosts_zero_action_3: "در کپشن یک دلیل روشن برای ری‌پست بنویس.",
    Statistics_RePosts_zero_urgency: "زیاد",

    //statistics suggestions box
    // 4️⃣ Page -> tools
    pageTools_hashtags: "هشتگ‌ها",
    pageTools_MyList: "لیست هشتگ‌ها",
    pageTools_CreateNewListexplain: "لیست # بسازید و از آن برای ساخت پست‌ها استفاده کنید",
    Analyzer: "آنالیز (AI)",
    pageTools_CreateNewList: "ایجاد لیست جدید",
    pageTools_CustomFont: "فونت سفارشی",
    pageTools_CustomFontExplain: "از فونت‌های سفارشی برای پست‌های اینستاگرام خود استفاده کنید!",
    pageToolspopup_CreateNewListexplain:
      "با دکمه‌ی <Enter> و <Space> هشتگ جدید ایجاد خواهد شد و با کلیک بر روی هر هشتگ، آن حذف می‌شود.",
    pageToolspopup_Listname: "نام لیست",
    pageToolspopup_hashtags: "هشتگ‌ها",
    pageToolspopup_typehere: "اینجا تایپ کنید",
    pageTools_hashtagList: "لیست هشتگ",
    pageTools_CreateNewListpic: "آنالیز تصویر",
    pageTools_CreateNewListpicexplain: "تولید هشتگ‌های مرتبط با تصویر",
    pageTools_CreateNewListpage: "آنالیز پیج",
    pageTools_CreateNewListpageexplain: "تولید هشتگ‌های مرتبط با آدرس اینستاگرام",
    pageToolspopup_pageURL: "ای دی اینستاگرام",
    pageToolspopup_HideLikeandViewCounts: "مخفی کردن تعداد لایک و بازدید",
    pageToolspopup_TurnoffCommenting: "غیرفعال کردن کامنت",
    pageToolspopup_TurnoffCommentingExplain: "امکان کامنت‌گذاری کاربران برای این پست غیرفعال خواهد شد",
    pageToolspopup_TurnoffCommentingexplainforlottery:
      "امکان کامنت‌گذاری برای این پست در زمان برگزاری قرعه‌کشی غیرفعال خواهد شد",

    pageToolspopup_TopHashtag: "هشتگ برتر",
    pageToolspopup_TopHashtagexplain: "تعداد دفعات استفاده شما از این هشتگ در پیج ",
    pageToolspopup_allRepliedcomments: "همه کامنت‌های پاسخ داده شده",
    noresult: "نتیجه‌ای یافت نشد",
    viewreplies: "مشاهده پاسخ‌ها",
    allRepliedcomments: "همه کامنت‌های پاسخ داده شده",
    Followers: "فالورها",
    NonFollowers: "غیر فالورها",
    pageToolspopup_ViewersLikes: "بازدیدکنندگان و لایک‌ها",
    supportedformat: "فرمت پشتیبانی شده",
    limitsize: "حداکثر اندازه",
    TagMention: "تگ و منشن",
    cover: "کاور",
    Pleaseselect: "لطفا انتخاب کنید",
    replace: "جایگزین ",
    Album: "آلبوم",
    SavedHashtagList: "لیست هشتگ‌های ذخیره‌شده",
    SavedHashtagListexplain: "هشتگ مورد نظر را برای اضافه کردن به انتهای کپشن انتخاب کنید",
    FirstComment: "اولین کامنت",
    PinFirstComment: "پین کردن اولین کامنت",
    areyousure: "آیا مطمئن هستید؟",
    shouldFollower: "کاربر باید حتما پیج را فالو داشته باشد",
    draftexplain: "شما در حال تلاش برای ذخیره به عنوان پیش‌نویس هستید",
    deletedraftexplain: "شما در حال تلاش برای حذف پیش‌نویس هستید",
    deleteorderexplain: "شما در حال تلاش برای حذف سفارش هستید",

    Addpeopleexplain: "*پس از تگ کردن افراد، تگ را تنظیم کنید یا با دوبار کلیک حذف کنید",
    AdvanceSettings: "تنظیمات پیشرفته",
    sharepreviewtofeed: "پیش‌نمایش را به فید به اشتراک بگذارید",
    Videocopyrightbypass: "دور زدن حق کپی‌رایت ویدیو",
    SetScheduledPost: "زمان‌بندی پست",
    SetScheduledPostexplain: "این پست در زمان تعیین‌شده منتشر خواهد شد",
    SetScheduledStoryexplain: "این استوری در زمان تعیین‌شده منتشر خواهد شد",
    addtoproduct: "افزودن به محصولات",
    addtoproductexplain: "این پست به عنوان محصول در لیست محصولات شما اضافه خواهد شد",
    TurnoffCommentingexplain: "امکان کامنت‌گذاری برای این پست غیرفعال خواهد شد",
    RecommendedDateTime: "تاریخ و زمان پیشنهادی",
    RecommendedDateTimeexplain: "زمان‌های پیشنهادی بر اساس تحلیل پیج شما  است",
    publish: "انتشار",
    pageTools_global: "جهانی",
    pageTools_FA_AR: "فارسی / عربی",
    pageTools_Overall: "کلی",
    pageTools_year: "سال",
    pageTools_Month: "ماه",
    pageTools_Week: "هفته",
    pageTools_Day: "روز",
    pageTools_hashtag: "هشتگ",
    pageTools_USED: "استفاده",
    pageTools_SearchedHashtag: "هشتگ جستجو شده",
    pageTools_TrendHashtags: "هشتگ‌های ترند",
    pageTools_AutoInterAction: "تعامل خودکار با فالوورها",
    pageTools_AcceptPendingRequests: "پذیرفتن خودکار درخواست‌های فالو",
    pageTools_LikeAllNewComments: "لایک کامنت‌های جدید",
    pageTools_LikeNewFollowersPosts: "لایک آخرین پست‌های فالوورهای جدید",
    pageTools_RemoveAllFollowings: "حذف تمام فالوینگ‌ها",
    pageTools_WinnerPicker: "قرعه‌کشی (انتخاب برنده)",
    pageTools_DayEvents: "رویدادهای روز",
    pageTools_EventDateRange: "بازه زمانی",
    pageTools_EventLanguage: "زبان",
    pageTools_EventSelectDate: "انتخاب بازه تاریخی",
    pageTools_EventSearch: "جستجوی رویدادها",
    pageTools_EventEmpty: "رویدادی برای بازه انتخابی یافت نشد",
    pageTools_EventReligious: "مذهبی",
    pageTools_EventIdeas: "ایده‌های رویداد",
    pageTools_IdeaCreate: "تولید ایده برای رویدادها",
    pageTools_IdeaExplain: "دریافت ایده‌های محتوا بر اساس رویدادها و مناسبت‌های پیش رو",
    pageTools_CreateEventIdea: "تولید ایده برای رویدادها",
    pageTools_CreateEventIdeaPrompt: "موضوع / پرامپت",
    pageTools_CreateEventIdeaPromptPlaceholder: "مثلاً: کفش، ورزش، سفر... (برای همه موضوعات خالی بگذارید)",
    pageTools_CreateEventIdeaOptional: "اختیاری",
    pageTools_CreateEventIdeaSubmit: "تولید",
    pageTools_CreateEventIdeaCancel: "انصراف",
    pageTools_EventIdeasLanguage: "زبان",
    pageTools_EventIdeasFetch: "دریافت ایده‌ها",
    pageTools_EventIdeasEmpty: "ایده‌ای یافت نشد",
    pageTools_EventIdeasLoadMore: "بیشتر",
    pageTools_EventIdeasIdea: "ایده",
    pageTools_EventIdeasCountry: "کشور",
    pageTools_EventIdeasPrompt: "موضوع",
    pageTools_EventIdeasCreatedTime: "تاریخ ساخت",
    pageTools_CustomEvent: "رویداد سفارشی",
    pageTools_exportcomments: "خروجی کل کامنت‌ها به‌صورت فایل اکسل گرفته می‌شود و قابل دانلود و اشتراک‌گذاری است",
    pageTools_Lottery: "قرعه‌کشی امتیازی",
    pageTools_emptylotteryList: "هنوز هیچ قرعه‌کشی‌ای ایجاد نکرده‌اید",

    pageTools_LotteryExplain: "بر اساس امتیازات کاربران در یک پست",
    pageTools_fromFollowers: "از بین فالوورها",
    pageTools_FromFollowersExplain: "انتخاب از بین تمام فالوورها به‌طور تصادفی",
    pageTools_Result: "نتیجه",
    pageTools_ResultExplain: "تاریخچه وضعیت قرعه‌کشی های قبلی",
    pageTools_popup_detail: "جزئیات",
    pageTools_popup_history: "تاریخچه",
    pageTools_LikeAllNewCommentsExplain:
      "وقتی یکی از فالوورها شما کامنتی روی هر پستی بگذارد، به طور خودکار لایک خواهد شد.",
    pageTools_AcceptType: "نوع فعال‌سازی",
    pageTools_popup_AlwaysActive: "همیشه فعال",
    pageTools_popup_JustOnce: "فقط یکبار",
    pageTools_AcceptPendingRequestsexplain: "تمام درخواست‌های فالو از افراد را به صورت خودکار پذیرفته میشود.",
    pageTools_onlyprivate: "*فقط با صفحه‌های خصوصی کار می‌کند.",
    pageTools_MaxLike: "تعداد پست‌هایی که لایک خواهند شد",
    pageTools_Reacceptfollower: "فالو مجدد پس از آنفالو",
    pageTools_Reacceptfollowerexplain:
      "اگر شخصی قبلاً فالو کرده و سپس آنفالو کند و دوباره درخواست فالو بدهد، سیستم آن را می‌پذیرد.",
    waitday: "زمان انتظار",
    waitdayexplain: "اگر شخصی توسط شما یا سیستم فالو شود، پس از مدت زمان تعیین شده حذف خواهد شد.",
    waitdayexplain2:
      "عدد انتظار بر حسب تعداد روز است. اگر این عدد برابر با صفر باشد، عمل به‌طور لحظه‌ای انجام خواهد شد.",
    pageTools_LikeNewFollowersPostsexplain:
      "زمانی که فرد جدیدی شما را فالو کند، آخرین پست او به صورت خودکار لایک می‌شود.",
    pageTools_RemoveAllFollowingsexplain: "این گزینه به صورت خودکار تمام فالویینگ‌های شما را حذف می‌کند.",
    pageTools_progress: "بسته به تعداد فالورهای شما، این فرآیند ممکن است تا چند روز طول بکشد ",
    pageTools_JustUnfollowwho: "فقط فالویینگ‌هایی که به من فالو بک نداده‌اند را آنفالو شوند",
    pageTools_AllmyFollowings: "تمام فالویینگ‌های من",
    pageTools_pageanAnalyzer: "آنالیز پیج",
    pageTools_pictureanAnalyzer: "آنالیز تصویر",
    pageTools_StartAnalysis: "شروع آنالیز",

    pageLottery_Step: "مرحله",
    pageLottery_Specifications: "مشخصات",
    pageLottery_SelectaPost: "انتخاب پست",
    pageLottery_SetDateTime: "انتخاب زمان و تاریخ",
    pageLottery_WinnersTasks: "وظایف شرکت کنندگان",
    pageLottery_WinnersTasksexplain: "وظایفی که هر یک از شرکت‌کنندگان باید انجام دهند تا وارد قرعه‌کشی شوند.",
    pageLottery_NumberofWinners: "تعداد برندگان",
    pageLottery_SetScoreForLottery: "منشن کردن افراد",
    pageLottery_SetScoreForLotteryexplain: "کاربران باید افراد دیگر را منشن کنند تا در قرعه‌کشی شرکت داده شوند",

    pageLottery_MinimumMention: "حداقل منشن",
    pageLottery_MinimumMentionexplain: "تعداد افرادی که باید منشن شوند",
    pageLottery_FollowedPage: "پیج فالو شده",
    pageLottery_FollowedPageexplain:
      "افراد باید پیج شما و/یا صفحاتی که انتخاب می‌کنید را فالو کنند تا در قرعه‌کشی شرکت کنند",
    pageLottery_FollowmyPage: "پیج من را فالو کن",
    pageLottery_FollowalternativePages: "صفحات جایگزین را فالو کن",
    pageLottery_Termsconditions: "شرایط و قوانین",
    pageLottery_publishTermsconditions: "انتشار شرایط و قوانین",
    pageLottery_previewTermsconditionsexplain: "این استوری به شرکت‌کنندگان به عنوان یک استوری نمایش داده خواهد شد.",
    pageLottery_Termsconditionsbanner: "بنر شرایط و قوانین",
    pageLottery_Termsconditionsbannerexplain:
      "یک بنر انتخاب کنید تا شرایط و قوانین قرعه‌کشی را به فالورهای خود اعلام کنید.",
    pageLottery_model: "مدل",
    pageLottery_Solid: "یکدست",
    pageLottery_Radial: "شعاعی",
    pageLottery_Linear: "خطی",
    pageLottery_Background: "پس‌زمینه",
    pageLottery_Color: "رنگ",
    pageLottery_Position: "موقعیت",
    pageLottery_Degree: "درجه",
    pageLottery_TextBox: "جعبه متن",
    pageLottery_Opacity: "شفافیت",
    pageLottery_Blur: "تاری",
    pageLottery_Font: "فونت",
    pageLottery_Winnerannouncement: "اعلام برنده",
    pageLottery_participants1: "🎉 از بین ۹۹۹,۹۹۹ شرکت‌کننده 🎉",
    pageLottery_participants2: "🥳 این‌ها برنده‌های خوش‌شانس هستند: 🥳",
    pageLottery_participantsexplain:
      "*سیستم به صورت خودکار تعداد شرکت‌کنندگان و تعداد برندگان را تنظیم کرده و شناسه‌های آن‌ها را پس از هر کاراکتر @ تعیین می‌کند.",
    pageLottery_Addtocaption: "اضافه کردن به کپشن پس از اتمام قرعه‌کشی",
    pageLottery_Publishasstory: "لیست برندگان به عنوان استوری منتشر شود",
    pageLottery_deleteexplain: "این قرعه‌کشی به‌طور دائمی حذف خواهد شد و این عمل قابل بازگشت نیست.",
    pageLottery_Winnerpickersstatus: "وضعیت قرعه‌کشی",
    pageLottery_scoreLotteryWinners: "برندگان قرعه‌کشی",
    pageLottery_NoWinners: "برنده‌ای وجود ندارد",
    pageLottery_RandomFollowersWinners: "برندگان تصادفی فالورها",
    pageLottery_specifickeywordexplain:
      "کاربران باید حتماً یک کلمه خاص را در کامنت خود بنویسند تا در قرعه‌کشی شرکت داده شوند",
    pageLottery_FollowmyPageexplain: "کاربران باید پیج را فالو داشته باشند تا در قرعه‌کشی شرکت داده شوند",

    pageLottery_ShareRemainingTime: "اشتراک‌گذاری زمان باقی‌مانده",
    ShareTermsAndCondition: "اشتراک‌گذاری شرایط و ضوابط",
    pageLottery_LotteryRemainingTime: "زمان باقی‌مانده قرعه کشی",
    pageLottery_Winnerpickerisrunning: "قرعه کشی در حال اجراست",
    pageLottery_ViewandEditDetails: "مشاهده و ویرایش جزئیات",
    pageLottery_ActiveWinnerpickers: "قرعه کشی فعال",
    pageTools_WinnerPickertooltip24hour: "قرعه‌کشی هر ۲۴ ساعت یک‌بار امکان‌پذیر است",
    specifickeywordstooltip: "سیستم به‌صورت خودکار ایموجی‌ها و اعداد فارسی، عربی و انگلیسی را تشخیص می‌دهد",
    pageLottery_FilterKeywords:
      "سیستم به‌صورت تصادفی از بین کامنت‌های حاوی کلمه‌ی موردنظر شما را انتخاب و نمایش می‌دهد",
    pageLottery_NumberofWinnersexplain: "تعداد برندگان قرعه‌کشی را مشخص کنید. حداکثر تعداد برندگان ۱۰۰ نفر است",
    pageLottery_permanentlinktooltip: "این لینک دائمی است، اما با انجام قرعه‌کشی جدید، لینک قبلی حذف می‌شود",
    pageLottery_permanentlinkexplain: "این لینک را می‌توانید برای تأیید سلامت و اصالت قرعه‌کشی به کاربران ارائه دهید",
    pageTools_randomly: "به صورت تصادفی",
    pageTools_BestEngagement: "بهترین انگیجمنت",
    pageTools_BestEngagementexplain: "انتخاب از بین فالورهایی که بیشترین لایک و کامنت را داشتند",
    // #endregion page Section
    // #region 3️⃣ Message Section
    message_youareattemptingto: "شما در حال تلاش هستید تا",
    message_blockexplain:
      ".این کاربر نمی‌تواند پروفایل، پست‌ها یا استوری شما را در اینستاگرام پیدا کنند. اینستاگرام به او اطلاع نمی‌دهد که شما او را بلاک کرده‌اید",
    message_deleteexplain: ".این چت به صورت دائمی حذف می‌شود و قابل بازگشت نیست",
    message_block: "بلاک",
    notactivemessage: ".این چت موقتا غیرفعال شده است. لطفاً از طریق اپلیکیشن اینستاگرام پاسخ خود را ارسال کنید",
    notactivemessageexplain:
      "توجه داشته باشید که اگر تا ۲۴ ساعت پاسخی ارسال نشود، چت از دسترس خارج خواهد شد. برای فعال‌سازی مجدد، یا باید از طریق اپلیکیشن اینستاگرام پاسخ دهید و یا منتظر باشید که فرد مقابل یک پیام جدید برای شما ارسال کند.",
    waitingforconnection: "...در انتظار اتصال",
    message_unblock: "آنبلاک",
    messagesetting_goodbye: "پیام وداع",
    messagesetting_welcome: "خوش‌آمدگویی ",
    messagesetting_welcomingmessage: "پیام خوش‌آمدگویی",
    messagesetting_Activewelcomemessageexplain:
      "این پیام به عنوان <پیام خوش‌آمدگویی> در دایرکت اینستاگرام به افرادی که شما را فالو می‌کنند ارسال خواهد شد.",
    messagesetting_Sentmessages: "پیام‌های ارسال‌شده",
    message: "پیام",
    receivedmessage: "پیام دریافت شده",
    Messageresponse: "پاسخ پیام",
    receivedcomment: "کامنت دریافت شده",
    commentresponse: "پاسخ کامنت",
    Likethereceivedcomment: "لایک کردن کامنت دریافت شده",
    unreadmessage: "پیام‌های خوانده‌نشده",
    specifickeywords: "کلمه کلیدی خاص",
    unreadcomment: "کامنت‌های خوانده‌نشده",
    hiddencommenttooltip:
      ".این کامنت از دید کاربران پنهان شده است. فقط ادمین‌ها می‌توانند کامنت‌های پنهان را مشاهده کنند",
    vanishmode: "حالت پنهان",
    vanishmodeexplain:
      "در حالت پنهان، پیام‌هایی که به آن‌ها پاسخ داده نشده و نادیده گرفته یا پنهان نشده‌اند، نمایش داده خواهند شد.",
    totalcomments: "کل کامنت‌ها",
    unansweredcomments: "کامنت‌های پاسخ داده نشده",
    totalcommenters: "کل افراد کامنت‌گذار",
    commentmanagement: "به مدیریت نظرات خوش آمدید",
    ticketmanagement: "به بخش مدیریت تیکت های مشتریان خوش آمدید",
    flowmanagement: "فلو بسازید و پاسخ‌های اینستاگرام را هوشمند و اتوماتیک کنید",

    QuickReplyexplain: "تمام کامنت‌های دریافت‌شده به‌صورت خودکار پاسخ داده می‌شوند.",
    autocommentReply: "پاسخ خودکار به کامنت",
    Sendresponseifthepageisfollowed: "ارسال پاسخ در صورت فالو شدن صفحه",
    Likethereceivedmessage: "لایک کردن پیام دریافت‌شده",
    messagesetting_Activewelcomingmessage: "پیام خوشامدگویی",
    messagesetting_welcometext:
      "سلام! 🌟\nخوش آمدی به دنیای ما! 🎉 خیلی خوشحالیم که به جمع فالورهای ما اضافه شدی. مطمئنیم که با هم لحظات شگفت‌انگیزی خواهیم داشت. 🤗\n\nامیدواریم که محتوای این پیج جالب و مفید باشه و با ما همراه بمونی. اگر سوال یا پیشنهادی داری، خوشحال میشیم با ما درمیون بزاری. 😊\n\n بی‌صبرانه منتظریم تا شما را در دنیای شگفت‌انگیزمان همراهی کنیم.✨\n\nبا احترام و تقدیر 💫",
    messagesetting_goodbyetext:
      "سلام! 👋\nمتاسفیم که صفحه ما را ترک کردی. 😢 ما به تک‌تک فالورهای خودمون اهمیت می‌دهیم و نظرات و پیشنهادات شما برای ما خیلی مهمه .\n\nاگر دلیل خاصی برای این تصمیم داشتی، خوشحال می‌شویم با ما در میان بگذاری. ما آماده شنیدن نظرات و پیشنهادات و انتقادات هستیم تا بتوانیم تجربه بهتری برای فالورهامون فراهم کنیم. 🫡\n\nدر هر صورت، برای تو بهترین‌ها رو آرزو داریم و امیدواریم در آینده دوباره به ما همراه بشی. 💫",
    messagesetting_ActiveFarewellmessage: "پیام وداع",
    messagesetting_ActiveFarewellmessageexplain:
      "این پیام به عنوان <پیام وداع> در دایرکت اینستاگرام به کسانی که شما را آنفالوو کرده‌اند، ارسال خواهد شد.",
    messagesetting_businessmessagefilter: "فیلتر پیام‌های کسب‌وکار",
    messagesetting_businessmessagefiltering: "فیلتر کردن پیام‌های کسب‌وکار",
    messagesetting_businessmessagefilteringexplain:
      "چت مورد نظر به‌طور خودکار به بخش <پیام‌های کاری> در تب دایرکت منتقل خواهد شد.",
    messagesetting_specificwords: "کلمات سفارشی",
    messagesetting_autofiltering: "فیلتر خودکار (AI)",
    messagesetting_specificwordsexplain:
      "شما می‌توانید چندین کلمه داشته باشید، هر کلمه را با کاراکتر <Enter> جدا کنید.",
    messagesetting_Createanewsupportticket: "ایجاد تیکت پشتیبانی",
    messagesetting_CreateanewsupportticketExplain:
      "کاربران می‌توانند از این گزینه برای ایجاد یک تیکت پشتیبانی در دایرکت خود استفاده کنند. شما نیز می‌توانید از طریق پنل برنسی یا مستقیماً در دایرکت به آن پاسخ دهید.",
    messagesetting_Changeapplicationlanguage: "تغییر زبان گزینه‌های دایرکت",
    messagesetting_ChangeapplicationlanguageExplain:
      "با فعال‌سازی این گزینه، کاربران می‌توانند تمامی قابلیت‌های دایرکت را در هفت زبان (انگلیسی، فارسی، عربی، فرانسوی، روسی، ترکی و آلمانی) مشاهده کنند. سیستم به‌طور هوشمند ترجمه‌های لازم را انجام خواهد داد.",
    messagesetting_ViewStoreandproducts: "مشاهده محصولات فروشگاه",
    messagesetting_ViewStoreandproductsExplain:
      "با این گزینه، کاربران می‌توانند کاتالوگ محصولات شما را به‌صورت لیستی یا آلبومی، همراه با جزئیاتی مانند موجودی، قیمت و سایر مشخصات مشاهده کنند.",
    messagesetting_Visityourwebsite: "نمایش وب‌سایت",
    messagesetting_VisityourwebsiteExplain:
      "کاربران می‌توانند از طریق این گزینه آدرس وب‌سایت شما و خلاصه‌ای از آن را مشاهده کرده و در صورت نیاز مستقیماً به آن مراجعه کنند. (سرعت بارگذاری این صفحه بسیار بالا خواهد بود.)",
    messagesetting_Viewuserrolesandpermissions: "قوانین و مقررات کسب‌وکار",
    messagesetting_ViewuserrolesandpermissionsExplain:
      "با فعال‌سازی این گزینه، کاربران می‌توانند قوانین، مقررات و محدودیت‌های کسب‌وکار شما را که در تنظیمات برنسی تعریف کرده‌اید، مشاهده کنند.",
    messagesetting_Viewbusinesshourschart: "ساعات کاری کسب‌وکار",
    messagesetting_ViewbusinesshourschartExplain:
      "کاربران می‌توانند از این گزینه برای مشاهده ساعات کاری شما استفاده کنند. این قابلیت به کاهش پیام‌های خارج از ساعات کاری کمک می‌کند.",
    messagesetting_Viewpricinginformation: "تعرفه خدمات تبلیغاتی",
    messagesetting_ViewpricinginformationExplain:
      "با فعال‌سازی این گزینه، کاربران می‌توانند به‌صورت به‌روز قیمت هر یک از سرویس‌های تبلیغاتی شما را مشاهده کنند. این قابلیت از دریافت سوالات تکراری جلوگیری می‌کند.",
    messagesetting_Searchforproducts: "جستجوی محصولات",
    messagesetting_SearchforproductsExplain:
      "کاربران می‌توانند با ارسال نام محصول، شماره پست یا بخشی از کپشن، مشخصات کامل محصول را دریافت کرده و در صورت تمایل، خرید خود را مستقیماً انجام دهند. این قابلیت تأثیر مثبتی بر افزایش فروش خواهد داشت.",
    messagesetting_addautomaticreplysystemsystem: "پاسخ سیستمی واحد برای تمامی قسمت‌های پیج",
    //
    messagesetting_HideRobotReply: "فیلتر پیام‌های خودکار و رباتی",
    messagesetting_HideRobotReplyExplain:
      "پیام‌های خودکار و رباتی مخفی می‌شوند و فقط پیام‌های واقعی در دایرکت نمایش داده می‌شوند",
    messagesetting_LikeRobotReply: "لایک خودکار کامنت‌های استوری",
    messagesetting_HideRobotReplytooltip: "پیام‌ها حذف نمی‌شوند و فقط مخفی می‌شوند تا مدیریت دایرکت ساده‌تر شود",
    messagesetting_LikeRobotReplyExplain:
      "کامنت‌های استوری به‌صورت خودکار لایک می‌شوند تا تعامل بیشتر و سریع‌تر انجام شود",
    messagesetting_automaticreplysystem: "کنترل پاسخ‌های خودکار",
    messagesetting_automaticreplysystemforallpost:
      "مدیریت کلی فعال یا غیرفعال بودن پاسخ‌های خودکار کامنت‌ها در همه پست‌ها",
    messagesetting_automaticreplysystemforallposttooltip:
      "اگر برای پست‌های مختلف پاسخ خودکار کامنت تنظیم کرده باشید، با این گزینه می‌توانید همه آن‌ها را یک‌جا فعال یا غیرفعال کنید. برای تنظیم پاسخ‌ها باید به صفحه هر پست به‌صورت جداگانه مراجعه کنید",
    messagesetting_messagePanellanguage: "زبان پیش‌فرض دایرکت",
    messagesetting_messagePanellanguageExplain: "زبان پیش‌فرض ربات دایرکت برای پاسخ‌دهی به پیام‌ها",
    messagesetting_AutoReplyPerFollow: "فالو آپ",
    messagesetting_AutoReplyPerFollowExplain:
      "در مواردی که از کاربر درخواست می شود پیج را فالو کند از این تمپلیت استفاده می شود.",
    messagesetting_AutoReplyPerFollowtooltip:
      "کاربرانی که شما را فالو نکرده‌اند، ابتدا درخواست فالو دریافت می‌کنند و پس از فالو کردن، پیام خودکار برای آن‌ها ارسال می‌شود",
    messagesetting_AutoReplyPerFollowtitle: "متن پیام",
    messagesetting_AutoReplyPerFollowtitlesample: "مثال: برای دریافت پیام، ابتدا صفحه ما را فالو کنید",
    messagesetting_AutoReplyPerFollowbtn: "متن دکمه",
    messagesetting_AutoReplyPerFollowbtnsample: "مثال: فالو کردم، پیام را ارسال کنید",
    messagesetting_automaticreplysystemexplain:
      "با دریافت هر پیام یا کامنت، در هر بخش پیج (فید، استوری، ریلز، لایو و غیره)، سیستم به‌طور خودکار با متنی که تنظیم می‌کنید پاسخ می‌دهد.",
    messagesetting_KeywordSensitive: "حساس به کلمه",
    messagesetting_KeywordsSensitive: "حساس به کلمات",
    sendreplydirectedsuccessfully: "ارسال پیام تأییدیه در کامنت پس از دایرکت",
    autoReplyFor: "پاسخ خودکار در",
    messagesetting_selectedwords: "موارد انتخاب‌شده",
    autocommentReplyExplain: "با دریافت یک کامنت یا پیام، سیستم به‌طور خودکار پاسخ می‌دهد.",
    selectnewmessage: ".برای ارسال پاسخ، لطفاً یک پیام را انتخاب کنید",
    sendreplyticket: "ارسال پاسخ ها",
    emptyticketdirect: "هیچ تیکتی از مشتریان دایرکت پیج خود دریافت نکرده‌اید",
    emptysystemticket: "هیچ تیکتی از مشتریان سیستم برنسی دریافت نکرده‌اید",
    emptycomment: "هنوز هیچ کامنتی برای نمایش وجود ندارد",
    emptydirect: "هنوز هیچ دایرکتی برای نمایش وجود ندارد",

    respondToAllComments: "پاسخگویی به همه کامنت‌ها",
    sensitiveToSpecificKeywords: "پاسخگویی حساس به کلمات کلیدی خاص",
    sensitiveToSpecificKeywordsExplain:
      "اگر این کلمات در هر جای متن کامنت وجود داشته باشد سیستم به صورت خودکار به آن کامنت پاسخ می‌دهد",
    contain: "شامل کلمه باشد",
    containExplain:
      "اگر روشن باشد، با وجود کلمه در متن کامنت پاسخ داده می‌شود؛ اگر خاموش باشد، فقط وقتی پاسخ داده می‌شود که کل کامنت دقیقاً همان کلمه باشد.",
    replyMethod: "نحوه پاسخگویی",
    respondInSameComment: "پاسخ به همان کامنت",
    respondDirectly: "پاسخ به صورت دایرکت",
    ticketID: "شناسه تیکت",
    noNewAnsweredTickets: "تیکت پاسخ‌داده‌شده جدیدی ندارید",
    noNewPendingTickets: "تیکت در حال رسیدگی جدیدی ندارید",
    noNewClosedTickets: "تیکت بسته‌شده‌ای ندارید",

    Ticketclosedby: "تیکت بسته شده توسط",
    waitingforuserresponse: "در انتظار پاسخ کاربر",
    inactiveticketexpired: ".این تیکت به دلیل عدم فعالیت در ۲۴ ساعت گذشته غیر فعال شده است",
    automaticreply: "پاسخ خودکار",
    autodirectexplain:
      "زمانی که یک کلمه کلیدی خاص در دایرکت دریافت می‌شود، پاسخ از پیش تعیین‌شده شما به‌طور خودکار در دایرکت ارسال خواهد شد",
    adddirectexplain: "اضافه کردن پاسخ‌های خودکار به دایرکت",
    autocommentexplain:
      "زمانی که یک کلمه کلیدی خاص در یک کامنت دریافت می‌شود، پاسخ از پیش تعریف‌شده شما به‌طور خودکار در همان کامنت ارسال خواهد شد",
    addcommentexplain: "اضافه کردن پاسخ‌های خودکار به کامنت‌ها",
    messagesetting_icebreaker: "دکمه شروع گفتگوی سریع",
    messagesetting_addNewButton: "افزودن دکمه جدید",
    messagesetting_icebreakerexplain:
      "با ورود کاربر به دایرکت برای اولین بار، چهار دکمه نمایش داده می‌شود که با انتخاب هرکدام، پاسخ مربوطه ارسال می‌شود.",
    messagesetting_addicebreakerexplain: "حداکثر ۴ دکمه شروع گفتگوی سریع اضافه کنید",
    messagesetting_PersistentMenu: "منوی دائمی دایرکت",
    messagesetting_PersistentMenuexplain:
      "منویی همیشه در دسترس که ارتباط مشتریان با برند شما را سریع، راحت و بدون نیاز به تایپ می‌کند.",
    messagesetting_addPersistentMenuexplain: "حداکثر ۳ دکمه منوی دائمی اضافه کنید",
    Welcometodirectmessages: "!به پیام‌های دایرکت اینستاگرام خوش آمدید",
    messagesetting_UseSystemButtonsExplain:
      "از دکمه‌های آماده سیستم برای ارائه اطلاعات استاندارد مانند مشاهده فروشگاه، تیکت پشتیبانی و تغییر زبان استفاده کنید",
    messagesetting_UseAIPromptsExplain:
      "با استفاده از پرامپت‌های هوش مصنوعی، پاسخ‌های هوشمند و شخصی‌سازی‌شده با لحن و نوع رفتار خودتان به کاربران ارائه دهید",
    messagesetting_ButtonTitle: "عنوان دکمه",
    messagesetting_NoPromptsFound: "هیچ پرامپتی یافت نشد. برای ساخت پرامپت جدید به صفحه ایجاد هدایت می‌شوید.",
    messagesetting_CreateNewPrompt: "ایجاد پرامپت جدید",
    messagesetting_SelectYourPrompt: "پرامپت خود را انتخاب کنید",
    messagesetting_DefineCustomResponseExplain:
      "متن پاسخ دلخواه خود را تعریف کنید تا این پاسخ به‌صورت خودکار به کاربران ارسال شود",
    messagesetting_SelectPredefinedFlowExplain:
      "یک فلوی از پیش تعریف‌شده را انتخاب کنید تا مکالمه خودکار و هوشمند با کاربر آغاز شود",
    messagesetting_NoFlowsFound: "هیچ فلویی یافت نشد. برای ساخت فلوی جدید به صفحه ایجاد هدایت می‌شوید.",
    messagesetting_CreateNewFlow: "ایجاد فلوی جدید",
    messagesetting_SelectFlow: "انتخاب فلو",
    messagesetting_ViewFlow: "نمایش فلو",
    messagesetting_UseGeneralAIExplain: "استفاده از هوش مصنوعی عمومی برای تعامل آزاد و بدون محدودیت با کاربران",
    tool_token_usage_guide: "مقدار تقریبی توکن مصرفی هنگام اجرای این ابزار",
    tool_how_use: "نحوه استفاده ابزار",
    tool_how_work: "نحوه عملکرد ابزار",
    send_sms_ir_code_description: "ارسال پیامک به موبایل کاربر از طریق پلتفرم SMS.ir",
    send_sms_ir_code_completeDescription:
      "این ابزار برای ارسال پیامک به کاربران استفاده می‌شود؛ مثل کد احراز هویت، ثبت‌نام یا اطلاع‌رسانی. با استفاده از آن می‌توانید شماره موبایل کاربران را دریافت کرده و در سرویس پیامکی خود استفاده کنید.",
    send_sms_ir_code_howUse: `1- کد ApiKey را از پلتفرم SMS.ir دریافت و وارد کنید.
2- قالب پیامک خود را در قسمت TemplateId وارد کنید.
3- در قالب پیامک هر جا {CODE} باشد، سیستم به صورت خودکار کد یکبار مصرف OTP را جایگزین می‌کند.
`,
    send_sms_ir_code_howWork: `1- کاربر شماره موبایل خود را در دایرکت ارسال می‌کند.
2- پیامک برای موبایل کاربر ارسال می‌شود، اگر کد شامل {CODE} باشد، سیستم آن را با OTP جایگزین می‌کند.
3- کاربر کد را برای هوش مصنوعی ارسال می‌کند.
4- هوش مصنوعی کد را بررسی کرده و شماره موبایل را تأیید می‌کند.
`,

    send_to_telegram_description: "ارسال پیام به تلگرام از طریق ربات",
    send_to_telegram_completeDescription:
      "این ابزار برای ارسال پیام به تلگرام با استفاده از ربات تلگرام استفاده می‌شود. پیام از طریق Bot Token به یک کانال یا چت مشخص ارسال می‌گردد و برای اطلاع‌رسانی، هشدارها و ارسال داده‌ها کاربرد دارد.",
    send_to_telegram_howUse:
      "1- توکن ربات تلگرام را وارد کنید.\n2- آیدی چت یا کانال را وارد کنید.\n3- ابزار را اجرا کنید تا پیام ارسال شود.",
    send_to_telegram_howWork:
      "1- کاربر Token و Channel را وارد می‌کند.\n2- سیستم با Bot API درخواست ارسال پیام را آماده می‌کند.\n3- پیام به کانال یا چت ارسال می‌شود.",

    sender_username_description: "استفاده از نام کاربری فرستنده در پرامپت",
    sender_username_completeDescription:
      "این ابزار به شما امکان می‌دهد نام کاربری فرستنده پیام را در پرامپت‌های هوش مصنوعی استفاده کنید. با قرار دادن {SENDER_USERNAME}، سیستم آن را با نام کاربر جایگزین می‌کند.",
    sender_username_howUse:
      "1- در پرامپت خود {SENDER_USERNAME} را قرار دهید.\n2- هنگام اجرا، سیستم آن را با نام کاربر جایگزین می‌کند.",
    sender_username_howWork:
      "1- کاربر {SENDER_USERNAME} را در پرامپت قرار می‌دهد.\n2- سیستم نام کاربر را جایگزین می‌کند.\n3- AI پاسخ را با استفاده از نام کاربر تولید می‌کند.",

    // #endregion Message Section
    // #region 5️⃣market Section
    // 5️⃣ Market -> home
    filter_most_expensive: "بیشترین قیمت",
    filter_cheapest: "کمترین قیمت",
    filter_newest: "جدیدترین",
    filter_highest_discount: "بیشترین تخفیف",
    filter_all_products: "همه محصولات",
    filter_only_available: "فقط کالاهای موجود",
    filter_reset: "حذف فیلتر‌ها",
    filter_sortby: "مرتب‌سازی بر اساس",
    filter_category: "دسته‌بندی",
    filter_price: "قیمت",
    Pricerange: "محدوده قیمت",
    from: "از",
    to: "تا",
    filter_rating: "امتیاز",
    filter_followers: "فالورها",
    default: "پیش‌فرض",
    lowtohigh: "از کم به زیاد",
    hightolow: "از زیاد به کم",
    biolinkHomerating: "امتیاز",
    biolinkHomefollower: "فالور",
    biolinkHomepost: "پست",
    biolinkHomeAllMarkets: "همه",
    biolinkHomeAdvertise: "تبلیغ‌گیرنده",
    biolinkHomeStore: "فروشگاه",
    biolinkStatisticsAllLinkclicks: "کلیک‌های همه لینک‌ها",
    biolinkStatisticsMarketviews: "بازدیدهای مارکت",
    biolinkStatisticsmostview: "پربازدیدترین",
    biolinkStatisticscouponcodeused: "استفاده از کد تخفیف",
    biolinkStatisticslastupdate: "آخرین بروزرسانی",
    biolinkStatisticsAllsearches: "همه جستجوها",
    biolinkStatisticsfeatures: "تنظیمات",
    biolinkStatisticsVisits: "بازدیدها",
    biolinkStatisticsClicksAndInteractions: "کلیک‌ها و تعاملات",
    biolinkStatisticsVisitsConverted: "بازدیدهای منجر به کلیک",
    biolinkStatisticsQuickUserExitAfterEntry: "خروج سریع کاربران پس از ورود",
    biolinkStatisticsNoInteractionExit: "خروج افراد بدون تعامل",
    biolinkStatisticsMaxClicksPerVisit: "بیشترین کلیک یک کاربر در یک بازدید",
    biolinkStatisticsAvgClicksAndInteractionsPerVisitor: "میانگین کلیک و تعامل هر بازدیدکننده",
    biolinkStatisticsTotalVisitTime: "مجموع زمان بازدید کاربران",
    biolinkStatisticsAvgVisitTime: "میانگین زمان حضور یک بازدیدکننده",
    biolinkStatisticsVideoPlatformsComparison: "مقایسه پلتفرم‌های ویدیویی",
    biolinkStatisticsYoutube: "یوتیوب",
    biolinkStatisticsAparat: "آپارات",
    biolinkStatisticsTwitch: "توییچ",
    biolinkStatisticsPlatformEntry: "ورود به پلتفرم",
    biolinkStatisticsRedirectEvent: "رویداد هدایت",
    biolinkStatisticsPlayVideo: "پخش ویدیو",
    biolinkStatisticsPlayEvent: "رویداد پخش",
    biolinkStatisticsUniqueVisit: "بازدید یکتا",
    biolinkStatisticsDedicatedLinkVisits: "بازدید از لینک اختصاصی",
    biolinkStatisticsCombinedLinkVisits: "نمودار ترکیبی بازدید لینک‌ها",
    // 5️⃣ Market -> Properties
    biolinkPropertiesfeatures: "تنظیمات",
    biolinkPropertiesProfileInfoBanner: "اطلاعات پروفایل و بنر",
    biolinkPropertiesFeaturebox: "باکس ویژگی ها",
    biolinkPropertiesTermsAndActiveTime: "قوانین و ساعات کاری",
    biolinkPropertiesFeatureboxexplain:
      "با فعال‌سازی هر ویژگی، می‌توانید اطلاعات مهمی را به بازدیدکنندگان صفحه لینک خود نمایش دهید",
    biolinkPropertiesBanner: "بنر",
    biolinkPropertiesFeaturesBox: "باکس ویژگی ها",
    biolinkPropertiesReviews: "نقد و بررسی‌ها",
    biolinkPropertiesAnnouncements: "اطلاعیه‌ها",
    biolinkPropertiesAnnouncementsexplain:
      "می‌توانید با نوشتن توضیحاتی در این بخش، اطلاعات مهمی را به بازدیدکنندگان صفحه لینک خود اطلاع‌رسانی کنید",

    biolinkPropertiesOnlineStream: "پخش زنده",
    biolinkPropertiesOnlineStreamexplain:
      "با فعال‌سازی این گزینه، هر زمان که پخش زنده‌ای در کانال خود آغاز کنید، به‌صورت خودکار در لینک اختصاصی‌تان نمایش داده می‌شود",
    biolinkPropertiesLastVideo: "آخرین ویدیو",
    biolinkPropertiesLastVideoexplain:
      "با فعال‌سازی این گزینه، هر زمان ویدیوی جدیدی در کانال خود منتشر کنید، آخرین ویدیو به‌صورت خودکار در لینک اختصاصی‌تان نمایش داده شده و همواره به‌روزرسانی می‌شود",

    biolinkPropertiesProducts: "محصولات",
    biolinkPropertiesProduct: "محصول",
    biolinkProperties_showLast10Products: "نمایش ۱۰ محصول آخر",
    biolinkProperties_showBestSellingProducts: "نمایش پرفروش‌ترین محصولات",
    biolinkPropertiesAdsTimeline: "جدول زمانی تبلیغات",
    biolinkPropertiesQandABox: "باکس سوال و جواب",
    biolinkPropertiesLinkShortcut: "لینک میان‌بر ",
    biolinkPropertiesContactAndMap: "تماس و نقشه",
    biolinkPropertieslinks: "لینک‌ها",
    clickonstreamvideo: "برای تماشای پخش زنده روی ویدیو کلیک کنید",
    livestarted: "پخش زنده در حال اجرا است",
    live: "زنده",
    biolinkPropertiesaddnew: "افزودن لینک جدید",
    biolinkProperties_DomainManager: "مدیریت دامنه",
    biolinkProperties_DomainManagerexplain: "وب‌سایت اختصاصی شما",
    biolinkProperties_DomainManagerexplain2:
      "می‌توانید این لینک را در Bio اینستاگرام قرار دهید یا با دیگر کاربران به اشتراک بگذارید",

    biolinkProperties_explain:
      "در صورتی که نام کاربری اینستاگرام تغییر کند، این لینک به‌طور خودکار به‌روزرسانی می‌شود.",
    biolinkProperties_rejected: "دامنه شما رد شده است (لطفاً با ما تماس بگیرید)",
    customDomain_inactive_title: "دامنه اختصاصی غیرفعال است",
    customDomain_inactive_desc: "دامنه شما در حال حاضر غیرفعال است. لطفاً برای فعال‌سازی با پشتیبانی تیکت ارسال کنید.",
    customDomain_noPackage_title: "پکیج دامنه اختصاصی یافت نشد",
    customDomain_noPackage_desc:
      "پکیج فعلی شما شامل دامنه اختصاصی نمی‌شود. برای استفاده از این قابلیت، پکیج خود را ارتقا دهید.",
    customDomain_rule_validChars: "فقط حروف و اعداد مجاز هستند",
    customDomain_rule_noUnderscore: "کاراکترهای (_) و (-) مجاز نیستند",
    customDomain_rule_noSubdomain: "دامنه‌های زیرمجموعه (Subdomain) مجاز نیستند",
    biolinkProperties_Request: "درخواست",
    biolinkProperties_Connect: "اتصال",
    biolinkProperties_Requested: "درخواست شده",
    biolinkProperties_Checking: "در حال بررسی",
    biolinkProperties_yourstore: "فروشگاه (لینک فروشگاه شما)",
    biolinkProperties_yourads: "لینک سفارش تبلیغات",
    biolinkProperties_yourlottery: "قرعه‌کشی‌های انجام‌شده شما",
    biolinkProperties_yourtariff: "تعرفه (جدول قیمت شما)",
    biolinkProperties_yourBusinesshours: "ساعات کاری فعال شما",
    biolinkProperties_yourBusinessTerms: "شرایط کسب و کار شما",
    biolinkProperties_defaultAddress: "آدرس دامنه پیش‌فرض",
    biolinkProperties_CustomAddress: "آدرس دامنه سفارشی شما",
    biolinkPropertiespopup_GeneralCustom: "عمومی",
    biolinkPropertiespopup_socialmedia: "شبکه‌های اجتماعی",
    biolinkPropertiespopup_mediastream: "رسانه و استریم",
    biolinkPropertiespopup_clouddrivecontent: "محتوای درایو ابری",
    biolinkPropertiespopup_Finance: "امور مالی",
    biolinkProperties_followersrate: "تعداد فالورها",
    biolinkProperties_followersrateExplain: "تعداد فالورهای پیج اینستاگرام شما نمایش داده می‌شود",
    biolinkProperties_successRating: "امتیاز موفقیت",
    biolinkProperties_successRatingExplain: "امتیاز موفقیت شما در انجام سفارشات نمایش داده می‌شود",
    biolinkProperties_bussinessHours: "ساعات کاری فعال",
    biolinkProperties_bussinessHoursExplain: "ساعات کاری فعال کسب‌وکار شما نمایش داده می‌شود",
    biolinkProperties_Enamadverified: "نماد اعتماد الکترونیکی",
    biolinkProperties_EnamadverifiedExplain: "وضعیت تأیید نماد اعتماد الکترونیکی شما نمایش داده می‌شود",
    biolinkProperties_BusinessTerms: "شرایط کسب‌وکار",
    biolinkProperties_BusinessTermsExplain: "شرایط و قوانین کسب‌وکار شما نمایش داده می‌شود",
    biolinkProperties_tariff: "تعرفه",
    biolinkProperties_TariffExplain: "تعرفه‌های خدمات شما نمایش داده می‌شود",
    biolinkProperties_StartADS: "شروع درخواست تبلیغات",
    biolinkProperties_StartADSExplain: "کاربر می‌تواند بر اساس تعرفه‌های شما تبلیغات خود را شروع کند",
    biolinkProperties_StartSALES: "شروع درخواست خرید",
    biolinkProperties_StartSALESExplain: "کاربر می‌تواند بر اساس محصولات شما خرید خود را شروع کند",
    biolinkProperties_NameServers: "نیم‌سرورهای دامنه",
    biolinkProperties_NameServersExplain: "نیم‌سرورها را در پنل ارائه‌دهنده دامنه خود ثبت کنید",
    customDomain_dnsError: "هنوز نیم‌سرورهای دامنه در ارائه‌دهنده دامنه شما ثبت نشده‌اند. دوباره تلاش کنید",
    customDomain_active_desc: "برای تغییر یا حذف این دامنه، درخواست خود را از بخش تنظیمات تیکت ارسال کنید",
    biolinkProperties_NameServerstooltip:
      "درخواست شما ممکن است تا ۱۲ ساعت زمان ببرد تا نیم‌سرورها در اینترنت منتشر شوند و دامنه شما فعال شود.",
    linkURL: "آدرس لینک",
    searchID: "افزودن کانال",
    searchIDexplain: "ایدی شخص یا اسم کانال مورد نظر را بنویسید",

    Browse: "مرور",
    biolinkPropertiespopup_yourcustomIcon: "آیکن سفارشی شما",
    Boldit: "جلب توجه کن!",

    Scheduletime: "زمان‌بندی حذف خودکار",
    biolinkPropertiespopup_ProfileInfo: "اطلاعات پروفایل",
    biolinkPropertiespopup_Banner: "بنر",
    biolinkPropertiespopup_Personal: "شخصی",
    biolinkPropertiespopup_SameasInstagramProfile: "همان پروفایل اینستاگرام",

    marketpropertise_aboutus: "این سایت از طریق پلتفرم برنسی ایجاد شده است",
    marketpropertise_copyright: "تمامی حقوق این سایت متعلق است به",
    marketpropertise_aboutusslogan: "برنسی بهترین انتخاب برای ایجاد بایولینک هوشمند و مدیریت پیج اینستاگرم",
    marketpropertise_madeby: "ساخته‌شده با 🤍 توسط",

    custom: "سفارشی",
    advertiseProperties_biography: "بیوگرافی",
    uploadbannerexplain: "آپلود چندین تصویر می‌تواند بر سرعت بارگذاری تأثیر بگذارد.",
    Embed: "قراردادن ویدیو",
    Embedexplain:
      "با فعال‌سازی این گزینه، ویدیو به‌صورت مستقیم در لینک اختصاصی نمایش و پخش می‌شود و کاربر بدون نیاز به ترک صفحه یا انتقال به پلتفرم دیگر قادر به مشاهده آن خواهد بود",
    notfound: "یافت نشد",
    showsavecontactbutton: "نمایش دکمه ذخیره تماس",
    Map: "نقشه",
    Contact: "تماس",
    Showmap: "نمایش نقشه",
    location: "موقعیت",
    phone: "تلفن",
    invalidphone: "تلفن نامعتبر",
    email: "ایمیل",
    invalidemail: "ایمیل نامعتبر",
    Address: "آدرس",
    // #endregion Market Section
    // #region 6️⃣advertise Section
    advertise_ADDetail: "جزئیات تبلیغ",
    content: "محتوا",
    advertise_orderdate: "تاریخ سفارش",
    advertise_duration: "مدت زمان",
    Remaining: "باقیمانده",
    ago: "پیش",
    // advertise -> calendar
    advertisecalendar_calendar: "تقویم",
    advertisecalendar_nextday: "تبلیغات بعدی برای این روز",
    advertisecalendar_TODAY: "امروز",
    advertisecalendar_BookaTime: "رزرو یک زمان",
    advertisecalendar_TIMELINEZOOM: "بزرگنمایی خط زمانی",
    advertisecalendar_Timeline: "جدول زمانی",
    // advertise -> statistics
    advertisestatistics_lasttwomonth: "دو ماه گذشته",
    advertisestatistics_lastmonth: "ماه گذشته",
    advertisestatistics_thismonth: "این ماه",
    advertisestatistics_ads: "تبلیغ",
    advertisestatistics_fromlast: "% از ماه گذشته",
    advertisestatistics_totalADSstatistics: "آمار کل تبلیغات",
    advertisestatistics_TotalAds: "کل تبلیغات",
    advertisestatistics_TotalIncome: "کل درآمد",
    advertisestatistics_totaladsreport: "گزارش کل تبلیغات",
    advertisestatistics_adno: "شماره تبلیغ ",
    advertisestatistics_advertiser: "تبلیغ‌کننده",
    advertisestatistics_type: "نوع",
    advertisestatistics_status: "وضعیت",
    advertisestatistics_price: "قیمت",
    advertisestatistics_date: "تاریخ",
    advertisestatistics_share: "اشتراک",
    // advertise -> adlist
    advertiseadlist_activeAd: "تبلیغات منتشر شده",
    advertiseadlist_AwaitingApproval: "تبلیغات در انتظار تأیید",
    advertiseadlist_AwaitingPublication: "تبلیغات برنامه‌ریزی شده",
    advertiseadlist_rejectedlist: "تبلیغات رد شده",
    // advertise -> Properties
    advertiseProperties_Concurrentads: "تبلیغات همزمان",
    advertiseProperties_Concurrentadsexplain: "تعداد تبلیغات فعال در یک زمان مشخص",
    advertiseProperties_numberofads: "تعداد تبلیغات در پیج",
    advertiseProperties_numberofadsexplain: "تعداد تبلیغات فعال در طول روز",
    advertiseProperties_campaign: "کمپین",
    advertiseProperties_campaignexplain: "امکان شرکت در کمپین‌های تبلیغاتی توسط برنسی",
    advertiseProperties_adsoptions: "گزینه‌های تبلیغات",
    advertiseProperties_rejectreasonheader1: "دلیل ۱ (محتوای نامرتبط)",
    advertiseProperties_rejectreasonheader2: "دلیل ۲ (محتوای ناسالم)",
    advertiseProperties_rejectreasonheader3: "دلیل ۳ (نقض سیاست‌ها)",
    advertiseProperties_rejectreasonheader4: "دلیل ۴ (بازخورد منفی)",
    advertiseProperties_rejectreason1:
      "متأسفانه، محتوای ارائه شده با ارزش‌ها و اهداف پیج ما همخوانی ندارد، برای مخاطبان ما نامرتبط است یا فاقد اطلاعات ضروری است، بنابراین نمی‌توانیم این تبلیغ را بپذیریم.",
    advertiseProperties_rejectreason2:
      "متأسفانه، محتوای ارائه شده ممکن است برای مخاطبان ما ناسالم، گمراه‌کننده یا حاوی اطلاعات پیچیده باشد و نیاز به تغییرات گسترده دارد، بنابراین نمی‌توانیم این تبلیغ را بپذیریم.",
    advertiseProperties_rejectreason3:
      "متأسفانه، محتوای ارائه شده با قوانین و مقررات ما یا اینستاگرام همخوانی ندارد و ممکن است غیرمعقول، توهین‌آمیز، بحث‌برانگیز یا جرم‌انگاری تلقی شود. بنابراین نمی‌توانیم این تبلیغ را بپذیریم.",
    advertiseProperties_rejectreason4:
      "متأسفانه، به دلیل حجم بالای تبلیغات مشابه، ناهماهنگی زمانی، نظرات منفی کاربران در تجربیات قبلی یا کیفیت پایین محتوای ارائه شده، نمی‌توانیم این تبلیغ را بپذیریم.",
    advertiseProperties_AdvertisingTerms: "شرایط تبلیغات",
    advertiseProperties_AdvertisingTermsexplain:
      "تبلیغ‌دهندگان باید این قوانین را بپذیرند تا بتوانند در صفحه شما تبلیغ کنند.",
    advertiseProperties_AdvertisingTerm1: "شرط ۱ صفحه شما",
    advertiseProperties_AdvertisingTerm2: "شرط ۲ صفحه شما",
    advertiseProperties_AdvertisingTerm3: "شرط ۳ صفحه شما",
    advertiseProperties_AdvertisingTerm4: "شرط ۴ صفحه شما",
    advertiseProperties_AdvertisingTermsave: "ذخیره",
    advertiseProperties_businesshours: "ساعات کاری فعال ادمین",
    advertiseProperties_24hours: "۲۴ ساعت فعال",
    advertiseProperties_close: "۲۴ ساعت غیرفعال",
    advertiseProperties_notifications: "اعلان‌ها",
    advertiseProperties_notificationsSMS: "پیامک",
    advertiseProperties_notificationsEmail: "ایمیل",
    advertiseProperties_notificationssystem: "اعلان سیستمی",
    advertiseProperties_notificationsinstagramdirect: "دایرکت اینستاگرام",
    advertiseProperties_notificationssystemticket: "تیکت",
    advertiseProperties_advertisetariff: "تعرفه تبلیغات",
    advertiseProperties_onlyToday: "فقط برای امروز",
    advertiseProperties_onlyTodayexplain: "تعرفه قیمت تبلیغات فقط برای امروز",
    advertiseProperties_tariff12hours: "۱۲ ساعت",
    advertiseProperties_tariff24hours: "۲۴ ساعت",
    advertiseProperties_otherdays: "پایه (روزهای دیگر)",
    advertiseProperties_otherdaysexplain: "تعرفه قیمت تبلیغات برای روزهای دیگر",
    advertiseProperties_Campaign: "کمپین",
    advertiseProperties_Campaignexplain: "تعرفه قیمت تبلیغات برای کمپین",
    advertiseProperties_lastModified: "آخرین تغییرات",
    advertiseProperties_userreport: "گزارش کاربر",
    advertiseProperties_userID: "شناسه کاربر",
    advertiseProperties_reportexplain: "گزارش شما به پشتیبانی برنسی ارسال خواهد شد.",
    advertiseProperties_reportsubmit: "ارسال",
    Apply: "اعمال",
    signinyouradvertise: "فعالسازی تبلیغات",
    signinyouradvertiseExplain: "تبلیغات خود را با چند کلیک فعال کنید",

    // #endregion advetise Section
    // #region 7️⃣Store Section
    // Store -> product
    Storeproduct_activatestore: "فعالسازی فروشگاه",
    signinyourstore: "ساخت فروشگاه",
    signinyourstoreExplain: "فروشگاه خود را با چند کلیک بسازید",
    Storeproduct_needyourID: "تأیید هویت",
    Storeproduct_needyourIDExplain: "کارت شناسایی را آپلود کنید",
    Storeproduct_successyourID: "هویت شما با موفقیت تایید شده است",
    Storeproduct_NationalCardexplain:
      "این کارت باید متعلق به فردی باشد که با شماره موبایل خود در برنسی ثبت‌نام کرده است.",
    Storeproduct_addcreditnumber: "اطلاعات مالی",
    Storeproduct_addcreditnumberExplain: "کارت بانکی خود را وارد کنید",
    Storeproduct_successnumber: "اطلاعات بانکی شما با موفقیت تأیید شده است",
    Storeproduct_shippingmethod: "نحوه ارسال",
    Storeproduct_shippingmethodExplain: "روش ارسال خود را انتخاب کنید",
    Storeproduct_shippingmethodsuccess: "روش ارسال انتخاب شده با موفقیت ثبت شده است",
    Storeproduct_shippingmethodtooltip:
      "روش‌های پیشنهادی بر اساس موقعیت شما انتخاب شده‌اند. بعداً  نیز در تنظیمات فروشگاه قابل ویرایش و تغییر هستند.",
    Storeproduct_uploadimagefirst: "لطفاً ابتدا عکس کارت ملی خود را آپلود کنید",
    Storeproduct_creditcardsameidcard: "شماره کارت بانکی باید متعلق به دارنده‌ی کارت ملی باشد",
    Storeproduct_postalcode: "نشانی کسب‌وکار",
    Storeproduct_postalcodeExplain: "کد پستی را وارد کنید",
    Storeproduct_postalcodesuccess: "آدرس و موقعیت با موفقیت ثبت شده است",
    Storeproduct_postalcodeinputExplain: "هزینه ارسال براساس این آدرس محاسبه می‌شود، لطفاً کد پستی را دقیق وارد کنید.",
    Storeproduct_TermsAndCondition: "شرایط و قوانین",
    Storeproduct_TermsAndConditionExplain: "قوانین را مطالعه و تأیید کنید",
    Storeproduct_TermsAndConditionesuccess: "پذیرش قوانین با موفقیت ثبت شده است",
    Storeproduct_AcceptTermsAndCondition:
      "من تمامی قوانین و مقررات مربوط به ساخت فروشگاه در برنسی را مطالعه کرده و آن را می‌پذیرم",
    Storeproduct_notyet: "شما هنوز هیچ محصولی اضافه نکرده‌اید!",
    Storeproduct_addnow: "الان محصولات را اضافه کنید",
    Storeproduct_addexplain: "محصولات به صورت خودکار از صفحه اینستاگرام شما اضافه خواهند شد.",
    Storeproduct_productlist: "لیست محصولات",
    Storeproduct_search: "'PID' جستجو 'نام محصول' یا ",
    Storeproduct_importproduct: "وارد کردن محصول",
    Storeproduct_importfrominsta: "وارد کردن از اینستاگرام شما",
    Storeproduct_newproduct: "محصول جدید",
    Storeproduct_addnewproduct: "افزودن  محصول جدید",
    Storeproduct_name: "نام محصول",
    Storeproduct_weight: "وزن",
    Storeproduct_size: "اندازه",
    Storeproduct_color: "رنگ",
    Storeproduct_stock: "موجودی",
    Storeproduct_price: "قیمت",
    Storeproduct_active: "فعال",
    Storeproduct_gram: "گرم",
    bulkProduct: {
      title: "مدیریت محصولات انتخاب‌شده",
      selectedCount: "{{count}} محصول انتخاب شده",
      priceChange: "تغییر قیمت",
      valueType: "نوع مقدار",
      amount: "مبلغ",
      increase: "افزایش",
      decrease: "کاهش",
      applyAll: "اعمال یکسان برای همه محصولات",
      applyIndividual: "تنظیم جداگانه هر محصول",
      allProducts: "اعمال روی هر {{count}} محصول",
      discountAllHint: "یک درصد یا مبلغ ثابت تخفیف برای همه محصولات انتخاب‌شده تعیین کنید.",
      priceAllHint: "قیمت همه محصولات را به صورت درصدی یا مبلغ ثابت افزایش یا کاهش دهید.",
      currentDiscount: "تخفیف فعلی",
      saving: "در حال ذخیره...",
    },
    loadingmoreproducts: "در حال بارگذاری محصولات بیشتر...",
    noMoreProducts: "محصولات بیشتری وجود ندارد",

    //store -> statistics
    storestatistics_lasttwomonth: "دو ماه گذشته",
    storestatistics_lastmonth: "ماه گذشته",
    storestatistics_thismonth: "این ماه",
    storestatistics_sales: "فروش",
    storestatistics_fromlast: "٪ از ماه گذشته",
    storestatistics_totalSalesstatistics: "آمار کل فروش‌ها",
    storestatistics_TotalSales: "کل فروش‌ها",
    storestatistics_TotalIncome: "کل درآمد",
    storestatistics_totalsalesreport: "خریداران برتر",
    storestatistics_buyer: "مشخصات خریدار",
    storestatistics_totalPurchases: "تعداد کل خریدها",
    storestatistics_totalAmount: "مبلغ کل خریدها",
    storestatistics_lastPurchase: "آخرین زمان خرید",
    storestatistics_saleno: "شماره فروش",
    storestatistics_seller: "فروشنده",
    storestatistics_type: "نوع",
    storestatistics_status: "وضعیت",
    storestatistics_price: "قیمت",
    storestatistics_date: "تاریخ",
    storestatistics_share: "اشتراک",
    storestatistics_couponTitle: "تخفیف‌ها",
    storestatistics_addCoupon: "افزودن کد تخفیف",
    storestatistics_noCoupons: "هنوز کد تخفیفی ایجاد نشده است.",
    storestatistics_couponCode: "کد تخفیف",
    storestatistics_discountPercent: "درصد تخفیف",
    storestatistics_maxUses: "حداکثر استفاده",
    storestatistics_phoneNumber: "شماره تلفن",
    storestatistics_maxDiscountOptional: "سقف تخفیف (اختیاری)",
    storestatistics_couponExpiry: "زمان انقضا (باید حداقل ۱ ساعت از اکنون فاصله داشته باشد)",
    storestatistics_showInBio: "نمایش در بیو",
    storestatistics_couponDeleted: "حذف شده",
    storestatistics_couponExpired: "منقضی شده",
    storestatistics_couponExhausted: "تکمیل شده",
    storestatistics_couponActive: "فعال",
    storestatistics_unlimited: "نامحدود",
    storestatistics_couponUsage: "{{used}} از {{max}} استفاده",
    storestatistics_discountValue: "{{discount}}٪ تخفیف",
    storestatistics_maxDiscountValue: "سقف: {{value}}",
    storestatistics_expiryValue: "انقضا: {{date}}",
    storestatistics_private: "private",
    storestatistics_public: "public",
    // Store -> order
    incartcount: "در سبد خرید",
    addtocart: "افزودن به سبد خرید",
    AllProducts: "همه محصولات",
    Storeproduct_inQueue: "در انتظار تایید",
    Storeproduct_inprogress: "در حال پردازش",
    Storeproduct_pickingup: "جمع‌آوری",
    Storeproduct_sent: "ارسال شده",
    Storeproduct_delivered: "تحویل داده شده",
    Storeproduct_failed: "ناموفق",
    Storeproduct_canceledbyuser: "لغو شده توسط خریدار",
    Storeproduct_canceledbyadmin: "لغو شده توسط ادمین",

    Storeproduct_returned: "مرجوع شده",
    Storeproduct_yourcartisempty: "سبد خرید شما خالی است",
    Storeproduct_noitemfounded: "موردی یافت نشد",
    Storeproduct_incart: "سبد خرید",
    ShowUnprocessedItemsOnly: "موارد پردازش‌نشده",
    pageStatistics_fromstore: "از فروشگاه",
    ordernumber: "شماره سفارش",
    order_addressSubject: "خانه،محل کار",
    order_addressReceiver: "نام گیرنده در این آدرس",
    order_addressNote: "یادداشت آدرس",

    Storeorder_all: "همه",
    Storeorder_ORDERID: "شماره سفارش",
    Storeorder_CUSTOMER: "مشتری",
    Storeorder_ITEMS: "موارد",
    Storeorder_ITEM: "مورد",
    Storeorder_PRICE: "قیمت",
    Storeorder_OrderDATE: "تاریخ سفارش",
    copytrackingcode: "کپی کد رهگیری",
    Storeorder_SentDATE: "تاریخ ارسال",
    Storeorder_deliverdate: "تاریخ تحویل",
    Storeorder_DELIVERY: "ارسال توسط",
    Storeorder_Destination: "مقصد",
    Storeorder_STATUS: "وضعیت",
    Storeorder_DETAILS: "جزئیات",
    Storeorder_PickupRequest: "درخواست جمع‌آوری",
    Storeorder_PrintWaybill: "چاپ بارنامه",
    Storeorder_Waybill: "بارنامه",
    Storeorder_WaybillExplain:
      "لطفاً پیش از ثبت درخواست جمع‌آوری، بارنامه را چاپ کرده و به‌صورت خوانا، صاف و محکم بر روی بسته‌بندی بچسبانید.",
    Storeorder_noneSendExplain:
      "با توجه به این‌که ارسال این بسته از طریق سیستم ارسال برنسی امکان‌پذیر نبوده و شما آن را شخصاً و با مسئولیت خود ارسال کرده‌اید، لازم است این مرحله را تأیید نمایید.  با تأیید این مرحله، به خریدار اطلاع داده خواهد شد که بسته برای او ارسال شده است.",
    Storeorder_ManualTrackingExplain:
      "با توجه به تحویل مستقیم بسته به باربری توسط شما، لطفاً پس از دریافت کد رهگیری، آن را در کادر مربوطه ثبت و این مرحله را تأیید نمایید.  با این اقدام، برنسی به‌صورت خودکار کد رهگیری و اطلاعات ارسال را به خریدار اطلاع خواهد داد.",
    Storeorder_SendExplain: "اطلاعات این قسمت به صورت خودکار به روز رسانی خواهد شد",

    Storeorder_requestedpickup: "در انتظار جمع‌آوری",
    Storeorder_TrackingCode: "کد رهگیری",
    Storeorder_IssuingTrackingCode: "در حال صدور کد رهگیری",
    Storeorder_bymyself: "توسط خودم",
    Storeorder_Envelope: "پاکت",
    Storeorder_Invoice: "صورتحساب",

    Storeorder_PostMan: "پستچی",
    Storeorder_from: "ارسال از",
    Storeorder_currentLocation: "موقعیت فعلی",
    Storeorder_lastUpdateTime: "آخرین زمان بروزرسانی",
    Storeorder_sender: "فرستنده",

    Storeorder_DeliveryAmount: "هزینه ارسال",
    Storeorder_InsuranceAmount: "هزینه بیمه",
    Storeorder_Coupon: "کد تخفیف",
    Storeorder_RemoveCoupon: "حذف کد تخفیف",
    Storeorder_Productsinyourshoppingcart: "محصولات در سبد خرید شما",
    Storeorder_SendtotheAddress: "ارسال به این آدرس",
    Storeorder_changeofaddress: "تغییر آدرس",

    Storeorder_postparselbox: "جعبه پستی",
    Storeorder_pocketenveloptitle: "تعداد محصول در هر پاکت",
    Storeorder_pocketenveloptitleExplain:
      "لطفاً مشخص کنید که از این محصول، چه تعداد در یک پاکت معمولی (یا بسته‌بندی استاندارد شما) جا می‌گیرد. این عدد به ما کمک می‌کند تا محاسبات انبار، بسته‌بندی و ارسال دقیق‌تری داشته باشیم.",
    Storeorder_orderDetailsStep: "اطلاعات سفارش",
    Storeorder_orderconfirmStep: "سایز بسته و بارنامه",
    Storeorder_orderlist: "لیست سفارشات",
    Storeorder_singleorder: "سفارش",
    Storeorder_quantityorder: "تعداد",
    Showmore: "نمایش بیشتر",
    totalprice: "قیمت کل",
    note: "یادداشت",
    navbar_PaymentNumber: "کد رهگیری پرداخت",
    Storeorder_receiver: "گیرنده",
    Storeorder_AcceptthisOrder: "تأیید این سفارش",
    Storeorder_ParselisConfirmed: "تایید می‌کنم که مشخصات وارد شده صحیح است",
    Storeorder_ParselisConfirmedExplain: "اشتباه در وارد کردن سایز یا وزن منجر به جریمه و برگشت بسته می‌شود",
    Storeorder_CancelOrder: "لغو سفارش",
    Storeorder_nextWaybill: "ادامه ( دریافت بارنامه )",
    Storeorder_Pickedup: "جمع‌آوری شده",
    SelectProduct: "انتخاب محصول",
    SelectedPosts: "پست‌های انتخاب شده:",
    BacktoProductList: "بازگشت به لیست محصولات",
    Backtocart: "بازگشت به سبد خرید",
    product_BasicDetail: "جزئیات پایه",
    product_ProductID: "شناسه محصول",
    product_Producttitle: "عنوان محصول",
    product_Product: "محصولات",
    product_Categories: "دسته‌بندی ها",
    product_MainCategory: "دسته اصلی",
    product_Subcategory: "زیر دسته",
    product_Subset: "زیر مجموعه",
    product_Group: "گروه",
    product_Branch: "شاخه",
    product_Subbranch: "زیر شاخه",
    product_Dependency: "وابستگی",
    product_Brand: "برند",
    product_instagramcaption: "کپشن اینستاگرام",
    product_productDescription: "توضیحات محصول",
    product_Informationplaceholder:
      "در این قسمت میتوانید توضیحات محصول خود را بنویسید \n\n این توضیحات میتواند حاوی اطلاعات کامل و جذابی مانند \n ویژگی‌ها، مزایا و جزئیات کلیدی محصول ویا نحوه استفاده، مواد تشکیل‌دهنده \n را به‌طور مختصر و مفید بیان کند.\n\n مشتریان نسبت به این اطلاعات با ویژگی محصول بیشتر آشنا شده و شانس فروش محصول بیشتر خواهد شد.",
    product_General: "عمومی",
    product_Specifications: "مشخصات",
    product_Information: "توضیحات",
    product_addNewTable: "افزودن جدول جدید",
    product_EditTable: "ویرایش جدول",
    product_PreviewTable: "جدول",
    product_addtable: "ایجاد جدول",
    product_tabletitle: "عنوان جدول (اختیاری)",
    product_tabletitleExplain: "مثلا: جدول سایز بندی",
    product_tableheaderoption: "ردیف اول به عنوان هدر",
    product_AddColumn: "افزودن ستون کنار این ستون",
    product_DeleteColumn: "حذف این ستون",
    product_AddRow: "افزودن ردیف زیر این ردیف",
    product_DeleteRow: "حذف این ردیف",
    rowheader: "هدر",
    cell: "سلول",
    product_Media: "محتوا",
    Nodescriptionavailable: "توضیحات موجود نیست",
    NoSpecificationsavailable: "مشخصات موجود نیست",
    product_Properties: "ویژگی‌ها",
    product_Setting: "تنظیمات",
    product_productdeleted: "محصول حذف شد",
    product_SetProperties: "تنظیم ویژگی‌ها",
    product_SetPropertiesexplain: "شما می‌توانید ۱ تا ۳ ویژگی انتخاب کنید و یکی از آنها می‌تواند سفارشی باشد",
    product_AddNewproperty: "افزودن ویژگی جدید",
    product_Nopropertyisset: "هیچ ویژگی تنظیم نشده است",
    product_Variation: "مدل",
    product_Discount: "تخفیف",
    product_PricewithDiscount: "قیمت با تخفیف",
    product_AddNewVariation: "افزودن مدل جدید",
    product_Definenew: "تعریف جدید (شخصی‌سازی)",
    product_systemlist: "لیست پیش‌فرض هوشمند",
    product_itemlist: "لیست آیتم‌ها",
    product_Available: "موجود",
    product_supplying: "درحال تامین",
    product_OutOfStock: "ناموجود",
    product_Stoppedsale: "توقف فروش",
    product_draft: "پیش‌نویس",
    product_Amount: "مقدار",
    product_NUMBEROFUSES: "تعداد دفعات قابل استفاده",
    product_UNLIMITED: "نامحدود",
    product_LIMITED: "محدود",
    product_USINGTIMES: "مقدار زمان قابل استفاده",
    product_UNLIMITEDTIME: "زمان نامحدود",
    permanent: "دائمی",
    product_LIMITEDTIME: "زمان محدود",
    product_mediatitle: "مدیریت تصاویر و ویدیوهای محصول",
    product_clicktoupload: "برای بارگذاری کلیک کنید",
    product_SuggestedImages: "تصاویر پیشنهادی",
    product_SuggestedImagesExplain:
      "با استفاده از تصاویر پیشنهادی، گالری محصول خود را بهبود دهید یا تصاویر دلخواه خود را بارگذاری کنید",
    product_ordragdrop: "یا بکشید و رها کنید",
    product_productspecifications: "مشخصات محصول",
    product_choosesystemlist: "انتخاب از لیست سیستم",
    product_choosesystemlistexplain: "هر مشخصاتی که نیاز دارید جستجو و انتخاب کنید",
    product_Definenewexplain: "اگر نتوانستید مشخصات را پیدا کنید، آن را ایجاد کنید",
    product_importbatch: "وارد کردن دسته",
    product_importbatchexplain: "همه مشخصات را از محصول قبلی اضافه کنید",
    Value: "مقدار",
    Undefined: "تعریف‌ نشده",
    product_original: "اصلی",
    product_HighCopy: "های‌کپی",
    product_notoriginal: "غیراصل",
    product_Corporate: "شرکتی",
    product_Miscellaneous: "متفرقه",
    product_fake: "فیک",
    tomorrow: "فردا",
    NotSet: "تنظیم نشده",
    Yes: "بله",
    No: "خیر",
    "Video generation request sent.": "درخواست ایجاد ویدیو ارسال شد.",
    "Image generation request sent.": "درخواست ایجاد تصویر ارسال شد.",
    ", Image generation failed.": ", ایجاد تصویر ناموفق بود.",
    "Create and manage AI-generated images and videos.":
      "تصاویر و ویدیوهای ایجادشده با هوش مصنوعی را بسازید و مدیریت کنید.",
    Storeproduct_OutOfStandardSize: "خارج از سایز استاندارد",
    product_box: "کارتن سایز",
    Product_Availablity: "موجودی",
    Product_maxincart: "حداکثر در سبد",
    Product_originality: "اصالت",
    Product_preperingforship: "آماده‌سازی برای ارسال",
    Product_Evat: "مالیات بر ارزش افزوده",
    Product_Evatcount: "مقدار مالیات",
    Product_Guarantee: "گارانتی",
    Product_Guaranteelength: "مدت گارانتی",
    Product_packageshipping: "بسته‌بندی و ارسال",
    Product_packageshippingexplain: "با غیرفعال کردن این گزینه، ارسال محصول و سایر خدمات وابسته بر عهده شما خواهد بود",
    Product_titleExplain:
      "عنوان‌های پیشنهادی بر اساس ویژگی‌های محصول شما و میانگین عناوین مشابه در بازار ارائه شده‌اند تا نمایش آن در جستجوها و محصولات مشابه افزایش یابد.\n (این عناوین می‌تواند شامل خطا باشد)",
    Product_Breakable: "شکستنی",
    Product_Luquid: "مایعات",
    Product_sack: "کیسه‌ای / گونی",
    Product_sackExplain:
      "در صورتی که محصول شما به صورت گونی، کیسه، بگ، یا بسته‌بندی‌های نرم و قابل انعطاف ارسال می‌شود، این گزینه را انتخاب کنید. این انتخاب به ما کمک می‌کند تا نحوه چیدمان، حمل و بسته‌بندی را بهتر مدیریت کنیم.",
    Product_Productweights: "وزن محصول",
    Product_Productweightsexplian: "وزن خالص محصول بدون بسته بندی",
    Product_packaging: "بسته‌بندی",
    Product_packagingexplian:
      "وزن بسته بندی محصول بدون محتویات داخلی که شامل مقوای بسته بندی و چسب و برگه بارنامه می باشد و سیستم محاسبه میکند",
    Product_shippingSize: "ابعاد بسته‌بندی ",
    product_SuggestedPrice: "آنالیز قیمت این محصول در کل بازار",
    product_MinimumPrice: "حداقل قیمت",
    product_AveragePrice: "میانگین قیمت",
    product_MaximumPrice: "حداکثر قیمت",
    length: "طول",
    width: "عرض",
    height: "ارتفاع",
    Weight: "وزن",
    finalWeight: "وزن نهایی",
    product_deleteproductexplain: "شما در حال تلاش برای حذف این محصول هستید",
    // #endregion Store Section
    // #region 8️⃣Setting Section
    // Setting -> General -> System
    SettingGeneralSystemTitle: "سیستم",
    SettingGeneralSystemlanguage: "زبان",
    SettingGeneralSystemcalendar: "تقویم",
    SettingGeneralSystemGregorian: "میلادی",
    SettingGeneralSystemshamsi: "شمسی",
    SettingGeneralSystemHijri: "هجری",
    SettingGeneralSystemHindi: "هندی",
    SettingGeneralSystemStartWeek: "شروع هفته",
    SettingGeneralSystemsaturday: "شنبه",
    SettingGeneralSystemmonday: "دوشنبه",
    SettingGeneralSystemtuesday: "سه‌شنبه",
    SettingGeneralSystemwednesday: "چهارشنبه",
    SettingGeneralSystemthursday: "پنج‌شنبه",
    SettingGeneralSystemfriday: "جمعه",
    SettingGeneralSystemsunday: "یکشنبه",
    SettingGeneralSystemtheme: "تم",
    SettingGeneralSystemDarkmode: "حالت تاریک",
    SettingGeneralSystemlightmode: "حالت روشن",
    SettingGeneralSystemPrice: "مدل قیمت",
    SettingGeneralSystemDollar: "دلار",
    SettingGeneralSystemeuro: "یورو",
    SettingGeneralSystempound: "پوند",
    SettingGeneralSystemrial: "ریال",
    SettingGeneralSystemtoman: "تومان",
    // Setting -> General -> AI Models
    SettingGeneralAiModelsTitle: "مدل‌های هوش مصنوعی",
    SettingGeneralAiModelsTextModels: "مدل‌های متنی",
    SettingGeneralAiModelsVoiceModels: "مدل‌های تبدیل صدا به متن",
    SettingGeneralAiModelsDirectVoiceSupport: "پشتیبانی مستقیم صوتی",
    // Setting -> General -> Profile
    SettingGeneralProfileTitle: "پروفایل",
    SettingGeneral_activedevice: "دستگاه‌های فعال",
    SettingGeneral_leatestentery: "تاریخچه فعالیت کاربر",
    SettingGeneral_cantdeletesession: "نشست‌هایی که کمتر از ۲۴ ساعت از ایجاد آن‌ها گذشته باشد، قابل حذف نیستند.",
    SettingGeneral_deletesession: "شما در حال تلاش برای حذف این نشست هستید.",
    SettingGeneral_addSubAdmin: "افزودن ادمین همکار",
    SettingGeneral_addSubAdminExplain: "افزودن ادمین همکار با ایجاد دسترسی محدود",
    SettingGeneral_addSubAdminExplain2: "دعوت از ادمین با دسترسی محدود و امن، بدون نیاز به ورود به اینستاگرام.",

    SettingGeneral_addSubAdmintitleExplain:
      "شماره ادمین جدید را وارد کنید تا دعوت‌نامه ارسال شود و پس از تأیید، دسترسی‌ها فعال شود.",
    SettingGeneral_accesslevel: "سطح دسترسی",
    SettingGeneral_access: "دسترسی",
    SettingGeneral_partnertitle: "عنوان ادمین همکار",
    SettingGeneral_partnernumberexplain:
      "دعوت‌نامه به این شماره ارسال می‌شود و ادمین همکار باید در پنل خود آن را تأیید کند (ادمین باید در برنسی ثبت‌نام کند تا بتواند دعوت‌نامه را قبول کند).",
    SettingGeneral_contentTooltip: "پست‌ها، استوری‌ها، ریلزها، IGTV و کاروسل‌ها.",
    SettingGeneral_publishTooltip: "ایجاد پست و استوری و تولید محتوا؛ این دسترسی به دسترسی محتوا نیاز دارد.",
    SettingGeneral_automaticsTooltip:
      "هوش مصنوعی، فلوها و فرایندها و وظایف خودکار. این دسترسی به دسترسی محتوا نیاز دارد.",
    SettingGeneral_messageTooltip: "دایرکت اینستاگرام، پیام‌های داخلی و ابزارهای مرتبط.",
    SettingGeneral_commentTooltip: "نظرات، پاسخ‌ها و ابزارهای مرتبط.",
    SettingGeneral_transactionTooltip: "مدیریت حساب پرداخت، تراکنش‌ها، کیف پول و ابزارهای مرتبط.",
    SettingGeneral_adsTooltip: "مدیریت تقویم، تبلیغ‌دهندگان، تأیید تبلیغات، قیمت‌گذاری و ابزارهای مرتبط.",
    SettingGeneral_ordersTooltip: "محصولات، قیمت‌ها، موجودی انبار، سفارش‌ها، بارنامه‌ها و ابزارهای مرتبط.",
    SettingGeneral_bioTooltip: "محتوا و چیدمان بایو، لینک‌ها و میانبرهای محتوای شخص ثالث.",
    SettingGeneral_ticketTooltip: "CRM، تیکت‌های سیستمی و پشتیبانی.",
    SettingGeneral_productsTooltip: "ابزارهای مدیریت محصولات.",

    // Setting -> General -> support
    SettingGeneral_GeneralSupport: "پشتیبانی عمومی",
    SettingGeneral_Customerservices: "خدمات مشتریان",
    SettingGeneral_ReportBug: "گزارش باگ",
    SettingGeneral_Advertise: "تبلیغات",
    SettingGeneral_Store: "فروشگاه",
    SettingGeneral_biolink: "بایو لینک",
    SettingGeneral_Walletandfinance: "کیف پول و امور مالی",
    SettingGeneral_MessageingandComment: "پیام رسان و مدیریت کامنت ",
    SettingGeneral_Support: "پشتیبانی",
    SettingGeneral_Department: "مربوط به بخش",
    SettingGeneral_Title: "عنوان",
    SettingGeneral_Description: "توضیحات",
    SettingGeneral_Send: "ارسال",
    // 6 notifications
    SharedRemainingTimeBefore: "برای استوری ۲۴ ساعت دیگر اقدام کنید",
    // #endregion Setting Section
    userpanel_market: "بازار",
    userpanel_order: "سفارش",
    userpanel_Messages: "پیام‌ها",
    userpanel_Settings: "تنظیمات",
    userpanel_PersonalInfo: "اطلاعات شخصی",
    userpanel_UploadNewPicture: "آپلود تصویر جدید",
    userpanel_Instagramid: "آیدی اینستاگرام",
    userpanel_Nameandfamily: "نام و نام خانوادگی",
    userpanel_NationalCode: "کد ملی",
    userpanel_BirthDay: "تاریخ تولد",
    userpanel_MobileNumber: "شماره موبایل",
    userpanel_Email: "ایمیل",
    userpanel_CreditNumber: "شماره کارت اعتباری",
    userpanel_Addresses: "آدرس‌ها",
    userpanel_AddNewAddress: "اضافه کردن آدرس جدید",
    userpanel_ZipCode: "کد پستی",
    userpanel_Address: "آدرس",
    userpanel_EditAddress: "ویرایش آدرس",
    userpanel_AddNewAddressexplain: "بسته شما به این آدرس و شخص تحویل داده می‌شود",
    startbusiness: "ایجاد کسب و کار",
    AI: "هوش مصنوعی",
    ExtraTokens: "توکن اضافی",
    TokenUsage: "توکن مصرفی",
    AdvancedAnalytics: "آنالیز پیشرفته",
    AIResponse: "پاسخ هوشمند اینستاگرام",
    CustomSupport: "پشتیبانی ویژه",
    CustomDomain: "دامنه اختصاصی",
    WinnerPicker: "قرعه‌کشی",
    WinnerPickerReserve: "قرعه‌کشی رزرو",

    dataTable1_feature1: "مدیریت پست و آمار حرفه‌ای",
    dataTable1_tooltip1:
      "زمان‌بندی آسان انتشار پست‌ها. نمودارها و آمار دقیق برای هر پست شامل: (لایک، اشتراک‌گذاری، کامنت، ذخیره، نرخ تعامل، ریچ، ایمپرشن، تعداد پخش، نگهداری، فالو/آنفالو، فعالیت پروفایل، هشتگ‌های استفاده‌شده)، و کلی قابلیت دیگر...",

    dataTable1_feature2: "ایجاد پست جدید",
    dataTable1_tooltip2:
      "پیشنهاد بهترین زمان و تاریخ بر اساس پیج شما. زمان‌بندی پست. ذخیره هشتگ‌ها برای استفاده مجدد. امکان پاسخ خودکار به کامنت‌ها. ذخیره پست به صورت پیش‌نویس، و غیره",

    dataTable1_feature3: "مدیریت استوری و آمار دقیق",
    dataTable1_tooltip3:
      "زمان‌بندی استوری‌ها. آمار کامل و نموداری برای هر استوری: (لایک، اشتراک‌گذاری، کامنت، ذخیره، نرخ تعامل، ریچ، ایمپرشن، تعداد پخش، نگهداری، فالو/آنفالو، فعالیت پروفایل، دایرکت، اسکرین‌شات)، و غیره...",

    dataTable1_feature4: "ایجاد استوری جدید",
    dataTable1_tooltip4:
      "پیشنهاد بهترین زمان و تاریخ بر اساس پیج شما. زمان‌بندی استوری. امکان پاسخ خودکار به کامنت‌ها. ذخیره استوری به صورت پیش‌نویس، و غیره",

    dataTable1_feature5: "آمار کلی پیج",
    dataTable1_tooltip5:
      "تعداد پست و استوری. مرتب‌سازی بر اساس بیشترین و کمترین ویو، کامنت و لایک. تشخیص بهترین و بدترین زمان پست (به همراه نمودار). نمودار و تاریخچه لایک‌ها، فالو/آنفالو، ویوها، کامنت‌ها، بازدیدکننده‌های روح. شناسایی بهترین فالوورها. مقایسه با آمار قبلی، و کلی امکانات دیگه...",

    dataTable1_feature6: "مدیریت هشتگ‌ها",
    dataTable1_tooltip6:
      "ساخت لیست نامحدود هشتگ. تولید هوشمند هشتگ با تحلیل عکس (هوش مصنوعی). تولید هوشمند هشتگ با تحلیل پیج (هوش مصنوعی). مشاهده هشتگ‌های استفاده‌شده در پیج. لیست ترند هشتگ‌ها (بر اساس روز، هفته، ماه و زبان: انگلیسی، فارسی، عربی و...)، و امکانات بیشتر...",

    dataTable1_feature7: "لایک خودکار کامنت‌های جدید",
    dataTable1_tooltip7: "لایک خودکار کامنت‌های جدید فالوورها روی هر پست. نمایش تاریخچه به صورت نمودار و لیست.",

    dataTable1_feature8: "قرعه‌کشی تصادفی بین فالوورها",
    dataTable1_tooltip8:
      "انتخاب بهترین فالوور بر اساس لایک و کامنت. انتخاب تصادفی برنده. تعیین تعداد برندگان. ساخت و انتشار استوری اعلام نتایج به صورت خودکار. پیگیری تاریخچه قرعه‌کشی با کد اختصاصی، و امکانات دیگر...",

    dataTable1_feature9: "قرعه‌کشی امتیازی بین فالوورها",
    dataTable1_tooltip9:
      "تعیین وظایف برای شرکت در قرعه‌کشی (لایک، کامنت، منشن، فالو). تعیین تعداد برندگان. ساخت و انتشار استوری شرایط قرعه‌کشی به‌صورت خودکار. یادآوری خودکار. ساخت و انتشار استوری اعلام نتایج به‌صورت خودکار. پیگیری تاریخچه قرعه‌کشی با کد اختصاصی، و کلی امکانات دیگه...",
    WithStrongCallToAction: "با کال تو اکشن قوی",
    WithProsAndCons: "با مزایا و معایب",
    ForComparison: "برای مقایسه",
    WithKeyPoints: "به همراه نکات کلیدی",
    ForPromotionalPost: "مخصوص پست تبلیغاتی",
    WithDetailedExplanation: "با توضیح کامل",
    PersuasiveStyle: "با سبک متقاعدکننده",
    ForProductIntroduction: "برای معرفی محصول",
    LongText: "به صورت متن طولانی",
    Aipromptexplain: "برنسی با تحلیل محتوای پیج شما، لحن و سبک نوشتارتان را می‌شناسد؛ نیازی به توضیح اضافه نیست!",
    ImagineSomething: "چیزی را تصور کن... ✦",
    Generating: "در حال تولید...",
    AccessAndManageComments: "دسترسی مدیریت کامنت‌ها",
    AccessAndManageMessages: "دسترسی مدیریت پیام‌ها",
    AccessAndPublishContent: "دسترسی انتشار محتوا",
    AccessAndManageInsights: "دسترسی مدیریت آمار و گزارش‌ها",
    AccessAndManageCommentsExplain:
      "برای مدیریت کامنت‌های اینستاگرام، ابتدا روی «فعال‌سازی مجوز» کلیک کرده و در صفحه باز شده، آن را فعال و تأیید کنید.",
    AccessAndManageMessagesExplain:
      "برای مدیریت پیام‌های اینستاگرام، ابتدا روی «فعال‌سازی مجوز» کلیک کرده و در صفحه باز شده، آن را فعال و تأیید کنید.",
    AccessAndPublishContentExplain:
      "برای مشاهده و انتشار محتوای اینستاگرام، ابتدا روی «فعال‌سازی مجوز» کلیک کرده و در صفحه باز شده، آن را فعال و تأیید کنید.",
    AccessAndManageInsightsExplain:
      "برای مدیریت آمار اینستاگرام، ابتدا روی «فعال‌سازی مجوز» کلیک کرده و در صفحه باز شده، آن را فعال و تأیید کنید.",
    EnablePermission: "فعال‌سازی مجوز",
    instagramTutorialTitle: "آموزش اتصال به اینستاگرام",
    instagramTutorialStep1Title: "مرحله ۱: ورود امن به اینستاگرام",
    instagramTutorialStep1Text:
      "روی «اتصال حساب اینستاگرام» کلیک کنید تا به instagram.com هدایت شوید و وارد اکانت خود شوید. این کار امنیت و اتصال معتبر را تضمین می‌کند.",
    instagramTutorialStep2Title: "مرحله ۲: تایید دسترسی‌ها",
    instagramTutorialStep2Text:
      "پس از ورود، اینستاگرام مجوزهایی برای دسترسی به اطلاعات عمومی شما درخواست می‌کند. همه را تایید کنید تا سیستم درست کار کند.",
    instagramremoveStep1Title: "مرحله ۳: بررسی دسترسی‌ها",
    instagramremoveStep1text: "از بخش تنظیمات می‌توانید همه دسترسی‌های فعال اکانت را ببینید.",
    instagramremoveStep2Title: "مرحله ۴: مدیریت و حذف دسترسی‌های اضافی",
    instagramremoveStep2text:
      "برنسی شریک رسمی اینستاگرام است؛ بنابراین نیازی به سرویس‌های دیگر نیست. برای امنیت بیشتر، دسترسی‌های غیرضروری را حذف کنید.",
    understood: "متوجه شدم",
    previous: "قبلی",
    connectTutorial: "آموزش اتصال",
    invalidcode: "رمز نامعتبر است",
    wearesorry: "متاسفیم!",
    PaymentFailed: "پرداخت ناموفق!",
    thankyou: "متشکریم!",
    Paymentsuccess: "پرداخت موفق!",
    TransactionNumber: "شماره تراکنش:",
    TransactiontrackingNumber: "شماره پیگیری تراکنش:",
    InvoiceNumber: "شماره فاکتور:",
    mainSubscriptionPlan: "اشتراک اصلی",
    Tokens: "توکن",
    tokenExplain: "توکن واحد مصرفی خدمات هوش مصنوعی است؛ به طور میانگین پردازش ۱۰۰ درخواست حدود ۱۰۰۰ توکن نیاز دارد.",
    ReserveToken: "توکن رزرو",
    packageTokenExplain:
      "توکن‌های رایگانی که همراه پکیج فعال می‌شوند و تا پایان اعتبار پکیج قابل استفاده‌اند؛ پس از آن منقضی می‌شوند.",
    ReserveTokenExplain: "توکن‌های خریداری‌شده به صورت رزرو که با گذشت زمان منقضی نمی‌شوند.",

    pageTools_Months: "ماه",
    subscriptionExpired: "اشتراک شما منقضی شد، لطفاً تمدید کنید",
    subscriptionExpireSoon: "اشتراک شما به زودی منقضی می‌شود",
    subscriptionManagement: "مدیریت اشتراک",
    subscription: "اشتراک",
    AIAssisment: "دستیار هوش مصنوعی",
    timeperiod: "بازه زمانی باقیمانده",
    domain: "دامنه",
    winnerpickerexpired: "شما دیگر امکان برگزاری قرعه‌کشی ندارید، لطفاً شارژ کنید",
    winnerpickerexpiresoon: "تعداد قرعه‌کشی‌های شما رو به اتمام است",
    Aiexpired: "شما دیگر امکان استفاده از هوش مصنوعی را ندارید، لطفاً شارژ کنید.",
    Aiexpiresoon: "توکن‌های هوش مصنوعی شما رو به اتمام است.",

    followercount: "تعداد فالورها",
    yourCurrentSubscription: "اشتراک فعلی شما",
    noItemsAvailableContactSupport: "این قسمت فعلاً در دسترس نمی‌باشد. برای سفارش به پشتیبانی برنسی تیکت بزنید.",

    // #region AIFlow Section
    AIAssismentexplain:
      "با استفاده از دستیار هوش مصنوعی برنسی، می‌توانید جریان‌های مکالمه هوشمند برای پاسخگویی خودکار به پیام‌ها و کامنت‌های اینستاگرام ایجاد کنید",
    livetest: "تست زنده",
    testlab: "آزمایشگاه",
    promptmode: "حالت پرامپت",
    promptanalysis: "تحلیل پرامپت",

    promptanalysisExplain:
      "پرامپت خود را با جزئیات وارد کنید؛ برنسی آن را بر اساس کاراکتر، لحن و سبک تعامل شما تحلیل می‌کند.",
    promptanalysisplaceholder: "برای تحلیل پرامپت حداقل ۲۰ کاراکتر وارد کنید",
    promptanalysisexplain: "برنسی پرامپت شما را تحلیل می‌کند و بهترین تنظیمات را برای پاسخگویی هوشمند پیشنهاد می‌دهد",

    reanalyze: "تحلیل مجدد",
    shouldFollowerexplain: "پاسخ فقط به کاربرانی داده می‌شود که شما را فالو کرده باشند",
    RenewForThread: "تجدید جریان مکالمه",
    RenewForThreadexplain: "در هر بار مکالمه، اگر کاربر پیام جدیدی ارسال کند، جریان مکالمه از ابتدا شروع می‌شود",
    prompt: "پرامپت",

    autosave: "ذخیره خودکار",
    Restrictorzoom: "تنظیم محدودیت بزرگ‌نمایی",
    snapGrid: "چیدمان منظم روی شبکه",
    PanningBoundary: "مرز حرکت در صفحه",
    Flow: "جریان (Flow)",
    flowtitle: "عنوان جریان",
    AIFlow_input: "ورودی",
    AIFlow_input_message_block: "پیام ورودی کاربر",
    AIFlow_output: "خروجی",
    AIFlow_output_title: "عنوان خروجی",
    AIFlow_text: "متن",
    AIFlow_item_text: "آیتم",
    AIFlow_block_title_required: "لطفاً عنوان بلوک را وارد کنید (الزامی)",
    AIFlow_item_title: "عنوان آیتم:",
    AIFlow_show_graph: "نمایش نمودار جریان",
    AIFlow_connect_post: "اتصال به پست",
    AIFlow_connect_post_access: "دسترسی کامنت و پیام اینستاگرام و مجوز بخش‌های خودکارسازی و کامنت لازم است.",
    AIFlow_connect_post_save_first: "پیش از اتصال به پست، این فلو را ذخیره کنید.",
    AIFlow_connect_post_confirm:
      "این فلو جایگزین پاسخ خودکار فعلی پست می‌شود و فعال خواهد شد. کلمات کلیدی و روش تطبیق قبلی حفظ می‌شوند؛ اگر کلمه کلیدی وجود نداشته باشد، فلو به همه کامنت‌ها پاسخ می‌دهد.",
    AIFlow_connect_post_resume: "اتصال فلو ذخیره شد، اما فعال‌سازی ناموفق بود. دوباره برای فعال‌سازی تلاش کنید.",
    AIFlow_connect_post_incompatible:
      "این فلو با پاسخ خصوصی کامنت سازگار نیست. پیش از اتصال، فلو را ویرایش و ذخیره کنید.",
    AIFlow_retry: "تلاش دوباره",
    AIPrompt_connect_post_access: "دسترسی کامنت اینستاگرام و مجوز بخش‌های خودکارسازی و کامنت لازم است.",
    AIPrompt_connect_post_confirm:
      "این هوش مصنوعی جایگزین پاسخ خودکار فعلی پست می‌شود و فعال خواهد شد. کلمات کلیدی و روش تطبیق قبلی حفظ می‌شوند؛ بدون کلمه کلیدی، به همه کامنت‌ها پاسخ داده می‌شود. ارسال خصوصی فقط با دسترسی پیام حفظ می‌شود؛ در غیر این صورت پاسخ‌ها به‌صورت کامنت ارسال می‌شوند.",
    AIPrompt_connect_post_resume:
      "اتصال هوش مصنوعی ذخیره شد، اما فعال‌سازی ناموفق بود. دوباره برای فعال‌سازی تلاش کنید.",
    messagesetting_PhoneNumbers: "شماره‌های تلفن",
    messagesetting_PhoneNumbersExplain: "شماره‌های تلفنی که از مشتریان شما از طریق جریان‌ها جمع‌آوری شده است",
    messagesetting_PhoneNumbersEmpty: "هنوز شماره تلفنی جمع‌آوری نشده است",
    AIFlow_item_subtitle: "زیرعنوان آیتم:",
    AIFlow_option_title: "عنوان گزینه",
    AIFlow_option_default: "گزینه",
    AIFlow_quick_reply: "پاسخ سریع",
    AIFlow_quick_reply_validation_error: "تمام فیلدهای پاسخ سریع باید پر شوند!",
    AIFlow_quick_reply_block_title_empty: "بلوک {label}\n عنوان وارد نشده است",
    AIFlow_quick_reply_option_title_empty: "بلوک {label}\n گزینه {index} بدون عنوان است",
    AIFlow_delete_image: "🗑️ پاک کردن عکس",
    AIFlow_delete_image_button_text: "🗑️ پاک کردن عکس",
    AIFlow_delete_all_block: "🗑️ حذف بلوک‌",
    AIFlow_delete_all_blocks: " حذف کل جریان ",
    AIFlow_save_all_blocks: " ذخیره کل جریان ",
    AIFlow_delete: "🗑️ حذف",
    AIFlow_upload_image: "📷 آپلود تصویر",
    AIFlow_image_uploaded: "تصویر آپلود شده ✓",
    AIFlow_add_image: "📷 اضافه کردن تصویر",
    AIFlow_voice_recorded: "🎵 صدای ضبط شده",
    AIFlow_record_voice: "🎤 ضبط صدا",
    AIFlow_record_voice_confirm: "آماده ضبط هستید؟ (حداقل ۳ ثانیه)",
    AIFlow_play_voice: "▶️ پخش صدا",
    AIFlow_add_output: " افزودن خروجی جدید",
    AIFlow_add_subtitle: "➕ اضافه کردن زیرعنوان",
    AIFlow_subtitle_input: "لطفاً زیرعنوان را وارد کنید:",
    AIFlow_link: "لینک:",
    AIFlow_general_block: "بلوک عمومی",
    AIFlow_text_block: "بلوک متن",
    AIFlow_image_block: "بلوک تصویر",
    AIFlow_voice_block: "بلوک صوتی",
    AIFlow_quick_reply_block: "بلوک پاسخ سریع",
    AIFlow_weblink_block: "بلوک لینک",
    AIFlow_add_text_block: "اضافه‌کردن بلوک متن",
    AIFlow_add_image_block: "اضافه‌کردن بلوک تصویر",
    AIFlow_add_voice_block: "اضافه‌کردن بلوک صوتی",
    AIFlow_add_quick_reply_block: "اضافه‌کردن پاسخ سریع",
    AIFlow_add_general_block: "اضافه‌کردن بلوک عمومی",
    AIFlow_add_weblink_block: "اضافه‌کردن لینک",
    AIFlow_generic_block: "بلوک زیرشاخه عمومی",
    AutoLayout_block: "چیدمان خودکار لایه‌ها",
    AIFlow_live_test_block: "تست زنده جریان",
    //alert
    AIFlow_Deleteallblocks_alert: "آیا مطمئنید که می‌خواهید کل جریان را حذف کنید؟",
    AIFlow_add_output_error_alert: "خطا در افزودن خروجی: {error}",
    AIFlow_unknown_block_type_alert: "نوع بلوک ناشناخته است:",
    AIFlow_multiple_flow_for_private_reply_alert: "چندین جریان برای پاسخ خصوصی یافت شد",
    AIFlow_empty_title_for_flow_alert: "عنوان جریان خالی است",
    AIFlow_weblink_has_hyphen_alert: "بلوک {label}\n لینک نباید شامل «-» باشد",
    AIFlow_min_output_required: "حداقل یک خروجی باید باقی بماند",
    AIFlow_max_quick_reply_outputs: "حداکثر ۱۵ خروجی مجاز است",
    AIFlow_max_generic_outputs: "حداکثر ۱۰ خروجی مجاز است",
    AIFlow_generic_item_connection_only: "این بلوک فقط به بلوک‌های عمومی وصل می‌شود",
    AIFlow_weblink_generic_item_only: "این بلوک فقط به زیرشاخه عمومی وصل می‌شود",
    AIFlow_voice_record_failed: "❌ ضبط صدا ناموفق بود (هیچ صدایی ضبط نشد)",
    AIFlow_voice_upload_failed: "✅ ضبط موفق بود اما آپلود انجام نشد",
    AIFlow_voice_record_empty: "❌ ضبط صدا خالی است",
    AIFlow_voice_record_start: "🎙️ ضبط شروع شد...",
    AIFlow_session_invalid: "نشست کاربری نامعتبر است، لطفاً دوباره وارد شوید",
    AIFlow_no_on_message_node: "نود شروع‌کننده پیام پیدا نشد!",
    AIFlow_validation_warning: "⚠️ هشدار اعتبارسنجی",
    AIFlow_generic_item_validation_error: "لطفاً تمام فیلدهای بلوک عمومی را تکمیل کنید",
    AIFlow_weblink_validation_error_alert: "تمام فیلدهای لینک باید پر شوند",
    AIFlow_generic_item_title_empty_alert: "آیتم {label}\n عنوان خالی است",
    AIFlow_generic_item_output_title_empty_alert: "آیتم {label}\n خروجی {index} بدون عنوان است",
    AIFlow_weblink_empty_alert: "بلوک {label}\n لینک خالی است",
    AIFlow_weblink_incomplete_alert: "بلوک {label}\n لینک ناقص است (فقط پروتکل وارد شده)",
    AIFlow_weblink_invalid_format_alert: "بلوک {label}\n فرمت لینک نادرست است",
    AIFlow_weblink_non_english_alert: "بلوک {label}\n لینک باید به انگلیسی باشد",
    AIFlow_editor_init_error: "❌ خطا در راه‌اندازی ویرایشگر",
    AIFlow_unexpected_error: "⚠️ خطای غیرمنتظره رخ داد",
    AIFlow_server_error: "❌ خطای سرور",
    AIFlow_connection_error: "⚠️ مشکل در اتصال",
    AIFlow_generic_connection_error: "خطا در اتصال بلوک عمومی به زیرشاخه",
    AIFlow_weblink_connection_error: "خطا در اتصال نود",
    AIFlow_voice_fetch_error: "خطا در دریافت فایل صوتی",
    AIFlow_voice_record_error: "خطا در ضبط صدا",
    AIFlow_voice_play_error: "خطا در پخش صدا",
    AIFlow_media_recorder_error: "خطا در ضبط‌کننده صدا",
    AIFlow_upload_error: "❌ خطا در آپلود",
    AIFlow_add_output_error: "❌ خطا در افزودن خروجی",
    AIFlow_json_parse_error: "خطا در پردازش JSON",
    AIFlow_position_error: "خطا در پردازش موقعیت پیام شروع‌کننده",
    AIFlow_node_remove_error: "خطا در حذف نود",
    AIFlow_node_connection_warning: "نمی‌توان اتصال برقرار کرد:",
    AIFlow_unknown_value_type: "نوع مقدار ناشناخته در دکمه",
    AIFlow_success: "✅ عملیات با موفقیت انجام شد",
    AIFlow_subtitle_success: "✓ زیرعنوان با موفقیت اضافه شد",
    AI_live_test: "پرامپت‌های هوش مصنوعی خود را به‌صورت لحظه‌ای تست کنید",
    // #endregion AIFlow Section
    //
    //
    //
    //
    //
    // #region Flow Section New
    New_Flow_input_message_block: "پیام ورودی کاربر",
    New_Flow_general_block: "بلوک عمومی",
    New_Flow_text_block: "بلوک متن",
    New_Flow_voice_block: "بلوک صوتی",
    New_Flow_imageorvideo_block: "بلوک تصویر / ویدیو",
    New_Flow_quick_reply_block: "بلوک پاسخ سریع",
    New_Flow_weblink_block: "بلوک لینک",
    New_Flow_phonenumbergrabber_block: "دریافت شماره تلفن",
    New_Flow_ai_block: "هوش مصنوعی",
    New_Flow_ai_select: "یک هوش مصنوعی انتخاب کنید",
    New_Flow_ai_livetest: "بلوک هوش مصنوعی شما در اینجا اجرا می‌شود",
    New_Flow_masterflow_block: "زیر فلو",
    New_Flow_masterflow_select: "یک فلو انتخاب کنید",
    New_Flow_masterflow_livetest: "زیر فلوی انتخاب‌شده از اینجا ادامه می‌یابد",
    New_Flow_Tutorials_buttongroup_title: "بلوک گروه دکمه",
    New_Flow_Tutorials_buttongroup_description:
      "این بلوک پیامی با حداکثر سه دکمه می‌فرستد؛ هر دکمه خروجی مستقل دارد و بلوک یک خروجی معمولی هم دارد که فلو را ادامه می‌دهد.",
    New_Flow_Tutorials_buttongroup_usageType:
      "مناسب ارائه چند گزینه مشخص، منو، ناوبری سریع و هدایت کاربر به لینک یا مرحله بعد.",
    New_Flow_Tutorials_buttongroup_feature_1: "متن پیام تا ۶۴۰ کاراکتر",
    New_Flow_Tutorials_buttongroup_feature_2: "تا ۳ دکمه با خروجی مستقل برای هر یک",
    New_Flow_Tutorials_buttongroup_feature_3: "خروجی معمولی بدون انتظار برای کلیک دکمه فلو را ادامه می‌دهد",
    New_Flow_Tutorials_buttongroup_tip_1: "متن پیام و برچسب دکمه‌ها را واضح و کوتاه بنویسید",
    New_Flow_Tutorials_buttongroup_tip_2: "هر دکمه را به بلوکی وصل کنید که باید پس از انتخاب آن بیاید",
    New_Flow_Tutorials_buttongroup_tip_3: "فقط خروجی‌های دکمه‌ها را می‌توان به بلوک لینک وصل کرد",
    New_Flow_Tutorials_buttongroup_limitation_1: "حداکثر ۳ دکمه",
    New_Flow_Tutorials_buttongroup_limitation_2: "متن پیام: حداکثر ۶۴۰ کاراکتر",
    New_Flow_Tutorials_buttongroup_limitation_3: "عنوان دکمه: حداکثر ۲۰ کاراکتر",
    New_Flow_Tutorials_buttongroup_limitation_4: "حذف آخرین دکمه، بلوک را حذف می‌کند",
    New_Flow_Tutorials_ai_title: "بلوک هوش مصنوعی",
    New_Flow_Tutorials_ai_description:
      "این بلوک گفتگو را به یکی از هوش‌های مصنوعیِ ساخته‌شده توسط شما می‌سپارد؛ هوش مصنوعی را از لیست داخل بلوک انتخاب کنید.",
    New_Flow_Tutorials_ai_usageType:
      "مناسب پاسخ‌گویی خودکار به پرسش‌های آزاد مشتریان، پشتیبانی، مشاوره و گفتگوهای فروش.",
    New_Flow_Tutorials_ai_feature_1: "فهرست همه هوش‌های مصنوعی ساخته‌شده را برای انتخاب نمایش می‌دهد",
    New_Flow_Tutorials_ai_feature_2: "هوش مصنوعی انتخاب‌شده از همین نقطه فلو گفتگو را به عهده می‌گیرد",
    New_Flow_Tutorials_ai_tip_1: "ابتدا هوش مصنوعی خود را بسازید و تنظیم کنید تا در لیست نمایش داده شود",
    New_Flow_Tutorials_ai_tip_2: "آن را پس از یک بلوک پیام که گفتگو را معرفی می‌کند قرار دهید",
    New_Flow_Tutorials_ai_limitation_1: "فقط ورودی دارد و خروجی ندارد، بنابراین فلو را پایان می‌دهد",
    New_Flow_Tutorials_ai_limitation_2: "در هر بلوک فقط یک هوش مصنوعی قابل انتخاب است",
    New_Flow_Tutorials_ai_limitation_3: "نمی‌تواند اولین بلوک فلو باشد",
    New_Flow_Tutorials_masterflow_title: "بلوک زیر فلو",
    New_Flow_Tutorials_masterflow_description:
      "وقتی کاربر روی یک دکمه می‌زند، گفتگو را به یکی از فلوهایی که قبلاً ساخته‌اید منتقل می‌کند.",
    New_Flow_Tutorials_masterflow_usageType: "استفاده مجدد از یک فلوی موجود به عنوان ادامه یک دکمه",
    New_Flow_Tutorials_masterflow_feature_1: "تمام فلوهایی که ساخته‌اید را نمایش می‌دهد تا یکی را انتخاب کنید",
    New_Flow_Tutorials_masterflow_feature_2: "فلوی انتخاب‌شده گفتگو را از این نقطه ادامه می‌دهد",
    New_Flow_Tutorials_masterflow_tip_1: "ابتدا فلوی مقصد را بسازید و ذخیره کنید تا در لیست نمایش داده شود",
    New_Flow_Tutorials_masterflow_tip_2: "برای مسیرهای مشترک (مثل پشتیبانی یا قیمت‌ها) بین فلوها از آن استفاده کنید",
    New_Flow_Tutorials_masterflow_limitation_1: "فقط ورودی دارد و خروجی ندارد، بنابراین این فلو را به پایان می‌رساند",
    New_Flow_Tutorials_masterflow_limitation_2: "فقط به دکمه‌ها متصل می‌شود، نه به خروجی‌های معمولی",
    New_Flow_Tutorials_masterflow_limitation_3: "فلویی که در حال ویرایش آن هستید قابل انتخاب نیست",
    New_Flow_Tutorials_masterflow_connection_1: "دکمه‌های بلوک پاسخ سریع",
    New_Flow_Tutorials_masterflow_connection_2: "دکمه‌های بلوک گروه دکمه",
    New_Flow_Tutorials_masterflow_connection_3: "دکمه‌های زیربلوک گالری",
    New_Flow_generic_block: "بلوک گالری (کاروسل)",
    New_Flow_add_general_block: "اضافه‌کردن بلوک گالری",
    New_Flow_add_text_block: "اضافه‌کردن بلوک متن",
    New_Flow_add_image_block: "اضافه‌کردن بلوک تصویر",
    New_Flow_add_voice_block: "اضافه‌کردن بلوک صوتی",
    New_Flow_add_quick_reply_block: "اضافه‌کردن پاسخ سریع",
    New_Flow_add_weblink_block: "اضافه‌کردن لینک",
    New_Flow_upload_imageorvideo: "آپلود تصویر یا ویدیو",
    New_Flow_upload_image: "آپلود تصویر",
    New_Flow_upload_unsupported_media: "فرمت رسانه پشتیبانی نمی‌شود",
    New_Flow_uploadmaxsizeexceeded: "حجم فایل نباید بیشتر از 50MB باشد",
    New_Flow_uploadfilefailed: "آپلود فایل انجام نشد، لطفاً دوباره تلاش کنید",
    invalidFlowDetected: "فلو نامعتبر است! برخی بلوک‌ها ورودی ندارند یا بلوک پیام تنهاست.",

    New_Flow_unsupportedbrowser: "مرورگر شما از پخش ویدیو پشتیبانی نمی‌کند",
    New_Flow_micphoneaccessdenied: "دسترسی به میکروفون را فعال کنید",
    New_Flow_upload_audio: "آپلود فایل صوتی",
    New_Flow_record_voice: "ضبط صدا",
    New_Flow_stop_record_voice: "توقف ضبط",
    New_Flow_areyoureadytorecord: "آماده ضبط هستید؟",

    New_Flow_voice_recording_started: "در حال ضبط صدا...",
    New_Flow_add_generic_sub_block: "اضافه‌کردن زیرشاخه",
    New_Flow_generic_sub: "زیرشاخه",
    New_Flow_add_button: "افزودن دکمه",
    New_Flow_quick_reply_title_placeholder: "عنوان گزینه پاسخ سریع",
    New_Flow_buttongroup_block: "بلوک گروه دکمه",
    New_Flow_add_buttongroup_block: "اضافه‌کردن گروه دکمه",
    New_Flow_buttongroup_title_placeholder: "متن پیام گروه دکمه",
    New_Flow_imagegallery_block: "بلوک گالری تصویر",
    New_Flow_add_imagegallery_block: "اضافه‌کردن گالری تصویر",
    New_Flow_imagegallery_max_reached: "حداکثر {{max}} تصویر می‌توانید به این بلوک اضافه کنید",
    New_Flow_Tutorials_imagegallery_title: "بلوک گالری تصویر",
    New_Flow_Tutorials_imagegallery_description:
      "این بلوک برای آپلود و ارسال چند تصویر (تا {{max}} تصویر) به کاربران در دایرکت استفاده می‌شود",
    New_Flow_Tutorials_imagegallery_usageType:
      "مناسب برای نمایش چند محصول، آلبوم عکس، تصاویر قبل و بعد و مجموعه‌های تصویری",
    New_Flow_Tutorials_imagegallery_feature_1: "پذیرش تا {{max}} تصویر در یک بلوک",
    New_Flow_Tutorials_imagegallery_limitation_1:
      "حداکثر {{max}} تصویر در هر بلوک (این محدودیت ممکن است در آینده افزایش یابد)",
    New_Flow_message_title: "عنوان پیام",
    New_Flow_message_description: "توضیحات پیام",
    New_Flow_live_test_block: "تست زنده جریان",
    New_Flow_delete_all_blocks: "حذف کل جریان",
    New_Flow_shortcuts_explain: "میانبرهای صفحه‌کلید برای افزایش سرعت و تسلط در مدیریت جریان‌های کاری.",
    New_Flow_Tutorials_Not_Available: "راهنما موجود نیست",
    New_Flow_Tutorials_Not_Available_Description: "راهنمایی برای این نود در دسترس نیست",
    New_Flow_Tutorials_Usage_Type: "نوع کاربرد",
    New_Flow_Tutorials_Features: "قابلیت‌ها",
    New_Flow_Tutorials_Tips: "نکات کاربردی",
    New_Flow_Tutorials_Limitations: "محدودیت‌ها",
    New_Flow_Tutorials_Connections: "اتصالات",
    New_Flow_unsavedChanges: "تغییرات ذخیره‌نشده دارید",
    New_Flow_addedNodes: "نودهای اضافه‌شده",
    New_Flow_removedNodes: "نودهای حذف‌شده",
    New_Flow_modifiedNodes: "نودهای ویرایش‌شده",
    New_Flow_invalidFlow_explain: "فلو معتبر نیست. لطفاً قبل از ذخیره، نودها را از نظر خطا بررسی کنید",
    sendsms: "ارسال پیامک به کاربر",
    sendtotelegram: "هدایت کاربر به تلگرام",
    senderusername: "صدا زدن نام کاربر",
    addtools: "افزودن ابزار",
    generatebyai: "تولید توسط هوش مصنوعی",

    //tutorials
    // ============================
    // New Flow Tutorials - Locale
    // ============================

    // onmessage
    New_Flow_Tutorials_onmessage_title: "نقطه شروع فلوی شما",
    New_Flow_Tutorials_onmessage_description:
      "این بلوک نقطه شروع فلوی شما است. زمانی که کاربر پیامی به دایرکت اینستاگرام شما ارسال می‌کند، این بلوک فعال شده و فلو شروع می‌شود. همیشه اولین بلوک در هر اتوماسیون است و نمی‌توان آن را حذف کرد.",
    New_Flow_Tutorials_onmessage_feature_1: "یک خروجی واحد برای اتصال به بلوک بعدی",
    New_Flow_Tutorials_onmessage_tip_1:
      "خروجی این بلوک را به هر بلوک دیگری متصل کنید، کاربر با ارسال هر نوع پیامی (متن، تصویر، ویدیو، صوت و...) فلو آغاز میشود",
    New_Flow_Tutorials_onmessage_connection_1: "قابل اتصال به بلوک های زیر:",
    New_Flow_Tutorials_onmessage_connection_2: "❌ بلوک لینک وب",
    New_Flow_Tutorials_onmessage_connection_3: "✅ بلوک پیام صوتی",
    New_Flow_Tutorials_onmessage_connection_4: "✅ بلوک پیام متنی",
    New_Flow_Tutorials_onmessage_connection_5: "✅ بلوک پاسخ سریع",
    New_Flow_Tutorials_onmessage_connection_6: "✅ بلوک تصویر و ویدیو",
    New_Flow_Tutorials_onmessage_connection_7: "✅ بلوک گالری",

    // text
    New_Flow_Tutorials_text_title: "بلوک پیام متنی",
    New_Flow_Tutorials_text_description: "این بلوک برای ارسال پیام‌های متنی به کاربران استفاده می‌شود",
    New_Flow_Tutorials_text_usageType:
      "مناسب برای پیام خوشامدگویی، توضیح محصولات، پاسخ به سوالات متداول، اطلاع‌رسانی و راهنمایی کاربران.",
    New_Flow_Tutorials_text_feature_1: "پشتیبانی از تمام زبان‌ها",
    New_Flow_Tutorials_text_feature_2: "قابلیت استفاده از ایموجی و کاراکترهای خاص",
    New_Flow_Tutorials_text_tip_1: "پیام‌ها را کوتاه و واضح بنویسید",
    New_Flow_Tutorials_text_tip_2: "از ایموجی به اندازه استفاده کنید",
    New_Flow_Tutorials_text_tip_3: "متن‌های طولانی را به چند بخش تقسیم کنید",
    New_Flow_Tutorials_text_tip_4: "لحن صمیمانه و دوستانه داشته باشید",
    New_Flow_Tutorials_text_tip_5: "از پاراگراف‌بندی مناسب استفاده کنید",
    New_Flow_Tutorials_text_limitation_1: "حداکثر 2200 کاراکتر",
    New_Flow_Tutorials_text_limitation_2: "فقط متن ساده (بدون فایل یا رسانه)",
    New_Flow_Tutorials_text_limitation_3: "بدون امکان فرمت‌بندی (Bold, Italic)",
    New_Flow_Tutorials_text_connection_1: "✅ بلوک ورودی پیام",
    New_Flow_Tutorials_text_connection_2: "❌ بلوک لینک وب",
    New_Flow_Tutorials_text_connection_3: "✅ بلوک پیام صوتی",
    New_Flow_Tutorials_text_connection_4: "✅ بلوک پیام متنی",
    New_Flow_Tutorials_text_connection_5: "✅ بلوک پاسخ سریع",
    New_Flow_Tutorials_text_connection_6: "✅ بلوک تصویر و ویدیو",
    New_Flow_Tutorials_text_connection_7: "❌ بلوک گالری",
    New_Flow_Tutorials_text_connection_8: "✅ بلوک زیرشاخه گالری",

    // image
    New_Flow_Tutorials_image_title: "بلوک تصویر و ویدیو",
    New_Flow_Tutorials_image_description:
      "این بلوک برای آپلود و ارسال تصاویر و ویدیوها به کاربران در دایرکت استفاده می‌شود",
    New_Flow_Tutorials_image_usageType:
      "مناسب برای نمایش محصولات، گالری تصاویر، لوگو، بنرهای تبلیغاتی، ویدیوهای آموزشی و معرفی.",
    New_Flow_Tutorials_image_feature_1: "پشتیبانی از تصاویر: JPEG, PNG, GIF, WebP, SVG",
    New_Flow_Tutorials_image_feature_2: "پشتیبانی از ویدیو: MP4, WebM, OGG, MOV, AVI, MKV",
    New_Flow_Tutorials_image_feature_3: "تشخیص خودکار نوع فایل",
    New_Flow_Tutorials_image_tip_1: "از تصاویر با کیفیت بالا استفاده کنید",
    New_Flow_Tutorials_image_tip_2: "فایل‌های حجیم را قبل از آپلود فشرده کنید",
    New_Flow_Tutorials_image_tip_3: "ابعاد استاندارد: 1080×1080 یا 1080×1350",
    New_Flow_Tutorials_image_tip_4: "ویدیوها را زیر 30 ثانیه نگه دارید",
    New_Flow_Tutorials_image_tip_5: "JPEG برای عکس‌های معمولی، PNG برای پس‌زمینه شفاف",
    New_Flow_Tutorials_image_limitation_1: "حداکثر حجم: 50 مگابایت",
    New_Flow_Tutorials_image_limitation_2: "یک فایل در هر بلوک",
    New_Flow_Tutorials_image_limitation_3: "فرمت‌های غیرمعمول ممکن است پشتیبانی نشوند",
    New_Flow_Tutorials_image_connection_1: "✅ بلوک ورودی پیام",
    New_Flow_Tutorials_image_connection_2: "❌ بلوک لینک وب",
    New_Flow_Tutorials_image_connection_3: "✅ بلوک پیام صوتی",
    New_Flow_Tutorials_image_connection_4: "✅ بلوک پیام متنی",
    New_Flow_Tutorials_image_connection_5: "✅ بلوک پاسخ سریع",
    New_Flow_Tutorials_image_connection_6: "✅ بلوک تصویر و ویدیو",
    New_Flow_Tutorials_image_connection_7: "❌ بلوک گالری",
    New_Flow_Tutorials_image_connection_8: "✅ بلوک زیرشاخه گالری",

    // voice
    New_Flow_Tutorials_voice_title: "بلوک پیام صوتی",
    New_Flow_Tutorials_voice_description:
      "این بلوک برای آپلود و ارسال فایل‌های صوتی یا ضبط صدای زنده به کاربران استفاده می‌شود",
    New_Flow_Tutorials_voice_usageType:
      "مناسب برای پیام‌های صوتی شخصی، آموزش‌های گویا، پادکست‌های کوتاه و راهنمایی‌های صوتی.",
    New_Flow_Tutorials_voice_feature_1: "پشتیبانی از فرمت: MP3, M4A, WAV, OGG, AAC",
    New_Flow_Tutorials_voice_feature_2: "ضبط مستقیم از میکروفون",
    New_Flow_Tutorials_voice_feature_3: "آپلود فایل صوتی آماده",
    New_Flow_Tutorials_voice_tip_1: "در محیط بدون سر و صدا ضبط کنید",
    New_Flow_Tutorials_voice_tip_2: "پیام‌های کوتاه (زیر 1 دقیقه) بهتر است",
    New_Flow_Tutorials_voice_tip_3: "کیفیت صدا را قبل از ارسال بررسی کنید",
    New_Flow_Tutorials_voice_tip_4: "متن خود را قبل از ضبط آماده کنید",
    New_Flow_Tutorials_voice_limitation_1: "حداکثر حجم: 50 مگابایت",
    New_Flow_Tutorials_voice_limitation_2: "نیاز به دسترسی میکروفون برای ضبط",
    New_Flow_Tutorials_voice_limitation_3: "یک فایل در هر بلوک",
    New_Flow_Tutorials_voice_connection_1: "✅ بلوک ورودی پیام",
    New_Flow_Tutorials_voice_connection_2: "❌ بلوک لینک وب",
    New_Flow_Tutorials_voice_connection_3: "✅ بلوک پیام صوتی",
    New_Flow_Tutorials_voice_connection_4: "✅ بلوک پیام متنی",
    New_Flow_Tutorials_voice_connection_5: "✅ بلوک پاسخ سریع",
    New_Flow_Tutorials_voice_connection_6: "✅ بلوک تصویر و ویدیو",
    New_Flow_Tutorials_voice_connection_7: "❌ بلوک گالری",
    New_Flow_Tutorials_voice_connection_8: "✅ بلوک زیرشاخه گالری",
    // quickreply
    New_Flow_Tutorials_quickreply_title: "بلوک پاسخ سریع",
    New_Flow_Tutorials_quickreply_description:
      "این بلوک برای ایجاد دکمه‌های انتخابی (Quick Reply) یکبار مصرف برای کاربران استفاده می‌شود که کاربر با کلیک روی هر دکمه، مسیر خاصی از فلو را طی می‌کند.",
    New_Flow_Tutorials_quickreply_usageType:
      "مناسب برای منوهای انتخاب، دسته‌بندی محصولات، سوالات چندگزینه‌ای، نظرسنجی و فیلترهای جستجو.",
    New_Flow_Tutorials_quickreply_feature_1: "تا 10 دکمه در هر بلوک",
    New_Flow_Tutorials_quickreply_feature_2: "هر دکمه یک خروجی مستقل دارد",
    New_Flow_Tutorials_quickreply_feature_3: "قابلیت حذف و ویرایش دکمه‌ها",
    New_Flow_Tutorials_quickreply_tip_1: "متن دکمه‌ها را واضح و کاربردی بنویسید",
    New_Flow_Tutorials_quickreply_tip_2: "3 تا 5 دکمه برای تجربه بهتر",
    New_Flow_Tutorials_quickreply_tip_3: "برچسب‌ها را کوتاه نگه دارید (زیر 20 کاراکتر)",
    New_Flow_Tutorials_quickreply_tip_4: "از فیلد عنوان برای راهنمایی استفاده کنید",
    New_Flow_Tutorials_quickreply_tip_5: "اولویت دکمه ها را بر اساس مهمترین ها تنظیم کنید",
    New_Flow_Tutorials_quickreply_limitation_1: "حداکثر 10 دکمه",
    New_Flow_Tutorials_quickreply_limitation_2: "عنوان دکمه: حداکثر 40 کاراکتر",
    New_Flow_Tutorials_quickreply_limitation_3: "توضیحات: حداکثر 140 کاراکتر",
    New_Flow_Tutorials_quickreply_limitation_4: "حداقل یک دکمه الزامی است",
    New_Flow_Tutorials_quickreply_connection_1: "✅ بلوک ورودی پیام",
    New_Flow_Tutorials_quickreply_connection_2: "❌ بلوک لینک وب",
    New_Flow_Tutorials_quickreply_connection_3: "✅ بلوک پیام صوتی",
    New_Flow_Tutorials_quickreply_connection_4: "✅ بلوک پیام متنی",
    New_Flow_Tutorials_quickreply_connection_5: "✅ بلوک پاسخ سریع",
    New_Flow_Tutorials_quickreply_connection_6: "✅ بلوک تصویر و ویدیو",
    New_Flow_Tutorials_quickreply_connection_7: "❌ بلوک گالری",
    New_Flow_Tutorials_quickreply_connection_8: "✅ بلوک زیرشاخه گالری",

    // generic
    New_Flow_Tutorials_generic_title: "بلوک گالری (کاروسل)",
    New_Flow_Tutorials_generic_description: "ایجاد گالری قابل اسکرول افقی (کاروسل) از آیتم‌ها",
    New_Flow_Tutorials_generic_usageType:
      "مناسب برای نمایش محصولات، منوی خدمات، دسته‌بندی‌ها، معرفی تیم، پورتفولیو و مقایسه گزینه‌ها.",
    New_Flow_Tutorials_generic_tip_1: "تصاویر با ابعاد یکسان استفاده کنید (مثلاً 1:1)",
    New_Flow_Tutorials_generic_tip_2: "تعداد آیتم‌ها را بین 3 تا 5 نگه دارید",
    New_Flow_Tutorials_generic_tip_3: "عناوین کوتاه و واضح بنویسید",
    New_Flow_Tutorials_generic_tip_4: "برای محصولات مشابه یا مقایسه ها مناسب است",
    New_Flow_Tutorials_generic_limitation_1: "حداکثر 10 آیتم در هر کاروسل",
    New_Flow_Tutorials_generic_connection_1: "✅ بلوک ورودی پیام",
    New_Flow_Tutorials_generic_connection_2: "✅ بلوک زیرشاخه گالری",
    New_Flow_Tutorials_generic_connection_3: "❌ بلوک لینک وب",
    New_Flow_Tutorials_generic_connection_4: "❌ بلوک پیام صوتی",
    New_Flow_Tutorials_generic_connection_5: "❌ بلوک پیام متنی",
    New_Flow_Tutorials_generic_connection_6: "❌ بلوک پاسخ سریع",
    New_Flow_Tutorials_generic_connection_7: "❌ بلوک تصویر و ویدیو",

    // genericitem
    New_Flow_Tutorials_genericitem_title: "آیتم کاروسل",
    New_Flow_Tutorials_genericitem_description: "یک آیتم درون کاروسل شامل تصویر، عنوان، توضیحات، لینک و تا 3 دکمه",
    New_Flow_Tutorials_genericitem_usageType:
      "مناسب برای نمایش جزئیات محصولات، معرفی خدمات، نمایش تیم، نمونه‌کارها و پکیج‌های قیمتی.",
    New_Flow_Tutorials_genericitem_feature_1: "لینک وب اختیاری",
    New_Flow_Tutorials_genericitem_feature_2: "تصویر اختیاری: JPEG, PNG, GIF",
    New_Flow_Tutorials_genericitem_feature_3: "ویدیو: MP4, WebM, OGG",
    New_Flow_Tutorials_genericitem_feature_4: "تا 3 دکمه با خروجی مستقل",
    New_Flow_Tutorials_genericitem_tip_1: "برای هر آیتم تصویر جذاب اضافه کنید",
    New_Flow_Tutorials_genericitem_tip_2: "عنوان برای پیام اصلی، توضیحات برای جزئیات",
    New_Flow_Tutorials_genericitem_tip_3: "لینک‌ها را قبل از ارسال تست کنید",
    New_Flow_Tutorials_genericitem_tip_4: "متن دکمه‌ها کوتاه و واضح باشد",
    New_Flow_Tutorials_genericitem_tip_5: "بهتر است از لینک کوتاه‌شده استفاده کنید",
    New_Flow_Tutorials_genericitem_limitation_1: "عنوان: حداکثر 140 کاراکتر",
    New_Flow_Tutorials_genericitem_limitation_2: "توضیحات: حداکثر 140 کاراکتر",
    New_Flow_Tutorials_genericitem_limitation_3: "حداکثر 3 دکمه",
    New_Flow_Tutorials_genericitem_limitation_4: "عنوان دکمه: حداکثر 40 کاراکتر",
    New_Flow_Tutorials_genericitem_limitation_5: "حجم فایل: حداکثر 50 مگابایت",
    New_Flow_Tutorials_genericitem_limitation_6: "حداقل یک دکمه الزامی است",
    New_Flow_Tutorials_genericitem_connection_1: "❌ بلوک ورودی پیام",
    New_Flow_Tutorials_genericitem_connection_2: "✅ بلوک گالری",
    New_Flow_Tutorials_genericitem_connection_3: "✅ بلوک لینک وب",
    New_Flow_Tutorials_genericitem_connection_4: "✅ بلوک پیام صوتی",
    New_Flow_Tutorials_genericitem_connection_5: "✅ بلوک پیام متنی",
    New_Flow_Tutorials_genericitem_connection_6: "✅ بلوک پاسخ سریع",
    New_Flow_Tutorials_genericitem_connection_7: "✅ بلوک تصویر و ویدیو",

    // weblink
    New_Flow_Tutorials_weblink_title: "بلوک لینک وب",
    New_Flow_Tutorials_phonenumbergrabber_title: "بلوک دریافت شماره تلفن",
    New_Flow_Tutorials_phonenumbergrabber_description:
      "این بلاک منتظر دریافت شماره تلفن می‌ماند و در صورت دریافت شماره، آن را به‌عنوان شماره معتبر ثبت می‌کند.",
    New_Flow_Tutorials_phonenumbergrabber_usageType:
      "مناسب برای جمع‌آوری شماره تماس مشتریان، ثبت‌نام، پیگیری سفارش، مشاوره و تماس با واحد فروش.",
    New_Flow_Tutorials_phonenumbergrabber_feature_1: "انتظار برای پاسخ کاربر تا دریافت شماره تلفن",
    New_Flow_Tutorials_phonenumbergrabber_feature_2: "اعتبارسنجی و ثبت خودکار شماره دریافت‌شده",
    New_Flow_Tutorials_phonenumbergrabber_tip_1:
      "قبل از این بلوک، با یک بلوک پیام متنی از کاربر بخواهید شماره خود را ارسال کند",
    New_Flow_Tutorials_phonenumbergrabber_tip_2: "قالب مورد انتظار شماره را به کاربر بگویید (مثلاً با کد کشور)",
    New_Flow_Tutorials_phonenumbergrabber_tip_3: "بعد از این بلوک، پیام تأیید یا تشکر ارسال کنید",
    New_Flow_Tutorials_phonenumbergrabber_limitation_1: "نمی‌تواند بلوک اول فلو باشد",
    New_Flow_Tutorials_phonenumbergrabber_limitation_2: "فقط یک ورودی و یک خروجی دارد",
    New_Flow_Tutorials_phonenumbergrabber_limitation_3: "فقط شماره‌های معتبر ثبت می‌شوند",
    New_Flow_Tutorials_phonenumbergrabber_connection_3: "❌ بلوک زیرشاخه گالری",
    New_Flow_Tutorials_phonenumbergrabber_connection_2: "❌ بلوک پاسخ سریع",
    New_Flow_Tutorials_phonenumbergrabber_connection_1: "❌ بلوک ورودی پیام (نمی‌تواند بلوک اول باشد)",
    New_Flow_Tutorials_weblink_description: "ارسال لینک وب قابل کلیک که در مرورگر کاربر باز می‌شود",
    New_Flow_Tutorials_weblink_usageType:
      "مناسب برای هدایت به وب‌سایت، صفحه محصول، فروشگاه، فرم ثبت‌نام، صفحات لندینگ و مقالات.",
    New_Flow_Tutorials_weblink_feature_1: "اعتبارسنجی خودکار URL",
    New_Flow_Tutorials_weblink_feature_2: "پشتیبانی از لینک‌های با/بدون WWW",
    New_Flow_Tutorials_weblink_tip_1: "بهتر است از کوتاه‌کننده لینک استفاده کنید",
    New_Flow_Tutorials_weblink_tip_2: "لینک‌ها را قبل از ارسال تست کنید",
    New_Flow_Tutorials_weblink_tip_3: "لینک‌ها باید موبایل‌فرندلی باشند",
    New_Flow_Tutorials_weblink_tip_4: "از Redirect زیاد خودداری کنید",
    New_Flow_Tutorials_weblink_tip_5: "ترجیحاً از HTTPS استفاده کنید",
    New_Flow_Tutorials_weblink_limitation_1: "فقط http:// یا https:// معتبر است",
    New_Flow_Tutorials_weblink_limitation_2: "امکان اضافه کردن توضیحات وجود ندارد",
    New_Flow_Tutorials_weblink_limitation_3: "لینک‌های داخلی (file://) پشتیبانی نمی‌شوند",
    New_Flow_Tutorials_weblink_connection_1: "⬅️ ورودی از: بلوک زیرشاخه گالری",
    New_Flow_Tutorials_weblink_connection_2: "❌ خروجی ندارد (نقطه پایان فلو)",

    // #endregion Flow Section New
    //
    //
    //
    //
    //
    // #region Notification Section
    Notify_Ok: "عملیات با موفقیت انجام شد",
    Notify_InternalException: "خطایی در سیستم رخ داده است",
    Notify_CannotSendSmsNow: "در حال حاضر امکان ارسال پیامک وجود ندارد",
    Notify_InvalidPhoneNumber: "شماره تلفن واردشده معتبر نیست",
    Notify_InvalidCountryCode: "کد کشور واردشده معتبر نیست",
    Notify_PhoneNumberNotAvailableInThisCountry: "امکان استفاده از این شماره در کشور انتخابی وجود ندارد",
    Notify_InstagramerIdNotExist: "یوزر اینستاگرام پیدا نشد",
    Notify_EmptyProductList: "لیست محصولات خالی است",
    Notify_InvalidVerificationCode: "کد تأیید واردشده نادرست است",
    Notify_LowQuality: "کیفیت محتوا پایین است",
    Notify_CannotEmptyChildren: "امکان حذف زیرمجموعه‌ها وجود ندارد",
    Notify_InvalidAspectRatio: "نسبت ابعاد واردشده معتبر نیست",
    Notify_InvalidMediaCodec: "کدک رسانه پشتیبانی نمی‌شود",
    Notify_InvalidMediaType: "نوع رسانه پشتیبانی نمی‌شود",
    Notify_MediaUrlNotAccessible: "آدرس رسانه در دسترس نیست",
    Notify_CannotCreatePrePostNow: "در حال حاضر امکان ایجاد پیش‌نویس وجود ندارد",
    Notify_InvalidMediaContent: "محتوای رسانه معتبر نیست",
    Notify_Unexpected: "خطای غیرمنتظره رخ داده است",

    Notify_TooManyRequestForImageHashtagGenerator: "تعداد درخواست‌ها برای تولید هشتگ تصویر بیش از حد مجاز است",
    Notify_LoginFailed: "ورود ناموفق بود، لطفاً دوباره تلاش کنید",
    Notify_NullUserId: "شناسه کاربر وارد نشده است",
    Notify_RealtimeSocketNotExist: "اتصال با سرور برقرار نیست",
    Notify_PushSocketNotExist: "اتصال برقرار نیست",
    Notify_InstaApiNotFoundForConnect: "اتصال با سرور های اینستاگرم برقرار نیست",
    Notify_EmptyHashtagList: "لیست هشتگ خالی است",
    Notify_InvalidHashtagListId: "شناسه لیست هشتگ معتبر نیست",
    Notify_DeleteHashtagFail: "حذف هشتگ انجام نشد",
    Notify_InvalidBase64Content: "محتوای Base64 معتبر نیست",
    Notify_InvalidTermsAndConditionSvgType: " قوانین و شرایط معتبر نیست",
    Notify_InvalidLotteryAnnouncementBannerId: "شناسه بنر اعلام قرعه‌کشی معتبر نیست",
    Notify_InvalidLotteryAnnouncementBannerStr: "متن بنر اعلام قرعه‌کشی معتبر نیست",
    Notify_InvalidPostId: "شناسه پست معتبر نیست",
    Notify_TooSoonLotteryInfo: "اطلاعات قرعه‌کشی ارسال شده است",
    Notify_InvalidDirectParams: "پارامترهای دایرکت معتبر نیست",
    Notify_NoInstagramerExists: "هیچ حساب اینستاگرامی یافت نشد",
    Notify_PropertyNotFoundOrNull: "ایتم یافت نشد یا خالی است",
    Notify_ReachNumberOfPinDirect: "به حداکثر تعداد پیام‌های سنجاق‌شده رسیده‌اید",
    Notify_InvalidStoryId: "شناسه استوری معتبر نیست",
    Notify_MaxPrePostReach: "به حداکثر تعداد پیش‌نویس رسیده‌اید",
    Notify_InvalidDraftId: "شناسه پیش‌نویس معتبر نیست",
    Notify_InvalidPrePostId: "شناسه پیش‌پست معتبر نیست",
    Notify_ReachHashtagListLimit: "به حداکثر تعداد لیست هشتگ رسیده‌اید",
    Notify_EmptyUsername: "نام کاربری وارد نشده است",
    Notify_TooManyRequestForPageHashtagAnalysis: "تعداد درخواست‌ها برای تحلیل هشتگ صفحه بیش از حد مجاز است",
    Notify_PasswordRequired: "رمز عبور الزامی است",
    Notify_PackageRequiredInThisTime: "نیاز به پکیج فعال دارید",
    Notify_FeatureRequiredInThisTime: " نیاز به فعال بودن این قابلیت است",
    Notify_NoShopperExist: "هیچ فروشنده‌ای یافت نشد",
    Notify_FollowerLotteryTypeRandomlyWithoutLoginForVerifiedOrPrivateAccount:
      "قرعه‌کشی تصادفی فالوور بدون ورود، برای حساب‌های خصوصی یا تأییدشده امکان‌پذیر نیست",
    Notify_FollowerLotteryTypeEngagmentWithoutLoginForPrivateAccount:
      "قرعه‌کشی تعامل فالوور بدون ورود، برای حساب‌های خصوصی امکان‌پذیر نیست",
    Notify_InvalidLinkId: "شناسه لینک معتبر نیست",
    Notify_ReachMaxBioLink: "به حداکثر تعداد لینک بیو رسیده‌اید",
    Notify_OnlyBusinessAccountHasThisAccess: "این دسترسی فقط برای حساب‌های تجاری فعال است",
    Notify_NoYoutubeChannelFound: "هیچ کانال یوتیوبی یافت نشد",
    Notify_CannotGetYoutubeRightNow: "در حال حاضر امکان دریافت اطلاعات یوتیوب وجود ندارد",
    Notify_AparatUsernameNotFound: "نام کاربری آپارات یافت نشد",
    Notify_AparatChannelHasNotAnyVideo: "کانال آپارات هیچ ویدئویی ندارد",
    Notify_InvalidYoutubeChannelId: "شناسه کانال یوتیوب معتبر نیست",
    Notify_NoAparatChannelFound: "هیچ کانال آپاراتی یافت نشد",
    Notify_CannotGetAparatRightNow: "در حال حاضر امکان دریافت اطلاعات آپارات وجود ندارد",
    Notify_NotSettedCustomDomain: "دامنه سفارشی تنظیم نشده است",
    Notify_CannotStoryWithoutWinnerBanner: "ایجاد استوری بدون بنر برنده امکان‌پذیر نیست",
    Notify_ExceedMaxStoryWinnerLotteryBanner: "تعداد بنرهای برنده قرعه‌کشی استوری از حد مجاز بیشتر است",
    Notify_LotteryOnProcessingOrEnded: "قرعه‌کشی در حال پردازش یا به پایان رسیده است",
    Notify_CannotAbortLotteryOneHourBefore: "امکان لغو قرعه‌کشی کمتر از یک ساعت مانده به اجرا وجود ندارد",
    Notify_CannotAbortFollowerLottery: "امکان لغو قرعه‌کشی فالوورها وجود ندارد",
    Notify_InvalidImageOrExceedMaxSize: "تصویر معتبر نیست یا حجم آن بیش از حد مجاز است",
    Notify_ExceedLoginAttempt: "تعداد تلاش‌های ورود از حد مجاز بیشتر شده است",
    Notify_NotExistComment: "کامنت یافت نشد",
    Notify_UserNotFound: "کاربر یافت نشد",

    Notify_ExistInstagramerBefore: "این حساب اینستاگرام قبلاً ثبت شده است",
    Notify_CannotChangeBusinessAccountType: "امکان تغییر نوع حساب تجاری وجود ندارد، لطفا به پشتیبانی تیکت بزنید",
    Notify_InvalidProductId: "شناسه محصول واردشده معتبر نیست",
    Notify_InvalidTrendHashtagPeriod: "دوره انتخابی برای هشتگ ترند معتبر نیست",
    Notify_InvalidLanguageId: "شناسه زبان معتبر نیست",
    Notify_CannotStoryWithoutTermsBanner: "ایجاد استوری بدون بنر قوانین امکان‌پذیر نیست",
    Notify_ExceedMaxStoryTermsLotteryBanner: "تعداد بنرهای قوانین قرعه‌کشی استوری از حد مجاز بیشتر است",
    Notify_LotteryTermsIsNull: "قوانین قرعه‌کشی ثبت نشده است",
    Notify_CanShareTermsBefore6HoursOfStartLottery: "امکان اشتراک قوانین فقط تا ۶ ساعت قبل از شروع قرعه‌کشی وجود دارد",
    Notify_CanShareTermForOnlyDefinedStatusLotteries: "اشتراک قوانین فقط برای قرعه‌کشی‌های در حالت تعریف‌شده فعال است",
    Notify_SharedRemainingTimeBefore: "زمان باقی‌مانده قبلاً به اشتراک گذاشته شده است",
    Notify_ShareRemainingTimeOnlyActiveForScoreLottery: "اشتراک زمان باقی‌مانده فقط برای قرعه‌کشی‌های امتیازی فعال است",
    Notify_CanShareTermsBefore1HoursOfStartLottery: "امکان اشتراک قوانین فقط تا ۱ ساعت قبل از شروع قرعه‌کشی وجود دارد",
    Notify_InvalidSubProductIds: "شناسه‌های زیرمحصول معتبر نیستند",
    Notify_ReachMaxProductMedia: "به حداکثر تعداد رسانه برای محصول رسیده‌اید",
    Notify_InvalidMediaProductId: "شناسه رسانه محصول معتبر نیست",
    Notify_AccountNotABusiness: "این حساب تجاری نیست",
    Notify_NotFoundProductWithThisTempId: "محصولی با این شناسه موقت یافت نشد",
    Notify_InvalidAvailabilityStatus: "وضعیت دسترسی واردشده معتبر نیست",
    Notify_InvalidIbanNumber: "شماره شبا واردشده معتبر نیست",
    Notify_ExistedIbanNumber: "این شماره شبا قبلاً ثبت شده است",
    Notify_IbanMethodNotAvailableForNotTomanPriceUser: "روش شبا برای کاربرانی با واحد پول غیرتومان فعال نیست",
    Notify_SearchQueryIsEmpty: "عبارت جستجو وارد نشده است",
    Notify_ExceedMaxInEachCard: "تعداد موارد در هر کارت از حد مجاز بیشتر است",
    Notify_ProductNotAlbumPost: "این محصول در قالب پست آلبومی ثبت نشده است",
    Notify_InvalidChildrenId: "شناسه فرزند معتبر نیست",
    Notify_NotAvailableProduct: "محصول در حال حاضر در دسترس نیست",
    Notify_ExceedStockCount: "تعداد انتخاب‌شده بیش از موجودی انبار است",
    Notify_CannotUnloadAnInstanceProduct: "امکان تخلیه یک نمونه محصول وجود ندارد",
    Notify_InvalidCategoryId: "شناسه دسته‌بندی معتبر نیست",
    Notify_NotFoundAnyProductOnThisCategory: "در این دسته‌بندی محصولی یافت نشد",
    Notify_NotFoundAnyNextProduct: "محصول بعدی یافت نشد",
    Notify_NotFoundAnyPreviousProduct: "محصول قبلی یافت نشد",
    Notify_InvalidItemId: "شناسه آیتم معتبر نیست",
    Notify_IpInvalid: "آی‌پی واردشده معتبر نیست",
    Notify_InstagramRedirectInTenSeconds: "تا ۱۰ ثانیه دیگر به‌صورت خودکار به اینستاگرام هدایت می‌شوید",
    Notify_InstagramRedirect: "در حال انتقال به اینستاگرام",
    Notify_InstagramRedirectExplain: "از فعال بودن فیلترشکن خود اطمینان حاصل کنید، زیرا آی‌پی شما معتبر نیست",
    Notify_ThisInstagramAccountAddedBefore: "این حساب اینستاگرام قبلاً اضافه شده است",
    Notify_InvalidTicketId: "شناسه تیکت معتبر نیست",
    Notify_ExpiredSignature: "امضا منقضی شده است",
    Notify_Forbidden: "دسترسی غیرمجاز",
    Notify_ConnectedInstagramPageNotFound: "صفحه اینستاگرام متصل پیدا نشد",
    Notify_AllInstagramAccountConnectedAddedBefore: "تمام حساب‌های اینستاگرام متصل قبلاً اضافه شده‌اند",
    Notify_SelectInstagramPageToConnect: "لطفاً صفحه اینستاگرام موردنظر برای اتصال را انتخاب کنید",
    Notify_InstagramRedirectRoleNotFound: "نقش تغییرمسیر اینستاگرام یافت نشد",
    Notify_FacebookLoginNotFound: "ورود فیسبوک پیدا نشد",
    Notify_SelectedPageNotFound: "صفحه انتخاب‌شده پیدا نشد",
    Notify_ShouldConnectInstaPageAgain: "لازم است صفحه اینستاگرام را دوباره متصل کنید",
    Notify_InvalidProductSuggestionId: "شناسه پیشنهاد محصول معتبر نیست",
    Notify_NotSavedSuggestions: "پیشنهادات ذخیره نشده‌اند",
    Notify_ExistedSuggestedMedia: "این رسانه پیشنهادی قبلاً ثبت شده است",
    Notify_InvalidUploadMediaUrl: "آدرس آپلود رسانه معتبر نیست",
    Notify_SuggestedPostAutoReplyKeyNotExist: "کلید پاسخ خودکار پست پیشنهادی یافت نشد",
    Notify_UploadingTimeIsSoSoon: "زمان آپلود خیلی زود است",
    Notify_InvalidPreStoryId: "شناسه پیش‌استوری معتبر نیست",
    Notify_NotProvidedInstagramerId: "شناسه اینستاگرامر وارد نشده است",
    Notify_InvalidInstagramerId: "شناسه اینستاگرامر معتبر نیست",
    Notify_InvalidThreadId: "شناسه رشته معتبر نیست",
    Notify_InvalidLiveMediaId: "شناسه رسانه زنده معتبر نیست",
    Notify_NotCreatedExportComment: "خروجی کامنت ایجاد نشده است",
    Notify_CreateExportAvailableWith24HourPeriod: "امکان ایجاد خروجی هر ۲۴ ساعت یک‌بار وجود دارد",
    Notify_NotSetted: "تنظیم انجام نشده است",
    Notify_ExceedGeneralAutoReplyCount: "تعداد پاسخ‌های خودکار عمومی از حد مجاز بیشتر است",
    Notify_InvalidTransactionId: "شناسه تراکنش معتبر نیست",
    Notify_CannotRenewalPackageWith1MonthTimeExist: "تمدید پکیج در حال حاضر امکان‌پذیر نیست",
    Notify_CannotDeleteCurrentSession: "امکان حذف جلسه فعلی وجود ندارد",
    Notify_InvalidSessionId: "شناسه جلسه معتبر نیست",
    Notify_CannotDeleteCurrentSessionForNewSessionFor1Day:
      "تا ۱ روز امکان حذف جلسه فعلی برای ایجاد جلسه جدید وجود ندارد",
    Notify_UpgradedBefore: "این حساب قبلاً ارتقا یافته است",
    Notify_PermissionNotExist: "مجوز موردنظر وجود ندارد",
    Notify_NotExistUser: "کاربر یافت نشد",
    Notify_UserAlreadyAsPartner: "کاربر از قبل به عنوان ادمین همکار ثبت شده است",
    Notify_ReachMaxPartnerCount: "به حداکثر تعداد ادمین همکار رسیده‌اید",
    Notify_InvalidPartnerRoleProvided: "نقش ادمین همکار ارائه‌شده معتبر نیست",
    Notify_PartnerRolesLengthIsZero: "هیچ نقشی برای ادمین همکار تعریف نشده است",
    Notify_PartnerNotExist: "ادمین همکار یافت نشد",

    Notify_CannotMakeYourSelfPartnerAsPartnerForYourSelf: "نمی‌توانید خودتان را ادمین همکار خودتان انتخاب کنید",
    Notify_PartnerExpireTimeMustBeBiggerThan1HourFromNow:
      "زمان انقضای ادمین همکار باید حداقل ۱ ساعت پس از حال حاضر باشد",
    Notify_PartnerNameCannotExceed100: "نام ادمین همکار نمی‌تواند بیش از ۱۰۰ کاراکتر باشد",
    Notify_ProductIsMultiSubproducted: "این محصول شامل چندین زیرمحصول است",
    Notify_InvalidSubProductId: "شناسه زیرمحصول معتبر نیست",
    Notify_ProductIdOutOfStock: "محصول موردنظر در موجودی نیست",
    Notify_SubProductIdRequired: "شناسه زیرمحصول الزامی است",
    Notify_CardIsEmpty: "کارت خالی است",
    Notify_InvalidAddressId: "شناسه آدرس معتبر نیست",
    Notify_ExceedTotalCreateAddress: "از حداکثر تعداد مجاز ایجاد آدرس عبور کرده‌اید",
    Notify_NotSupportedCountry: "کشور انتخاب‌شده پشتیبانی نمی‌شود",
    Notify_CannotFetchAddressInThisEndpoint: "امکان دریافت آدرس در این نقطه پایانی وجود ندارد",
    Notify_InvalidPostalCode: "کد پستی واردشده معتبر نیست",
    Notify_NeedCompleteAddress: "وارد کردن آدرس کامل الزامی است",
    Notify_CannotBuyFromYourSelf: "نمی‌توانید از خودتان خرید کنید",
    Notify_AllReadyIsBusiness: "این حساب قبلاً تجاری ثبت شده است",
    Notify_InvalidBusinessType: "نوع حساب تجاری معتبر نیست",
    Notify_UserAlreadyAuthorized: "کاربر قبلاً مجاز شده است",
    Notify_InstagramerNotInfluencer: "اینستاگرامر موردنظر اینفلوئنسر نیست",
    Notify_InstagramerNotShopper: "اینستاگرامر فروشنده نیست",
    Notify_AuthorizedInstagramerBefore: "اینستاگرامر قبلاً مجاز شده است",
    Notify_UserNotAuthorizedYet: "کاربر هنوز مجاز نشده است",
    Notify_InstagramerNotAuthorized: "اینستاگرامر مجاز نشده است",
    Notify_InvalidBankCardNumber: "شماره کارت بانکی واردشده معتبر نیست",
    Notify_TheOwnerOfPhoneNumberNotBlongsNationalNumber: "صاحب شماره تلفن با شماره ملی مطابقت ندارد",
    Notify_CouponCodeAlreadyExists: "کد کوپن قبلاً ثبت شده است",
    Notify_InvalidCouponId: "شناسه کوپن معتبر نیست",
    Notify_CannotChangeShowPrivateCouponInBio: "امکان تغییر نمایش کوپن خصوصی در بیو وجود ندارد",
    Notify_InvalidCouponCode: "کد کوپن معتبر نیست",
    Notify_CouponForAnotherPerson: "کوپن متعلق به شخص دیگری است",
    Notify_CouponExpired: "کوپن منقضی شده است",
    Notify_CouponDeleted: "کوپن حذف شده است",
    Notify_CouponUsedUp: "کوپن استفاده شده است",

    Notify_InvalidUsernameSearchQuery: "عبارت جستجوی نام کاربری معتبر نیست",
    Notify_PreviouslyAddedShopAddress: "این آدرس فروشگاه قبلاً اضافه شده است",
    Notify_NotSettedShopperAddress: "آدرس فروشنده تنظیم نشده است",
    Notify_NotExistAnyLogesticInYourCountry: "هیچ سیستم لجستیکی در کشور شما موجود نیست",
    Notify_InvalidLogesticIds: "شناسه‌های لجستیک معتبر نیستند",
    Notify_LogsticsNotSetted: "لجستیک تنظیم نشده است",
    Notify_NotCommpletedAllBusinessVerification: "تمام تأییدیه‌های تجاری تکمیل نشده‌اند",
    Notify_ThisParcelNotSupportedByAnySelectedAvailableLogestic: "این بسته توسط هیچ لجستیک انتخابی پشتیبانی نمی‌شود",
    Notify_NotSupportedLogestic: "لجستیک انتخاب‌شده پشتیبانی نمی‌شود",
    Notify_ExceedLogesticHeight: "ارتفاع بسته از حد مجاز لجستیک بیشتر است",
    Notify_ExceedLogesticWidth: "عرض بسته از حد مجاز لجستیک بیشتر است",
    Notify_ExceedLogesticLength: "طول بسته از حد مجاز لجستیک بیشتر است",
    Notify_ExceedLogesticTotalLength: "مجموع طول بسته از حد مجاز لجستیک بیشتر است",
    Notify_ExceedLogesticWeight: "وزن بسته از حد مجاز لجستیک بیشتر است",
    Notify_UserAddressesIsEmptyOrNotSetDefaultAddress: "آدرس‌های کاربر خالی است یا آدرس پیش‌فرض تنظیم نشده",
    Notify_NotSupportedBoxByThisDimensions: "جعبه با این ابعاد پشتیبانی نمی‌شود",
    Notify_CannotAvailableOutOfStackProduct: "امکان در دسترس قرار دادن محصول خارج از انبار وجود ندارد",
    Notify_YouAreDeadInCivilRegistration: "وضعیت شما در ثبت احوال فوت شده ثبت شده است",
    Notify_InstagramerAlreadyAuthorized: "اینستاگرامر قبلاً مجاز شده است",
    Notify_ThreadShouldBeActiveForSendMessage: "این چت برای ارسال پیام باید فعال باشد",
    Notify_PreviouslyClosedTicket: "تیکت قبلاً بسته شده است",
    Notify_NotMatchedCart: "سبد خرید تطابق ندارد",
    Notify_PhoneNumberNotBlongsNationalNumber: "شماره تلفن با شماره ملی مطابقت ندارد",
    Notify_NotMatchedCardNumberAndIdentity: "شماره کارت و اطلاعات هویتی تطابق ندارند",
    Notify_SuspendedShop: "این فروشگاه تعلیق شده است، لطفا به پشتیبانی تیکت بزنید",
    Notify_LogesticIdNotSpecifiedForaPostParcel: "شناسه لجستیک برای بسته پستی مشخص نشده است",
    Notify_LogesticNotInAvailableLogestics: "لجستیک انتخاب‌شده در لیست لجستیک‌های موجود نیست",
    Notify_ExceedProductReportForLast24Hour: "تعداد گزارش محصول در ۲۴ ساعت گذشته بیش از حد مجاز است",
    Notify_PreviouslyReportedThisProduct: "قبلاً این محصول را گزارش کرده‌اید",
    Notify_InvalidOrderId: "شناسه سفارش معتبر نیست",
    Notify_NotPendingPayRequest: "درخواست پرداخت در حالت انتظار نیست",
    Notify_NotExistShopAddress: "آدرس فروشگاه یافت نشد",
    Notify_InvalidOrderStatus: "وضعیت سفارش معتبر نیست",
    Notify_CancelInvoiceFailed: "لغو فاکتور انجام نشد",
    Notify_PaymentSystemNotSupportedThisPriceType: "سیستم پرداخت این نوع قیمت را پشتیبانی نمی‌کند",
    Notify_InvalidSentOrderType: "نوع سفارش ارسالی معتبر نیست",
    Notify_InvalidParcelId: "شناسه بسته معتبر نیست",
    Notify_AddedParcelIdBefore: "شناسه بسته قبلاً اضافه شده است",
    Notify_InvoiceNotOnPaid: "این فاکتور هنوز پرداخت نشده است",

    Notify_CreatedSystemTicketOnOrderBefore: "تیکت سیستم برای این سفارش قبلاً ایجاد شده است",
    Notify_PaymentServiceNotResponding: "سرویس پرداخت در حال حاضر پاسخ نمی‌دهد",
    Notify_YouAreNotAdmin: "شما ادمین نیستید",
    Notify_YouAreNotASubAdmin: "شما ادمین همکار نیستید",
    Notify_InvalidFbId: "شناسه فیسبوک معتبر نیست",
    Notify_InvalidFeatureId: "شناسه قابلیت معتبر نیست",
    Notify_InActiveFeature: "این قابلیت غیرفعال است",
    Notify_FeaturePaused: "این قابلیت متوقف شده است",
    Notify_InvalidPromptInput: "ورودی پرامپت معتبر نیست",
    Notify_PromptNotGenerated: "پرامپت تولید نشده است",
    Notify_AIGeneratorFailed: "تولیدکننده هوش مصنوعی با خطا مواجه شد",
    Notify_NotExecutedPromptForCommentYet: "پرامپت برای کامنت هنوز اجرا نشده است",
    Notify_InstagramPermissionNotExist: "مجوز اینستاگرام وجود ندارد",
    Notify_InvalidTimeZone: "منطقه زمانی معتبر نیست",
    Notify_PromptCaptionExampleNotGenerated: "مثال عنوان پرامپت تولید نشده است",
    Notify_InvalidMasterFlowId: "شناسه  فلوی اصلی معتبر نیست",
    Notify_InvalidFlowId: "شناسه فلو معتبر نیست",
    Notify_EmptySubFlows: "زیرفلوها خالی است",
    Notify_InvalidFlowObject: "فلو معتبر نیست",
    Notify_InvalidMasterFlowTitle: "عنوان فلوی اصلی معتبر نیست",
    Notify_InvalidPromptId: "شناسه پرامپت معتبر نیست",
    Notify_ExceedThreadTokenLimit: "حد مجاز توکن‌های این گفتگو تمام شده است",
    Notify_InvalidMediaId: "شناسه رسانه معتبر نیست",
    Notify_InvalidLotteryId: "شناسه قرعه‌کشی معتبر نیست",
    Notify_CannotAbortNonUpcomingLottery: "امکان لغو قرعه‌کشی‌های در حال حاضر وجود ندارد",
    Notify_CommentCountExceedFreeExport: "تعداد کامنت‌ها از حد مجاز برای قرعه کشی رایگان بیشتر است",
    Notify_InvalidReserveFeatureId: "شناسه فیچر رزرو معتبر نیست",
    Notify_CannotRenewalThisFeatureNow: "امکان تمدید این فیچر در حال حاضر وجود ندارد",
    Notify_InvalidLotteryStatus: "وضعیت قرعه‌کشی برای تغییر معتبر نیست",
    Notify_PublishedLotteryBannerBefore: "بنر قرعه‌کشی قبلاً منتشر شده است",
    Notify_LotteryWinnerBannerIsNull: "بنر برنده قرعه‌کشی وجود ندارد",
    Notify_InvalidCustomPromptSigniture: "امضای پرامپت سفارشی نامعتبر است",
    Notify_ServiceTemporarilyUnavailable: "سرویس به طور موقت در دسترس نیست",
    Notify_PageSummaryNotGenerated: "برنسی به داده‌های بیشتری نیاز دارد تا صفحه شما را تحلیل کند.\nلطفاً شکیبا باشید.",
    Notify_GenerateAIFail: "تولید هوش مصنوعی ناموفق بود",
    Notify_InvalidPageAnalysis: "تحلیل صفحه نامعتبر است",
    Notify_InvalidCustomPrompt: "پرامپت سفارشی نامعتبر است",
    Notify_AIModelNotSupportImage: "مدل هوش مصنوعی از تصویر پشتیبانی نمی‌کند",
    Notify_PromptNotSupportImage: "پرامپت از تصویر پشتیبانی نمی‌کند",
    Notify_AIModelNotSupportAudio: "مدل هوش مصنوعی از صدا پشتیبانی نمی‌کند",
    Notify_PromptNotSupportVoice: "پرامپت از صوت پشتیبانی نمی‌کند",
    Notify_AIModelNotSupportVideo: "مدل هوش مصنوعی از ویدیو پشتیبانی نمی‌کند",
    Notify_InvalidPrompt: "پرامپت نامعتبر است",
    Notify_InvalidImageGeneratorInput: "ورودی تولیدکننده تصویر نامعتبر است",
    Notify_InSuffcientNumberOfImage: "تعداد تصاویر کافی نیست",
    Notify_CreateImageExceedLimit: "ایجاد تصویر از حد مجاز بیشتر شده است",
    Notify_InvalidPromptType: "نوع پرامپت نامعتبر است",
    Notify_UnSupportedAIInputType: "نوع ورودی هوش مصنوعی پشتیبانی نمی‌شود",
    Notify_UnSupportedOrientationType: "نوع جهت‌گیری پشتیبانی نمی‌شود",
    Notify_SoraFailedAiCall: "فراخوانی هوش مصنوعی Sora ناموفق بود",
    Notify_AIVideoSecondNotSupported: "مدت زمان ویدیو هوش مصنوعی پشتیبانی نمی‌شود",
    Notify_FailedToTraslateDescription: "ترجمه توضیحات انجام نشد",
    Notify_FailedToGenerateEmbedVector: "تولید بردار embed ناموفق بود",
    Notify_NotGeneratedSummaryYet: "خلاصه هنوز تولید نشده است",
    Notify_NoEventsFoundForTheGivenTimeRange: "رویدادی برای بازه زمانی مشخص‌شده یافت نشد",
    Notify_NoEventsFoundForThisPrompt: "رویدادی برای این پرامپت یافت نشد",
    Notify_PageAnalysisNotExist: "تحلیل صفحه وجود ندارد",
    Notify_NoEventIdeaGenerated: "هیچ ایده‌ای برای رویداد تولید نشد",
    Notify_PhoneNumberAddedBefore: "این شماره تلفن قبلاً اضافه شده است",
    Notify_WhatsAppCodeSendedBeforeAndWait1Day: "کد واتساپ قبلاً ارسال شده است؛ لطفاً یک روز صبر کنید",
    Notify_WhatsAppCodeNotRequested: "درخواستی برای کد تأیید واتساپ ثبت نشده است",
    Notify_WhatsAppCodeMaxInvalidCountReach: "حداکثر تعداد تلاش نامعتبر برای کد واتساپ انجام شده است",
    Notify_UserWithThisPhoneNumberAlreadyExist: "کاربری با این شماره تلفن از قبل وجود دارد",
    Notify_InvalidAIToolId: "شناسه ابزار هوش مصنوعی نامعتبر است",
    Notify_AIToolParameterRequired: "پارامتر ابزار هوش مصنوعی الزامی است",
    Notify_AIToolParameterNotRequired: "این ابزار هوش مصنوعی پارامتر نمی‌پذیرد",
    Notify_ExceedDailyLimit: "از محدودیت روزانه عبور کرده‌اید",
    Notify_CannotGetTwitchRightNow: "در حال حاضر دریافت اطلاعات توییچ امکان‌پذیر نیست",
    Notify_InvalidTwitchChannelId: "شناسه کانال توییچ نامعتبر است",
    Notify_PhoneNumberRequired: "شماره تلفن الزامی است",
    Notify_NotVerifiedHost: "میزبان تأیید نشده است",
    Notify_NotBusinesser: "این کاربر صاحب کسب‌وکار نیست",
    Notify_NotFoundAnySuggestedCategory: "هیچ دسته‌بندی پیشنهادی یافت نشد",
    Notify_NoInvoiceExist: "هیچ صورتحسابی وجود ندارد",
    Notify_InvalidMediaAiCreatorKey: "مدل هوش مصنوعی نامعتبر است",
    Notify_InvalidMediaAiVersionKey: "ورژن هوش مصنوعی نامعتبر است",
    Notify_InvalidMediaAiRequestModel: "مدل درخواست رسانه هوش مصنوعی نامعتبر است",
    Notify_MediaAIError: "هنگام تولید رسانه با هوش مصنوعی خطایی رخ داد",
    Notify_TwitchChannelDoestHaveAnyVideo: "این کانال توییچ هیچ ویدیویی ندارد",
    Notify_CouponAlreadyDeleted: "این کوپن قبلاً حذف شده است",
    Notify_CouponNotDeleted: "این کوپن حذف نشده است",
    Notify_ExceedSubFlowCount: "تعداد زیرفلوها از حداکثر مجاز بیشتر شده است",
    Notify_ExceedFlowDepth: "عمق فلو از حداکثر مجاز بیشتر شده است",
    Notify_ExceedFlowItemCount: "تعداد آیتم‌های فلو از حداکثر مجاز بیشتر شده است",
    Notify_ExceedFlowMediaAudioCount: "تعداد رسانه‌ها و فایل‌های صوتی فلو از حداکثر مجاز بیشتر شده است",
    Notify_OneFlowButtonHasEmptyItem: "یکی از دکمه ها بدون فلو است",

    // Internal Notifications
    InternalNotify_Ok: "عملیات با موفقیت انجام شد",
    InternalNotify_RepetitiveHashtagInput: "هشتگ وارد شده تکراری است",
    InternalNotify_NotFoundDevice: "دستگاه یافت نشد",
    InternalNotify_EmptyHashtagList: "امکان ایجاد لیست خالی وجود ندارد",
    InternalNotify_CannotCreatePrePostNow: "در حال حاضر نمی‌توانید پیش‌پست ایجاد کنید",
    InternalNotify_PrivateAccountSelectedForCheckHashtag: "نمی‌توان حساب خصوصی را برای تحلیل انتخاب کرد",
    InternalNotify_InstagramLoginRequired: "این گزینه نیاز به ورود به اینستاگرام دارد",
    InternalNotify_InstagramLoginRequiredForVerifiedAccount:
      "این گزینه نیاز به ورود به اینستاگرام برای حساب‌های تأییدشده دارد",
    InternalNotify_PrivateOrVerifiedSponsor: "نمی‌توان حساب خصوصی یا تأییدشده را به عنوان اسپانسر انتخاب کرد",
    InternalNotify_StartUploadingPost: "پست در حال آپلود است",
    InternalNotify_UploadingPostError: "خطا در آپلود پست رخ داده است",
    InternalNotify_PostUploaded: "پست آپلود شد، صفحه را رفرش کنید تا مشاهده شود",
    InternalNotify_ExceededMedia: "تعداد رسانه‌ها از حد مجاز تجاوز کرده است",
    InternalNotify_More4IceBreaker: "نمی‌توانید بیش از ۴ گفت‌گو سریع داشته باشید",
    InternalNotify_CopyLink: "لینک شما کپی شد",
    InternalNotify_copy: "اطلاعات با موفقیت کپی شد",
    InternalNotify_CopyTrackingpost: "کد ردیابی بسته شما کپی شد",
    InternalNotify_Network: "خطای اتصال شبکه",
    InternalNotify_TimeExpire: "امکان ثبت وجود ندارد، زمان منقضی شده است",
    InternalNotify_ExceedPermittedHashtagNumber: "تعداد هشتگ‌ها از حد مجاز بیشتر است",
    InternalNotify_UnexpectedError: "خطای غیرمنتظره‌ای رخ داده است",
    InternalNotify_CopyToClipboard: "اطلاعات شما قبلاً در حافظه کپی شده است",
    InternalNotify_ExceedPermittedUploadMedia: "تعداد مدیا از حد مجاز بیشتر است",
    InternalNotify_FillRedBorderFields: "فیلدهای قرمز رنگ را پر کنید",
    InternalNotify_RepeatedVariation: "حداقل دو مورد تکراری هستند",
    InternalNotify_NeedOneProduct: "حداقل یک محصول مورد نیاز است",
    InternalNotify_UploadMedia: "مشکلی در آپلود رسانه وجود دارد",
    InternalNotify_TurnOnProxy: "باید از آی‌پی معتبر استفاده کنید",
    InternalNotify_ExceedPermittedLiveTime: "زمان لایو از حد مجاز گذشته است",
    InternalNotify_CommentDisabled: "نمی‌توانید زمانی که کامنت‌ها غیرفعال هستند، عملیات انجام دهید",
    InternalNotify_ExceedSelectedCollaboratorPage: "تعداد صفحات همکار انتخاب‌شده بیش از حد مجاز است",
    InternalNotify_RepetitiveCollaboratorPage: "این نام کاربری قبلاً انتخاب شده است",
    InternalNotify_ExceedPermittedSizeOfImage: "حجم تصویر از حد مجاز بیشتر است",
    InternalNotify_ExceedPermittedAspectRatioAlbum: "نسبت ابعاد ویدئو آلبوم از حد مجاز تجاوز کرده است",
    InternalNotify_ExceedPermittedSizeOfVideoAlbum: "حجم ویدئو آلبوم از حد مجاز بیشتر است",
    InternalNotify_ExceedPermittedDurationOfVideoAlbum: "مدت زمان ویدئو آلبوم از حد مجاز بیشتر است",
    InternalNotify_ExceedPermittedAspectRatioReels: "نسبت ابعاد ریلز از حد مجاز تجاوز کرده است",
    InternalNotify_ExceedPermittedSizeOfVideoReels: "حجم ریلز از حد مجاز بیشتر است",
    InternalNotify_ExceedPermittedDurationOfVideoReels: "مدت زمان ریلز از حد مجاز بیشتر است",
    InternalNotify_NotPermittedMediaType: "نوع رسانه معتبر نیست",
    InternalNotify_InvalidMetaData: "متادیتا معتبر نیست",

    InternalNotify_ExceedSelectedMaxTaggedPeople: "تعداد افراد تگ‌شده از حد مجاز گذشته است",
    InternalNotify_ExceedSelectedMaxHashtags: "تعداد هشتگ‌های انتخابی از حد مجاز بیشتر است",
    InternalNotify_ExistedInCollaborate: "این نام کاربری قبلاً در همکاران وجود دارد و نمی‌تواند در اسلاید اول باشد",
    InternalNotify_ExceedPermittedAspectRatioStory: "نسبت ابعاد استوری از حد مجاز تجاوز کرده است",
    InternalNotify_ExceedPermittedSizeOfVideoStory: "حجم استوری از حد مجاز بیشتر است",
    InternalNotify_ExceedPermittedWidthOfVideo: "عرض ویدئو از حد مجاز بیشتر است",
    InternalNotify_ExceedPermittedDurationOfVideoStory: "مدت زمان استوری از حد مجاز بیشتر است",
    InternalNotify_BelowMinimumDurationOfVideoStory: "مدت زمان ویدیوی استوری باید حداقل ۳ ثانیه باشد",
    InternalNotify_ExceedPermittedSpecificWordForAutoreply: "تعداد کلمات مخصوص برای پاسخ خودکار از حد مجاز گذشته است",
    InternalNotify_ExceedPermittedAspectRatioImage: "نسبت ابعاد تصویر از حد مجاز بیشتر است",
    InternalNotify_Success: "عملیات با موفقیت انجام شد",
    InternalNotify_CreateExportAvailableWith24HourPeriod: "امکان ایجاد خروجی با دوره ۲۴ ساعته فراهم است",
    InternalNotify_SaveIceBreaker: "با موفقیت اضافه شد",
    InternalNotify_deleteIceBreaker: "با موفقیت حذف شد",
    InternalNotify_SavePersistenceMenu: "منوی پایدار با موفقیت اضافه شد",
    InternalNotify_SelectLanguage: "زبان با موفقیت تغییر یافت",
    InternalNotify_SaveFollowTemplate: "قالب فالو با موفقیت ذخیره شد",
    InternalNotify_AutoReplyOn: "پاسخ خودکار با موفقیت فعال شد",
    InternalNotify_AutoReplyOff: "پاسخ خودکار با موفقیت غیرفعال شد",
    InternalNotify_AutoGeneralOn: "پاسخ خودکار عمومی با موفقیت فعال شد",
    InternalNotify_AutoGeneralOff: "پاسخ خودکار عمومی با موفقیت غیرفعال شد",
    InternalNotify_MaxInEachCard: "حداکثر در هر کارت",
    InternalNotify_ExceedStockCard: "تعداد مورد نظر از موجودی کارت بیشتر است",
    InternalNotify_DefaultAddress: "نمی‌توانید آدرس پیش‌فرض را حذف کنید",
    InternalNotify_FetchingYourData: "در حال دریافت اطلاعات شما هستیم، لطفا صبر کنید...",
    InternalNotify_EmptyTitleInQuickReply: "عنوان پاسخ سریع خالی است",
    InternalNotify_EmptyTitleForOutputsInQuickReply: "عنوان خروجی‌ها در پاسخ سریع خالی است",
    InternalNotify_EmptyTitleForFlow: "عنوان جریان خالی است",
    InternalNotify_MultipleFlowForPrivateReply: "نمی‌توانید چندین جریان برای پاسخ خصوصی داشته باشید",
    InternalNotify_NotPermittedForDownload: "اجازه دانلود این محتوا را ندارید",
    InternalNotify_NotFeature: "این قابلیت برای شما فعال نیست",
    InternalNotify_ExceedBasefeatureTime: "مدت زمان استفاده از ویژگی پایه از حد مجاز بیشتر است",
    InternalNotify_ChannelIdNotStartedWithUC: "شناسه کانال باید با 'UC' شروع شود",
    InternalNotify_PageAnalysisNotCompleted: "متأسفانه تحلیل صفحه شما هنوز توسط هوش مصنوعی انجام نشده است",
    JustCreated: "تیکت ثبت شده",
    AdminReplied: "پشتیبانی پاسخ داده",
    UserReplied: "کاربر پاسخ داده",
    AdminClosed: "تیکت توسط پشتیبانی بسته شده",
    UserClosed: "تیکت توسط کاربر بسته شده",
    TimerClosed: "تیکت به‌صورت خودکار بسته شده",
    closethisticket: "بستن این تیکت",
    Create: "ایجاد",
    image: "تصویر",
    video: "ویدیو",
    Images: "تصاویر",
    Videos: "ویدیوها",
    "Generated artwork and visuals": "تصاویر و آثار ساخته‌شده",
    "AI motion and clips": "حرکت‌ها و کلیپ‌های هوش مصنوعی",
    "Media type": "نوع رسانه",
    "Generated AI video preview": "پیش‌نمایش ویدیوی ساخته‌شده با هوش مصنوعی",
    Close: "بستن",
    Prompt: "پرامپت",
    Metadata: "فراداده",
    Creator: "سازنده",
    Version: "نسخه",
    Status: "وضعیت",
    "Image ID": "شناسه تصویر",
    "Video ID": "شناسه ویدیو",
    "Job ID": "شناسه کار",
    "Download image": "دانلود تصویر",
    "Download video": "دانلود ویدیو",
    "Your browser does not support video playback.": "مرورگر شما از پخش ویدیو پشتیبانی نمی‌کند.",
    Uploading: "در حال بارگذاری ",
    "Add video": "افزودن ویدیو",
    "Add audio": "افزودن صوت",
    "Add reference image": "افزودن تصویر مرجع",
    model: "مدل",
    models: "مدل",
    "resize aspect ratio": "افزایش نسبت ابعاد",
    "Video models": "مدل‌های ویدیو",
    "Image models": "مدل‌های تصویر",
    "Cost level {level}": "سطح هزینه {level}",
    "Calculating...": "در حال محاسبه...",
    "Search from People or Keyword": "جستجو بین افراد یا کلمات کلیدی",
    "Create new Flow": "ایجاد جریان جدید",
    "Welcome illustration": "تصویر خوش‌آمدگویی",
    "Untitled generation": "ساخته بدون عنوان",
    "No images yet": "هنوز تصویری وجود ندارد",
    "No videos yet": "هنوز ویدیویی وجود ندارد",
    "Your successful image generations will appear here.": "تصاویر موفق شما اینجا نمایش داده می‌شوند.",
    "Your successful video generations will appear here.": "ویدیوهای موفق شما اینجا نمایش داده می‌شوند.",
    "Create your first image": "اولین تصویر خود را بسازید",
    "Create your first video": "اولین ویدیوی خود را بسازید",
    "Generating image": "در حال ساخت تصویر",
    "Generating video": "در حال ساخت ویدیو",
    "Create video": "ساخت ویدیو",
    "Create image": "ساخت عکس",
    "In progress": "در حال انجام",
    "Just now": "همین حالا",
    "Waiting for the result": "در انتظار نتیجه",
    "Try again": "تلاش دوباره",
    "AI provider": "ارائه‌دهنده هوش مصنوعی",
    "Choose a model": "انتخاب مدل",
    "Describe the subject, setting, light, composition, and style...":
      "موضوع، فضا، نور، ترکیب‌بندی و سبک را توصیف کنید...",
    "Use at least {count} characters.": "حداقل از {count} نویسه استفاده کنید.",
    "Video creator is unavailable": "سازنده ویدیو در دسترس نیست",
    "Image creator is unavailable": "سازنده تصویر در دسترس نیست",
    "No video models found": "مدل ویدیویی پیدا نشد",
    "No image models found": "مدل تصویری پیدا نشد",
    "There are no video generation models available for this account.": "مدل تولید ویدیو برای این حساب در دسترس نیست.",
    "There are no image generation models available for this account.": "مدل تولید تصویر برای این حساب در دسترس نیست.",
    "Not available": "در دسترس نیست",

    // #region wallet fixed

    createdtime: "زمان ایجاد",
    BankCards: "کارت‌های بانکی",
    Transactions: "تراکنش‌ها",
    Settlements: "تسویه‌ها",
    AddNewBankCard: "افزودن کارت بانکی جدید",
    RegisterANewCard: "ثبت کارت جدید",
    CardBankNumber: "شماره کارت بانکی",
    CardNumberExplain: "شماره کارت خود را وارد کنید. کارت بانکی باید به نام شخص ثبت‌نام‌کننده باشد.",
    RegisterBankCard: "ثبت کارت بانکی",
    CardNumber: "شماره کارت",
    DefaultBankCard: "کارت بانکی پیش‌فرض",
    SetAsDefaultBankCard: "تنظیم به‌عنوان کارت بانکی پیش‌فرض",
    Type: "نوع",
    Suspended: "معلق",
    Amount: "مبلغ",
    Time: "زمان",
    Order: "سفارش",
    User: "کاربر",
    NotAvailable: "در دسترس نیست",
    Unsettled: "تسویه‌نشده",
    AwaitingSettled: "در انتظار تسویه",
    Settled: "تسویه‌شده",
    SettlementFailed: "تسویه ناموفق",
    SettleRequest: "درخواست تسویه",
    emptyInvoice: "هنوز هیچ صورتحسابی ثبت نشده است.",
    InvoiceID: "شناسه صورتحساب",
    InvoiceType: "نوع صورتحساب",
    InvoiceHistory: "تاریخچه صورتحساب‌ها",
    OrderDetails: "جزئیات سفارش",
    InvoiceDetails: "جزئیات صورتحساب",
    Paid: "پرداخت‌شده",
    Success: "موفق",
    RefundRequest: "درخواست بازپرداخت",
    Refunding: "در حال بازپرداخت",
    Refunded: "بازپرداخت‌شده",
    RefundFailed: "بازپرداخت ناموفق",
    Failed: "ناموفق",
    Package: "بسته",
    Product: "محصول",
    Feature: "ویژگی",
    Custom: "سفارشی",
    Invoice: "صورتحساب",
    UnknownStatus: "وضعیت نامشخص",
    NoSettlementsRegisteredYet: "هنوز هیچ تسویه‌ای ثبت نشده است.",
    LogesticPayment: "پرداخت لجستیک",
    ProductIncome: "درآمد محصول",
    BrancyFeatureIncome: "درآمد ویژگی برنسی",
    BrancyLogesticPayment: "پرداخت لجستیک برنسی",
    BrancyPackageIncome: "درآمد بسته برنسی",
    BrancyProductIncome: "درآمد محصول برنسی",
    BrancyTransferPayment: "کارمزد انتقال برنسی",
    WalletBalance: "موجودی کیف پول",
    TotalWithdrawn: "مجموع برداشت‌شده",
    FailedTransactions: "تراکنش‌های ناموفق",
    PendingSettlement: "در انتظار تسویه",
    OrderInProgress: "سفارش در حال پردازش",
    OrderPickup: "جمع‌آوری سفارش",
    OrderDelivery: "تحویل سفارش",
    SubInvoiceHistory: "تاریخچه ریزصورتحساب‌ها",
    history: "تاریخچه",
    // #endregion wallet fixed

    // #endregion Notification Section
    how: "چگونه",
    ConnectProduct: "اتصال مستقیم به محصول",
    messagesetting_ConnectProductResponseExplain: "محصول خود را به Story یا Live متصل کنید.",
    economy: "اقتصادی",
    Retry: "تلاش مجدد",
    messagesetting_SpecifyProductResponseExplain: "یک محصول را مشخص کنید تا به‌صورت خودکار برای کاربران ارسال شود",
    messagesetting_ProductResponseExplain: "محصول فعلی را به کاربر متصل کنید",
  },
};
